(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref490"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref490"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cl4iB", function(module, exports) {

var $kFdUg = parcelRequire("kFdUg");
var $8fbac7e4f03b9c4e$require$MAX_SAFE_COMPONENT_LENGTH = $kFdUg.MAX_SAFE_COMPONENT_LENGTH;
var $8fbac7e4f03b9c4e$require$MAX_SAFE_BUILD_LENGTH = $kFdUg.MAX_SAFE_BUILD_LENGTH;
var $8fbac7e4f03b9c4e$require$MAX_LENGTH = $kFdUg.MAX_LENGTH;

var $372xn = parcelRequire("372xn");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $8fbac7e4f03b9c4e$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $8fbac7e4f03b9c4e$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $372xn(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${$8fbac7e4f03b9c4e$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$8fbac7e4f03b9c4e$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$8fbac7e4f03b9c4e$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("kFdUg", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $f0b26c7fd0ae3c80$var$SEMVER_SPEC_VERSION = "2.0.0";
const $f0b26c7fd0ae3c80$var$MAX_LENGTH = 256;
const $f0b26c7fd0ae3c80$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $f0b26c7fd0ae3c80$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $f0b26c7fd0ae3c80$var$MAX_SAFE_BUILD_LENGTH = $f0b26c7fd0ae3c80$var$MAX_LENGTH - 6;
const $f0b26c7fd0ae3c80$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $f0b26c7fd0ae3c80$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $f0b26c7fd0ae3c80$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $f0b26c7fd0ae3c80$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $f0b26c7fd0ae3c80$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $f0b26c7fd0ae3c80$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $f0b26c7fd0ae3c80$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("372xn", function(module, exports) {

var $4Ydn9 = parcelRequire("4Ydn9");
const $2443fe6e229654d4$var$debug = (typeof $4Ydn9 === "object" && $4Ydn9.env && undefined, ()=>{});
module.exports = $2443fe6e229654d4$var$debug;

});
parcelRegister("4Ydn9", function(module, exports) {
// shim for using process in browser
var $39e7237dfe921a60$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $39e7237dfe921a60$var$cachedSetTimeout;
var $39e7237dfe921a60$var$cachedClearTimeout;
function $39e7237dfe921a60$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $39e7237dfe921a60$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $39e7237dfe921a60$var$cachedSetTimeout = setTimeout;
        else $39e7237dfe921a60$var$cachedSetTimeout = $39e7237dfe921a60$var$defaultSetTimout;
    } catch (e) {
        $39e7237dfe921a60$var$cachedSetTimeout = $39e7237dfe921a60$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $39e7237dfe921a60$var$cachedClearTimeout = clearTimeout;
        else $39e7237dfe921a60$var$cachedClearTimeout = $39e7237dfe921a60$var$defaultClearTimeout;
    } catch (e) {
        $39e7237dfe921a60$var$cachedClearTimeout = $39e7237dfe921a60$var$defaultClearTimeout;
    }
})();
function $39e7237dfe921a60$var$runTimeout(fun) {
    if ($39e7237dfe921a60$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($39e7237dfe921a60$var$cachedSetTimeout === $39e7237dfe921a60$var$defaultSetTimout || !$39e7237dfe921a60$var$cachedSetTimeout) && setTimeout) {
        $39e7237dfe921a60$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $39e7237dfe921a60$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $39e7237dfe921a60$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $39e7237dfe921a60$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $39e7237dfe921a60$var$runClearTimeout(marker) {
    if ($39e7237dfe921a60$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($39e7237dfe921a60$var$cachedClearTimeout === $39e7237dfe921a60$var$defaultClearTimeout || !$39e7237dfe921a60$var$cachedClearTimeout) && clearTimeout) {
        $39e7237dfe921a60$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $39e7237dfe921a60$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $39e7237dfe921a60$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $39e7237dfe921a60$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $39e7237dfe921a60$var$queue = [];
var $39e7237dfe921a60$var$draining = false;
var $39e7237dfe921a60$var$currentQueue;
var $39e7237dfe921a60$var$queueIndex = -1;
function $39e7237dfe921a60$var$cleanUpNextTick() {
    if (!$39e7237dfe921a60$var$draining || !$39e7237dfe921a60$var$currentQueue) return;
    $39e7237dfe921a60$var$draining = false;
    if ($39e7237dfe921a60$var$currentQueue.length) $39e7237dfe921a60$var$queue = $39e7237dfe921a60$var$currentQueue.concat($39e7237dfe921a60$var$queue);
    else $39e7237dfe921a60$var$queueIndex = -1;
    if ($39e7237dfe921a60$var$queue.length) $39e7237dfe921a60$var$drainQueue();
}
function $39e7237dfe921a60$var$drainQueue() {
    if ($39e7237dfe921a60$var$draining) return;
    var timeout = $39e7237dfe921a60$var$runTimeout($39e7237dfe921a60$var$cleanUpNextTick);
    $39e7237dfe921a60$var$draining = true;
    var len = $39e7237dfe921a60$var$queue.length;
    while(len){
        $39e7237dfe921a60$var$currentQueue = $39e7237dfe921a60$var$queue;
        $39e7237dfe921a60$var$queue = [];
        while(++$39e7237dfe921a60$var$queueIndex < len)if ($39e7237dfe921a60$var$currentQueue) $39e7237dfe921a60$var$currentQueue[$39e7237dfe921a60$var$queueIndex].run();
        $39e7237dfe921a60$var$queueIndex = -1;
        len = $39e7237dfe921a60$var$queue.length;
    }
    $39e7237dfe921a60$var$currentQueue = null;
    $39e7237dfe921a60$var$draining = false;
    $39e7237dfe921a60$var$runClearTimeout(timeout);
}
$39e7237dfe921a60$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $39e7237dfe921a60$var$queue.push(new $39e7237dfe921a60$var$Item(fun, args));
    if ($39e7237dfe921a60$var$queue.length === 1 && !$39e7237dfe921a60$var$draining) $39e7237dfe921a60$var$runTimeout($39e7237dfe921a60$var$drainQueue);
};
// v8 likes predictible objects
function $39e7237dfe921a60$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$39e7237dfe921a60$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$39e7237dfe921a60$var$process.title = "browser";
$39e7237dfe921a60$var$process.browser = true;
$39e7237dfe921a60$var$process.env = {};
$39e7237dfe921a60$var$process.argv = [];
$39e7237dfe921a60$var$process.version = ""; // empty string to avoid regexp issues
$39e7237dfe921a60$var$process.versions = {};
function $39e7237dfe921a60$var$noop() {}
$39e7237dfe921a60$var$process.on = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.addListener = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.once = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.off = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.removeListener = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.removeAllListeners = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.emit = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.prependListener = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.prependOnceListener = $39e7237dfe921a60$var$noop;
$39e7237dfe921a60$var$process.listeners = function(name) {
    return [];
};
$39e7237dfe921a60$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$39e7237dfe921a60$var$process.cwd = function() {
    return "/";
};
$39e7237dfe921a60$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$39e7237dfe921a60$var$process.umask = function() {
    return 0;
};

});



parcelRegister("dgs9t", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $bsOiL = parcelRequire("bsOiL");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === "number") super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $bsOiL.getWindow)();
    const document = (0, $bsOiL.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(" ");
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(" ");
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $bsOiL.getWindow)();
    const events = args[0].split(" ");
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
    }
    if (callback) dom.on("transitionstart", fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function width() {
    const window = (0, $bsOiL.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $bsOiL.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $bsOiL.getWindow)();
        const document = (0, $bsOiL.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function show() {
    const window = (0, $bsOiL.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function styles() {
    const window = (0, $bsOiL.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $bsOiL.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $bsOiL.getWindow)();
    const document = (0, $bsOiL.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === "undefined") return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $bsOiL.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $bsOiL.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $bsOiL.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $bsOiL.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = "resize scroll".split(" ");
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut("click");
const blur = shortcut("blur");
const focus = shortcut("focus");
const focusin = shortcut("focusin");
const focusout = shortcut("focusout");
const keyup = shortcut("keyup");
const keydown = shortcut("keydown");
const keypress = shortcut("keypress");
const submit = shortcut("submit");
const change = shortcut("change");
const mousedown = shortcut("mousedown");
const mousemove = shortcut("mousemove");
const mouseup = shortcut("mouseup");
const mouseenter = shortcut("mouseenter");
const mouseleave = shortcut("mouseleave");
const mouseout = shortcut("mouseout");
const mouseover = shortcut("mouseover");
const touchstart = shortcut("touchstart");
const touchend = shortcut("touchend");
const touchmove = shortcut("touchmove");
const resize = shortcut("resize");
const scroll = shortcut("scroll");
var $9a829b59c758b65e$export$2e2bcd8739ae039 = $;

});
parcelRegister("bsOiL", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $8589541a787ca437$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $8589541a787ca437$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $8589541a787ca437$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $8589541a787ca437$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($8589541a787ca437$var$isObject(src[key]) && $8589541a787ca437$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $8589541a787ca437$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $8589541a787ca437$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $8589541a787ca437$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $8589541a787ca437$export$8b58be045bf06082(doc, $8589541a787ca437$export$3fdcb9b4d81368d8);
    return doc;
}
const $8589541a787ca437$export$8582633f185c62bb = {
    document: $8589541a787ca437$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $8589541a787ca437$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $8589541a787ca437$export$8b58be045bf06082(win, $8589541a787ca437$export$8582633f185c62bb);
    return win;
}

});


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $1f237190b3823da6$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${$1f237190b3823da6$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener("resize", ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});


var $a5bce33b7b920d36$exports = {};
/** @type {import('tailwindcss').Config} */ $a5bce33b7b920d36$exports = {
    /**
     * FD content
     * **/ // content: ["./src/**/*.{html,js}"],
    /**
     * SD content
     * **/ content: [
        "./app/modules/**/*.php",
        "./app/layout/**/*.php",
        "./app/modules/!panel/**",
        "./app/public/js/*.js",
        "./app/public/js/**/*.js",
        "./src/js/**/*.js",
        "./src/js/*.js"
    ],
    theme: {
        screens: {
            "xs": "360px",
            // => @media (min-width: 360px) { ... }
            "sm": "640px",
            // => @media (min-width: 640px) { ... }
            "md": "768px",
            // => @media (min-width: 768px) { ... }
            "lg": "1024px",
            // => @media (min-width: 1024px) { ... }
            "xl": "1280px",
            // => @media (min-width: 1280px) { ... }
            "2xl": "1536px",
            // => @media (min-width: 1536px) { ... }
            "3xl": "1800px"
        },
        extend: {
            colors: {
                transparent: "transparent",
                current: "currentColor"
            }
        }
    },
    plugins: []
};


function $d913fe852cb14a3a$export$74b8f1741b4483c3(options = {}) {
    const defaultOptions = {
        animateOnce: true,
        speed: 600,
        threshold: 0.5,
        delay: 0,
        easing: "ease",
        disableMutationObserver: false,
        breakpoints: {}
    };
    // Export breakpoints from tailwind
    if (Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($a5bce33b7b920d36$exports))).theme.screens).length) defaultOptions.breakpoints = (0, (/*@__PURE__*/$parcel$interopDefault($a5bce33b7b920d36$exports))).theme.screens;
    /* --- Merge all options --- */ const { breakpoints: breakpoints } = defaultOptions;
    const mergedBreakpoints = Object.assign(breakpoints, options.breakpoints);
    const mainOptions = Object.assign(defaultOptions, options);
    mainOptions.breakpoints = mergedBreakpoints;
    /* --- Set global properties --- */ function setGlobalProperty(name, value, isTimeUnit) {
        if (isTimeUnit) value += "ms";
        document.documentElement.style.setProperty(`--view-${name}`, `${value}`);
    }
    const { speed: speed, easing: easing } = mainOptions;
    setGlobalProperty("speed", speed, true);
    setGlobalProperty("easing", easing);
    // Setup of Intersection Observer
    const intesectionObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            // Show element
            if (entry.isIntersecting) entry.target.classList.add("animated");
            else if (!entry.isIntersecting && !mainOptions.animateOnce) entry.target.classList.remove("animated");
        });
    }, {
        threshold: 0,
        rootMargin: "0% 0% -10% 0%"
    });
    // Change animation of element on breakpoints
    function changeEffectOnResize(element, breakpoint, effect) {
        const initialEffect = element.dataset.view;
        let fixedBreakpoint = typeof breakpoint === "string" ? breakpoint.replace(/\D/g, "") : breakpoint;
        if (window.innerWidth >= fixedBreakpoint) element.dataset.view = effect;
        else element.dataset.view = initialEffect;
    }
    // Main function to observe element
    function intersectElement(element, isMutation = false) {
        element.classList.add("in-view");
        const dataset = element.dataset;
        // Set speed to current element
        if (dataset.viewSpeed) element.style.transitionDuration = `${dataset.viewSpeed}ms`;
        // Set easing to current element
        if (dataset.viewEasing) element.style.transitionTimingFunction = dataset.viewEasing;
        for(const key in dataset){
            const property = key.toLowerCase();
            let dataViewValue = property.match(/view(.*)/)[1].replace(/^-/, "");
            // Check if dataset value equal to breakpoint
            if (dataViewValue && dataViewValue in breakpoints) changeEffectOnResize(element, breakpoints[dataViewValue], dataset[key]);
        }
        if (!isMutation) window.addEventListener("load", ()=>{
            // Observe element with delay
            if (dataset.viewDelay) setTimeout(()=>intesectionObserver.observe(element), dataset.viewDelay);
            else intesectionObserver.observe(element);
        });
        else intesectionObserver.observe(element);
    }
    /* --- Intersect elements on init --- */ const targetElements = document.querySelectorAll("[data-view]");
    if (targetElements.length) targetElements.forEach((target)=>intersectElement(target));
    /* --- Intersect dynamically added elements in DOM --- */ if (!mainOptions.disableMutationObserver) {
        // Callback function to handle the mutations
        const handleMutations = function(mutationsList) {
            for (const mutation of mutationsList)if (mutation.addedNodes.length) {
                // Check if any added node has the desired class
                const addedNodes = mutation.addedNodes;
                addedNodes.forEach((target)=>{
                    if (target.dataset && "view" in target.dataset) intersectElement(target, true);
                });
            }
        };
        // Create a MutationObserver instance
        const mutationObserver = new MutationObserver(handleMutations);
        const mutationObserverOptions = {
            childList: true,
            subtree: true,
            characterData: false
        };
        mutationObserver.observe(document.body, mutationObserverOptions);
    }
}
// Test call
$d913fe852cb14a3a$export$74b8f1741b4483c3();
const $d913fe852cb14a3a$var$startViewAnimationArr = document.querySelectorAll(".start-view-animation");
if ($d913fe852cb14a3a$var$startViewAnimationArr.length) for(let i = 0; i < $d913fe852cb14a3a$var$startViewAnimationArr.length; i++)setTimeout(function() {
    $d913fe852cb14a3a$var$startViewAnimationArr[i].classList.add("animated");
}, 50);


function $54c6583ff500d57c$var$setParallax(element, effectSpeed) {
    element.style.opacity = 1;
    function handleScroll() {
        const defaultSpeed = 0.1;
        const originalSpeed = parseFloat(element.getAttribute("data-parallax-view-speed")) || defaultSpeed;
        const speed = originalSpeed / 10;
        const scroll = window.scrollY + window.innerHeight;
        const elPos = element.getBoundingClientRect().top + window.scrollY;
        let newPos = 0;
        /*let start = true;

    if(element.hasAttribute('data-parallax-view-not-mobile') === true && window.innerWidth <=640) {
      start = false;
    }*/ if (elPos + element.clientHeight >= window.scrollY) {
            if (window.innerHeight >= elPos) {
                newPos = window.scrollY * speed;
                if (element.hasAttribute("data-parallax-view-horizontal") === true) element.style.transform = `translateX(${-newPos}px)`;
                else {
                    element.style.transform = `translateY(${-newPos}px)`;
                    if (element.hasAttribute("data-parallax-view-custom-transformX") === true) {
                        const customTransform = parseFloat(element.getAttribute("data-parallax-view-custom-transformX")) || "-50%";
                        element.style.transform = `translateY(${-newPos}px) translateX(${customTransform})`;
                    }
                }
            } else if (scroll >= elPos) {
                newPos = (elPos - (window.scrollY + window.innerHeight)) * speed;
                if (element.hasAttribute("data-parallax-view-horizontal") === true) element.style.transform = `translateX(${newPos}px)`;
                else {
                    element.style.transform = `translateY(${newPos}px)`;
                    if (element.hasAttribute("data-parallax-view-custom-transformX") === true) {
                        const customTransform = parseFloat(element.getAttribute("data-parallax-view-custom-transformX")) || "-50%";
                        element.style.transform = `translateY(${-newPos}px) translateX(${customTransform})`;
                    }
                }
            }
        }
    }
    window.addEventListener("scroll", handleScroll);
    handleScroll();
}
const $54c6583ff500d57c$var$parallaxElements = document.querySelectorAll("[data-parallax-view]");
$54c6583ff500d57c$var$parallaxElements.forEach((element)=>{
    $54c6583ff500d57c$var$setParallax(element);
});


const $6e0072d6babad5b9$var$headerComponent = document.getElementsByClassName("header")[0];
const $6e0072d6babad5b9$var$mobileOpenFixed = document.querySelector(".profile-mob-open.fixed-btn");
const $6e0072d6babad5b9$var$siteElement = document.querySelector("#site");
if ($6e0072d6babad5b9$var$mobileOpenFixed && $6e0072d6babad5b9$var$siteElement) $6e0072d6babad5b9$var$mobileOpenFixed.addEventListener("click", (e)=>{
    e.preventDefault();
    $6e0072d6babad5b9$var$siteElement.style.overflow = "visible";
    setTimeout(()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setTimeout(()=>{
            $6e0072d6babad5b9$var$siteElement.style.overflow = "hidden";
        }, 300);
    }, 300);
});
const $6e0072d6babad5b9$var$scrollContainer = ()=>document.documentElement || document.body;
document.addEventListener("scroll", ()=>{
    if ($6e0072d6babad5b9$var$scrollContainer().scrollTop > 50) {
        $6e0072d6babad5b9$var$headerComponent.classList.add("scrolled");
        if ($6e0072d6babad5b9$var$mobileOpenFixed) $6e0072d6babad5b9$var$mobileOpenFixed.classList.add("scrolled");
    } else if ($6e0072d6babad5b9$var$scrollContainer().scrollTop == 0) {
        $6e0072d6babad5b9$var$headerComponent.classList.remove("scrolled");
        if ($6e0072d6babad5b9$var$mobileOpenFixed) $6e0072d6babad5b9$var$mobileOpenFixed.classList.remove("scrolled");
    }
});
const $6e0072d6babad5b9$var$mobileMenuStartPoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--mobile-menu-start-point"));
let $6e0072d6babad5b9$var$isMobileMenuEnable = window.outerWidth <= $6e0072d6babad5b9$var$mobileMenuStartPoint || document.querySelector(".header-mobile");
if (document.querySelector(".menu-dropdown")) {
    const menuDropdownsArr = document.querySelectorAll(".menu-dropdown");
    menuDropdownsArr.forEach((menuDropdown)=>{
        const dropdownList = menuDropdown.querySelector(".menu-dropdown__list");
        menuDropdown.addEventListener("click", (e)=>{
            if (window.innerWidth <= 1280) {
                if (!menuDropdown.classList.contains("is-active")) {
                    e.preventDefault();
                    menuDropdown.classList.add("is-active");
                    dropdownList.classList.add("is-active");
                } else {
                    menuDropdown.classList.remove("is-active");
                    dropdownList.classList.remove("is-active");
                }
            }
        });
    });
}
function $6e0072d6babad5b9$var$menuToggleFunc() {
    const menuToggle = document.querySelector(".menu-toggle");
    const navbarNav = document.querySelector(".navbar-nav");
    const headerCloseWrapper = document.querySelector(".header-close-wrapper");
    menuToggle.classList.toggle("active");
    navbarNav.classList.toggle("active");
    $6e0072d6babad5b9$var$headerComponent.classList.toggle("open-menu");
    headerCloseWrapper.classList.toggle("active");
    $6e0072d6babad5b9$var$mobileOpenFixed.classList.toggle("open-menu");
    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
        scrollLock.disablePageScroll(document.querySelector(".navbar-nav .menu"));
        scrollLock.addScrollableSelector(".simplebar-content-wrapper");
    } else scrollLock.enablePageScroll();
}
function $6e0072d6babad5b9$var$updateMenu() {
    $6e0072d6babad5b9$var$isMobileMenuEnable = window.outerWidth <= $6e0072d6babad5b9$var$mobileMenuStartPoint || document.querySelector(".mobile-header");
    if (!$6e0072d6babad5b9$var$isMobileMenuEnable) {
        const dropdownMenus = document.querySelectorAll(".dropdown-menu");
        dropdownMenus.forEach((menu)=>{
            menu.style.display = "";
        });
        const headerCloseWrapper = document.querySelector(".header-close-wrapper");
        headerCloseWrapper.classList.remove("active");
        const activeMenuItems = document.querySelectorAll(".menu-item.active");
        activeMenuItems.forEach((item)=>{
            item.classList.remove("active");
        });
        const navbarNav = document.querySelector(".navbar-nav");
        navbarNav.classList.remove("active");
        $6e0072d6babad5b9$var$headerComponent.classList.remove("open-menu");
        $6e0072d6babad5b9$var$mobileOpenFixed.classList.remove("open-menu");
        const menuToggle = document.querySelector(".menu-toggle");
        menuToggle.classList.remove("active");
        scrollLock.enablePageScroll();
    }
}
window.addEventListener("resize", $6e0072d6babad5b9$var$updateMenu);
window.addEventListener("orientationchange", $6e0072d6babad5b9$var$updateMenu);
const $6e0072d6babad5b9$var$menuToggle = document.querySelector(".menu-toggle");
const $6e0072d6babad5b9$var$headerCloseWrapper = document.querySelector(".header-close-wrapper");
$6e0072d6babad5b9$var$menuToggle.addEventListener("click", $6e0072d6babad5b9$var$menuToggleFunc);
$6e0072d6babad5b9$var$headerCloseWrapper.addEventListener("click", $6e0072d6babad5b9$var$menuToggleFunc);
function $6e0072d6babad5b9$var$headerSticky() {
    let prevScrollPos = window.pageYOffset;
    window.onscroll = ()=>{
        const currentScrollPos = window.pageYOffset;
        const headerHeight = $6e0072d6babad5b9$var$headerComponent.scrollHeight;
        const mobileOpenFixedNew = document.querySelector(".profile-mob-open.fixed-btn");
        function checkScrollPosition() {
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const triggerPoint = documentHeight - 300;
            if (mobileOpenFixedNew) {
                if (scrollPosition >= triggerPoint) {
                    $6e0072d6babad5b9$var$mobileOpenFixed.style.transform = "translateX(-150%)";
                    $6e0072d6babad5b9$var$mobileOpenFixed.style.pointerEvents = "none";
                    $6e0072d6babad5b9$var$mobileOpenFixed.style.transition = "transform 0.1s";
                } else {
                    $6e0072d6babad5b9$var$mobileOpenFixed.style.transform = "translateX(0)";
                    $6e0072d6babad5b9$var$mobileOpenFixed.style.pointerEvents = "auto";
                    $6e0072d6babad5b9$var$mobileOpenFixed.style.transition = "transform 0.1s";
                }
            }
        }
        window.addEventListener("scroll", checkScrollPosition);
        checkScrollPosition();
        if (window.scrollY > 0) {
            if (prevScrollPos > currentScrollPos) {
                $6e0072d6babad5b9$var$headerComponent.style.top = 0;
                $6e0072d6babad5b9$var$headerComponent.classList.add("scrolled");
                if (mobileOpenFixedNew) {
                    mobileOpenFixedNew.classList.add("scrolled");
                    mobileOpenFixedNew.style.transform = `translateY(-16px)`;
                    mobileOpenFixedNew.style.top = `110px`;
                }
            } else {
                $6e0072d6babad5b9$var$headerComponent.style.top = `-${headerHeight + 3}px`;
                if (mobileOpenFixedNew) {
                    mobileOpenFixedNew.style.transform = `translateY(-${headerHeight + 16}px)`;
                    mobileOpenFixedNew.style.top = `30px`;
                }
            }
        }
        if (window.scrollY === 0) {
            $6e0072d6babad5b9$var$headerComponent.classList.remove("scrolled");
            if (mobileOpenFixedNew) {
                mobileOpenFixedNew.classList.remove("scrolled");
                mobileOpenFixedNew.style.transform = `translateY(0)`;
            }
        }
        prevScrollPos = currentScrollPos;
    };
    if (window.scrollY !== 0) {
        $6e0072d6babad5b9$var$headerComponent.classList.add("scrolled");
        if ($6e0072d6babad5b9$var$mobileOpenFixed) {
            $6e0072d6babad5b9$var$mobileOpenFixed.classList.add("scrolled");
            $6e0072d6babad5b9$var$mobileOpenFixed.style.transform = `translateY(0)`;
        }
    }
}
$6e0072d6babad5b9$var$headerSticky();


window.uploadFile = function uploadFile1() {
    if (document.querySelector("[data-upload-file-animation]")) {
        const uploadFileBlocksArr = document.querySelectorAll("[data-upload-file-animation]");
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener("dragover", function() {
                this.classList.add("drag");
                this.classList.remove("drop", "done");
            });
            fileUpload.addEventListener("dragleave", function() {
                this.classList.remove("drag");
            });
            fileUpload.addEventListener("drop", start, false);
            fileUpload.addEventListener("change", start, false);
            function start() {
                this.classList.remove("drag");
                this.classList.add("drop");
                setTimeout(()=>this.classList.add("done"), 500);
            }
        });
    }
};
uploadFile();


const $7ecb4f28e7c99467$var$authTabs = document.querySelectorAll(".authorization-tab"), $7ecb4f28e7c99467$var$authForms = document.querySelectorAll(".authorization-form"), $7ecb4f28e7c99467$var$authTitles = document.querySelectorAll(".authorization-title .authorization-section__title");
if ($7ecb4f28e7c99467$var$authTabs && $7ecb4f28e7c99467$var$authForms) {
    const urlParams = new URLSearchParams(window.location.search);
    const activeTab = urlParams.get("tab") || urlParams.get("form");
    let activeIndex = activeTab === "Employers" ? 1 : 0;
    $7ecb4f28e7c99467$var$authTabs.forEach((tab, index)=>{
        if (index === activeIndex) {
            tab.classList.add("active");
            $7ecb4f28e7c99467$var$authForms[index]?.classList.add("active");
            $7ecb4f28e7c99467$var$authTitles[index]?.classList.add("active");
        } else {
            tab.classList.remove("active");
            $7ecb4f28e7c99467$var$authForms[index]?.classList.remove("active");
            $7ecb4f28e7c99467$var$authTitles[index]?.classList.remove("active");
        }
    });
    $7ecb4f28e7c99467$var$authTabs?.forEach((item, i)=>{
        item?.addEventListener("click", ()=>{
            if (item?.classList.contains("active")) return;
            $7ecb4f28e7c99467$var$authTabs?.forEach((t)=>t.classList.remove("active"));
            $7ecb4f28e7c99467$var$authForms?.forEach((t)=>t.classList.remove("active"));
            $7ecb4f28e7c99467$var$authTitles?.forEach((t)=>t.classList.remove("active"));
            item?.classList.add("active");
            $7ecb4f28e7c99467$var$authForms[i]?.classList.add("active");
            $7ecb4f28e7c99467$var$authTitles[i]?.classList.add("active");
        });
    });
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $e78b9365f8180c81$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $686aaf81b7eb0e4c$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f35f5fbe1f7e7aee$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $36e1ff64f9481fdf$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(element) || !(0, $e78b9365f8180c81$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $36e1ff64f9481fdf$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(element) || !(0, $e78b9365f8180c81$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $36e1ff64f9481fdf$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $36e1ff64f9481fdf$var$applyStyles,
    effect: $36e1ff64f9481fdf$var$effect,
    requires: [
        "computeStyles"
    ]
};


var $12ba806f13054259$export$8960430cfd85939f = Math.max;
var $12ba806f13054259$export$96ec731ed4dcb222 = Math.min;
var $12ba806f13054259$export$2077e0241d6afd3c = Math.round;



function $d7ed558936499be6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $192e525fa84ae3f4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $d7ed558936499be6$export$2e2bcd8739ae039)());
}


function $14b0cdf0b5bbedbb$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $12ba806f13054259$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $12ba806f13054259$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(element) ? (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $192e525fa84ae3f4$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $a18633a9316c5732$export$2e2bcd8739ae039(node) {
    var win = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $aebc473140c25abf$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $34847452422529b2$export$2e2bcd8739ae039(node) {
    if (node === (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(node) || !(0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(node)) return (0, $a18633a9316c5732$export$2e2bcd8739ae039)(node);
    else return (0, $aebc473140c25abf$export$2e2bcd8739ae039)(node);
}






function $b1ff58ed930018de$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $d34576f66d694eb5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $14b0cdf0b5bbedbb$export$2e2bcd8739ae039)((0, $b1ff58ed930018de$export$2e2bcd8739ae039)(element)).left + (0, $a18633a9316c5732$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $fc7fef63f95a2668$export$2e2bcd8739ae039(element) {
    return (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $a5d03d6ae8aeb3c6$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $a32d1f6c23a390cc$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $12ba806f13054259$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $12ba806f13054259$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a32d1f6c23a390cc$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(offsetParent) && $a32d1f6c23a390cc$var$isElementScaled(offsetParent);
    var documentElement = (0, $b1ff58ed930018de$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $14b0cdf0b5bbedbb$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e78b9365f8180c81$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a5d03d6ae8aeb3c6$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $34847452422529b2$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $14b0cdf0b5bbedbb$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d34576f66d694eb5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $69d36864ce9522ab$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $14b0cdf0b5bbedbb$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $410fdc12c0f6172b$export$2e2bcd8739ae039(element) {
    if ((0, $e78b9365f8180c81$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f35f5fbe1f7e7aee$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $b1ff58ed930018de$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $8263e1ecc43b5e6e$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $e78b9365f8180c81$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(node) && (0, $a5d03d6ae8aeb3c6$export$2e2bcd8739ae039)(node)) return node;
    return $8263e1ecc43b5e6e$export$2e2bcd8739ae039((0, $410fdc12c0f6172b$export$2e2bcd8739ae039)(node));
}





function $005fe9601b2fb29e$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $8263e1ecc43b5e6e$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a5d03d6ae8aeb3c6$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($005fe9601b2fb29e$export$2e2bcd8739ae039((0, $410fdc12c0f6172b$export$2e2bcd8739ae039)(target)));
}







function $5697376aaa9feb96$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $e78b9365f8180c81$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3112ae3fb61a4be1$var$getTrueOffsetParent(element) {
    if (!(0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3112ae3fb61a4be1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $d7ed558936499be6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $d7ed558936499be6$export$2e2bcd8739ae039)());
    if (isIE && (0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $410fdc12c0f6172b$export$2e2bcd8739ae039)(element);
    if ((0, $f35f5fbe1f7e7aee$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $e78b9365f8180c81$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3112ae3fb61a4be1$export$2e2bcd8739ae039(element) {
    var window = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(element);
    var offsetParent = $3112ae3fb61a4be1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $5697376aaa9feb96$export$2e2bcd8739ae039)(offsetParent) && (0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3112ae3fb61a4be1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $e78b9365f8180c81$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $e78b9365f8180c81$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3112ae3fb61a4be1$var$getContainingBlock(element) || window;
}


var $de1614addf479461$export$1e95b668f3b82d = "top";
var $de1614addf479461$export$40e543e69a8b3fbb = "bottom";
var $de1614addf479461$export$79ffe56a765070d2 = "right";
var $de1614addf479461$export$eabcd2c8791e7bf4 = "left";
var $de1614addf479461$export$dfb5619354ba860 = "auto";
var $de1614addf479461$export$aec2ce47c367b8c3 = [
    $de1614addf479461$export$1e95b668f3b82d,
    $de1614addf479461$export$40e543e69a8b3fbb,
    $de1614addf479461$export$79ffe56a765070d2,
    $de1614addf479461$export$eabcd2c8791e7bf4
];
var $de1614addf479461$export$b3571188c770cc5a = "start";
var $de1614addf479461$export$bd5df0f255a350f8 = "end";
var $de1614addf479461$export$390fd549c5303b4d = "clippingParents";
var $de1614addf479461$export$d7b7311ec04a3e8f = "viewport";
var $de1614addf479461$export$ae5ab1c730825774 = "popper";
var $de1614addf479461$export$ca50aac9f3ba507f = "reference";
var $de1614addf479461$export$368f9a87e87fa4e1 = /*#__PURE__*/ $de1614addf479461$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $de1614addf479461$export$b3571188c770cc5a,
        placement + "-" + $de1614addf479461$export$bd5df0f255a350f8
    ]);
}, []);
var $de1614addf479461$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($de1614addf479461$export$aec2ce47c367b8c3, [
    $de1614addf479461$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $de1614addf479461$export$b3571188c770cc5a,
        placement + "-" + $de1614addf479461$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $de1614addf479461$export$421679a7c3d56e = "beforeRead";
var $de1614addf479461$export$aafa59e2e03f2942 = "read";
var $de1614addf479461$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $de1614addf479461$export$c65e99957a05207c = "beforeMain";
var $de1614addf479461$export$f22da7240b7add18 = "main";
var $de1614addf479461$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $de1614addf479461$export$8d4d2d70e7d46032 = "beforeWrite";
var $de1614addf479461$export$68d8715fc104d294 = "write";
var $de1614addf479461$export$70a6e5159acce2e6 = "afterWrite";
var $de1614addf479461$export$d087d3878fdf71d5 = [
    $de1614addf479461$export$421679a7c3d56e,
    $de1614addf479461$export$aafa59e2e03f2942,
    $de1614addf479461$export$6964f6c886723980,
    $de1614addf479461$export$c65e99957a05207c,
    $de1614addf479461$export$f22da7240b7add18,
    $de1614addf479461$export$bab79516f2d662fe,
    $de1614addf479461$export$8d4d2d70e7d46032,
    $de1614addf479461$export$68d8715fc104d294,
    $de1614addf479461$export$70a6e5159acce2e6
];


function $f44dad41759cd1ba$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $f44dad41759cd1ba$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $f44dad41759cd1ba$var$order(modifiers); // order based on phase
    return (0, $de1614addf479461$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $069f94add8c1e22b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $a3c108cebb3f4285$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $a4e99e3bc9b29c64$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $a4e99e3bc9b29c64$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $a4e99e3bc9b29c64$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $a4e99e3bc9b29c64$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $a4e99e3bc9b29c64$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(reference) ? (0, $005fe9601b2fb29e$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $005fe9601b2fb29e$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $005fe9601b2fb29e$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f44dad41759cd1ba$export$2e2bcd8739ae039)((0, $a3c108cebb3f4285$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$a4e99e3bc9b29c64$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $a32d1f6c23a390cc$export$2e2bcd8739ae039)(reference, (0, $3112ae3fb61a4be1$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $69d36864ce9522ab$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $069f94add8c1e22b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$a4e99e3bc9b29c64$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $a4e99e3bc9b29c64$export$8f7491d57c8f97a9 = /*#__PURE__*/ $a4e99e3bc9b29c64$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $145633a1f57fea74$var$passive = {
    passive: true
};
function $145633a1f57fea74$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $145633a1f57fea74$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $145633a1f57fea74$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $145633a1f57fea74$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $145633a1f57fea74$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $145633a1f57fea74$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $145633a1f57fea74$var$effect,
    data: {}
};



function $d16c0edc741610be$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $1bf6b9a2945e0f67$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $396a33655af60525$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $d009aff2efe01ec4$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $d16c0edc741610be$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $1bf6b9a2945e0f67$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $de1614addf479461$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $de1614addf479461$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $de1614addf479461$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $de1614addf479461$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $396a33655af60525$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $de1614addf479461$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $de1614addf479461$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $a378c035248bfd47$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $d009aff2efe01ec4$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a378c035248bfd47$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $a378c035248bfd47$var$popperOffsets,
    data: {}
};










var $d2de39023abb37a7$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d2de39023abb37a7$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $12ba806f13054259$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $12ba806f13054259$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $d2de39023abb37a7$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $de1614addf479461$export$eabcd2c8791e7bf4);
    var sideY = (0, $de1614addf479461$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3112ae3fb61a4be1$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $b1ff58ed930018de$export$2e2bcd8739ae039)(popper);
            if ((0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $de1614addf479461$export$1e95b668f3b82d) || (placement === (0, $de1614addf479461$export$eabcd2c8791e7bf4) || placement === (0, $de1614addf479461$export$79ffe56a765070d2)) && variation === (0, $de1614addf479461$export$bd5df0f255a350f8)) {
            sideY = (0, $de1614addf479461$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $de1614addf479461$export$eabcd2c8791e7bf4) || (placement === (0, $de1614addf479461$export$1e95b668f3b82d) || placement === (0, $de1614addf479461$export$40e543e69a8b3fbb)) && variation === (0, $de1614addf479461$export$bd5df0f255a350f8)) {
            sideX = (0, $de1614addf479461$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d2de39023abb37a7$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d2de39023abb37a7$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $d2de39023abb37a7$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $d16c0edc741610be$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $1bf6b9a2945e0f67$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d2de39023abb37a7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d2de39023abb37a7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d2de39023abb37a7$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $d2de39023abb37a7$var$computeStyles,
    data: {}
};





function $bb3afe476f399af7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $d16c0edc741610be$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $de1614addf479461$export$eabcd2c8791e7bf4),
        (0, $de1614addf479461$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $de1614addf479461$export$eabcd2c8791e7bf4),
        (0, $de1614addf479461$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $bb3afe476f399af7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $de1614addf479461$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $bb3afe476f399af7$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bb3afe476f399af7$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $bb3afe476f399af7$var$offset
};


var $5f275cfdcd57aa98$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $5f275cfdcd57aa98$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $5f275cfdcd57aa98$var$hash[matched];
    });
}



var $2adf952a05706328$var$hash = {
    start: "end",
    end: "start"
};
function $2adf952a05706328$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2adf952a05706328$var$hash[matched];
    });
}







function $31003957c3d70b2f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $686aaf81b7eb0e4c$export$2e2bcd8739ae039)(element);
    var html = (0, $b1ff58ed930018de$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $192e525fa84ae3f4$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d34576f66d694eb5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $9cd655b6d54324d7$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $b1ff58ed930018de$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $a18633a9316c5732$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $12ba806f13054259$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $12ba806f13054259$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d34576f66d694eb5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $12ba806f13054259$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $68ef8ca8b3f9f3f4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f35f5fbe1f7e7aee$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $8594cdbafa786eca$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $05367559f063e01d$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $14b0cdf0b5bbedbb$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $05367559f063e01d$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $de1614addf479461$export$d7b7311ec04a3e8f) ? (0, $8594cdbafa786eca$export$2e2bcd8739ae039)((0, $31003957c3d70b2f$export$2e2bcd8739ae039)(element, strategy)) : (0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(clippingParent) ? $05367559f063e01d$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $8594cdbafa786eca$export$2e2bcd8739ae039)((0, $9cd655b6d54324d7$export$2e2bcd8739ae039)((0, $b1ff58ed930018de$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $05367559f063e01d$var$getClippingParents(element) {
    var clippingParents = (0, $005fe9601b2fb29e$export$2e2bcd8739ae039)((0, $410fdc12c0f6172b$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $fc7fef63f95a2668$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f35f5fbe1f7e7aee$export$1b3bfaa9684536aa)(element) ? (0, $3112ae3fb61a4be1$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(clippingParent) && (0, $68ef8ca8b3f9f3f4$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $e78b9365f8180c81$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $05367559f063e01d$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $05367559f063e01d$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $05367559f063e01d$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $12ba806f13054259$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $12ba806f13054259$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $12ba806f13054259$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $12ba806f13054259$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $05367559f063e01d$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $fdc0ab85db162438$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $c9cd182c3945ef55$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $fdc0ab85db162438$export$2e2bcd8739ae039)(), paddingObject);
}


function $958f1cbccc401797$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $b579fbb15e9f73d5$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $de1614addf479461$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $de1614addf479461$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $de1614addf479461$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $c9cd182c3945ef55$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $958f1cbccc401797$export$2e2bcd8739ae039)(padding, (0, $de1614addf479461$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $de1614addf479461$export$ae5ab1c730825774) ? (0, $de1614addf479461$export$ca50aac9f3ba507f) : (0, $de1614addf479461$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $05367559f063e01d$export$2e2bcd8739ae039)((0, $f35f5fbe1f7e7aee$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $b1ff58ed930018de$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $14b0cdf0b5bbedbb$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $d009aff2efe01ec4$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $8594cdbafa786eca$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $de1614addf479461$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $de1614addf479461$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $de1614addf479461$export$79ffe56a765070d2),
                (0, $de1614addf479461$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $de1614addf479461$export$1e95b668f3b82d),
                (0, $de1614addf479461$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $650ab7b6172242d0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $de1614addf479461$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $1bf6b9a2945e0f67$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $de1614addf479461$export$368f9a87e87fa4e1) : (0, $de1614addf479461$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $1bf6b9a2945e0f67$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $de1614addf479461$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $b579fbb15e9f73d5$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $d16c0edc741610be$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $4a08d4970d5f86e8$var$getExpandedFallbackPlacements(placement) {
    if ((0, $d16c0edc741610be$export$2e2bcd8739ae039)(placement) === (0, $de1614addf479461$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $5f275cfdcd57aa98$export$2e2bcd8739ae039)(placement);
    return [
        (0, $2adf952a05706328$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $2adf952a05706328$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $4a08d4970d5f86e8$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $d16c0edc741610be$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $5f275cfdcd57aa98$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $4a08d4970d5f86e8$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $d16c0edc741610be$export$2e2bcd8739ae039)(placement) === (0, $de1614addf479461$export$dfb5619354ba860) ? (0, $650ab7b6172242d0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $d16c0edc741610be$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $1bf6b9a2945e0f67$export$2e2bcd8739ae039)(placement) === (0, $de1614addf479461$export$b3571188c770cc5a);
        var isVertical = [
            (0, $de1614addf479461$export$1e95b668f3b82d),
            (0, $de1614addf479461$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $b579fbb15e9f73d5$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $de1614addf479461$export$79ffe56a765070d2) : (0, $de1614addf479461$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $de1614addf479461$export$40e543e69a8b3fbb) : (0, $de1614addf479461$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $5f275cfdcd57aa98$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $5f275cfdcd57aa98$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4a08d4970d5f86e8$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $4a08d4970d5f86e8$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $858d6032587e2607$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $42d70a0e6a975299$export$f28d906d67a997f3(min, value, max) {
    return (0, $12ba806f13054259$export$8960430cfd85939f)(min, (0, $12ba806f13054259$export$96ec731ed4dcb222)(value, max));
}
function $42d70a0e6a975299$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $42d70a0e6a975299$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $95d1719feaa084e8$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $b579fbb15e9f73d5$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $d16c0edc741610be$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $1bf6b9a2945e0f67$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $396a33655af60525$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $858d6032587e2607$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $de1614addf479461$export$1e95b668f3b82d) : (0, $de1614addf479461$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $de1614addf479461$export$40e543e69a8b3fbb) : (0, $de1614addf479461$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $de1614addf479461$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $de1614addf479461$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $69d36864ce9522ab$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $fdc0ab85db162438$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $42d70a0e6a975299$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3112ae3fb61a4be1$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $42d70a0e6a975299$export$f28d906d67a997f3)(tether ? (0, $12ba806f13054259$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $12ba806f13054259$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $de1614addf479461$export$1e95b668f3b82d) : (0, $de1614addf479461$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $de1614addf479461$export$40e543e69a8b3fbb) : (0, $de1614addf479461$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $de1614addf479461$export$1e95b668f3b82d),
            (0, $de1614addf479461$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $42d70a0e6a975299$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $42d70a0e6a975299$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $95d1719feaa084e8$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $95d1719feaa084e8$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $9585b7c8a5696302$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $c9cd182c3945ef55$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $958f1cbccc401797$export$2e2bcd8739ae039)(padding, (0, $de1614addf479461$export$aec2ce47c367b8c3)));
};
function $9585b7c8a5696302$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $d16c0edc741610be$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $396a33655af60525$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $de1614addf479461$export$eabcd2c8791e7bf4),
        (0, $de1614addf479461$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $9585b7c8a5696302$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $69d36864ce9522ab$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $de1614addf479461$export$1e95b668f3b82d) : (0, $de1614addf479461$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $de1614addf479461$export$40e543e69a8b3fbb) : (0, $de1614addf479461$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3112ae3fb61a4be1$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $42d70a0e6a975299$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $9585b7c8a5696302$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $68ef8ca8b3f9f3f4$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $9585b7c8a5696302$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $9585b7c8a5696302$var$arrow,
    effect: $9585b7c8a5696302$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $55401eabebe6f2eb$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $55401eabebe6f2eb$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $de1614addf479461$export$1e95b668f3b82d),
        (0, $de1614addf479461$export$79ffe56a765070d2),
        (0, $de1614addf479461$export$40e543e69a8b3fbb),
        (0, $de1614addf479461$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $55401eabebe6f2eb$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $b579fbb15e9f73d5$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $b579fbb15e9f73d5$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $55401eabebe6f2eb$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $55401eabebe6f2eb$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $55401eabebe6f2eb$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $55401eabebe6f2eb$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $55401eabebe6f2eb$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $55401eabebe6f2eb$var$hide
};




var $233a215823b1eb37$export$d34966752335dd47 = [
    (0, $145633a1f57fea74$export$2e2bcd8739ae039),
    (0, $a378c035248bfd47$export$2e2bcd8739ae039),
    (0, $d2de39023abb37a7$export$2e2bcd8739ae039),
    (0, $36e1ff64f9481fdf$export$2e2bcd8739ae039),
    (0, $bb3afe476f399af7$export$2e2bcd8739ae039),
    (0, $4a08d4970d5f86e8$export$2e2bcd8739ae039),
    (0, $95d1719feaa084e8$export$2e2bcd8739ae039),
    (0, $9585b7c8a5696302$export$2e2bcd8739ae039),
    (0, $55401eabebe6f2eb$export$2e2bcd8739ae039)
];
var $233a215823b1eb37$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $a4e99e3bc9b29c64$export$ed5e13716264f202)({
    defaultModifiers: $233a215823b1eb37$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $cbcb5262e5944fcb$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $cbcb5262e5944fcb$var$BOX_CLASS = "tippy-box";
var $cbcb5262e5944fcb$var$CONTENT_CLASS = "tippy-content";
var $cbcb5262e5944fcb$var$BACKDROP_CLASS = "tippy-backdrop";
var $cbcb5262e5944fcb$var$ARROW_CLASS = "tippy-arrow";
var $cbcb5262e5944fcb$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $cbcb5262e5944fcb$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $cbcb5262e5944fcb$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $cbcb5262e5944fcb$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $cbcb5262e5944fcb$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $cbcb5262e5944fcb$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $cbcb5262e5944fcb$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $cbcb5262e5944fcb$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $cbcb5262e5944fcb$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $cbcb5262e5944fcb$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $cbcb5262e5944fcb$var$normalizeToArray(value) {
    return [].concat(value);
}
function $cbcb5262e5944fcb$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $cbcb5262e5944fcb$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $cbcb5262e5944fcb$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $cbcb5262e5944fcb$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $cbcb5262e5944fcb$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $cbcb5262e5944fcb$var$div() {
    return document.createElement("div");
}
function $cbcb5262e5944fcb$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $cbcb5262e5944fcb$var$isType(value, type);
    });
}
function $cbcb5262e5944fcb$var$isNodeList(value) {
    return $cbcb5262e5944fcb$var$isType(value, "NodeList");
}
function $cbcb5262e5944fcb$var$isMouseEvent(value) {
    return $cbcb5262e5944fcb$var$isType(value, "MouseEvent");
}
function $cbcb5262e5944fcb$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $cbcb5262e5944fcb$var$getArrayOfElements(value) {
    if ($cbcb5262e5944fcb$var$isElement(value)) return [
        value
    ];
    if ($cbcb5262e5944fcb$var$isNodeList(value)) return $cbcb5262e5944fcb$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $cbcb5262e5944fcb$var$arrayFrom(document.querySelectorAll(value));
}
function $cbcb5262e5944fcb$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $cbcb5262e5944fcb$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $cbcb5262e5944fcb$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $cbcb5262e5944fcb$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $cbcb5262e5944fcb$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $cbcb5262e5944fcb$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $cbcb5262e5944fcb$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $cbcb5262e5944fcb$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $cbcb5262e5944fcb$var$currentInput = {
    isTouch: false
};
var $cbcb5262e5944fcb$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $cbcb5262e5944fcb$var$onDocumentTouchStart() {
    if ($cbcb5262e5944fcb$var$currentInput.isTouch) return;
    $cbcb5262e5944fcb$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $cbcb5262e5944fcb$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $cbcb5262e5944fcb$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $cbcb5262e5944fcb$var$lastMouseMoveTime < 20) {
        $cbcb5262e5944fcb$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $cbcb5262e5944fcb$var$onDocumentMouseMove);
    }
    $cbcb5262e5944fcb$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $cbcb5262e5944fcb$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($cbcb5262e5944fcb$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $cbcb5262e5944fcb$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $cbcb5262e5944fcb$var$onDocumentTouchStart, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $cbcb5262e5944fcb$var$onWindowBlur);
}
var $cbcb5262e5944fcb$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $cbcb5262e5944fcb$var$isIE11 = $cbcb5262e5944fcb$var$isBrowser ? !!window.msCrypto : false;
function $cbcb5262e5944fcb$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $cbcb5262e5944fcb$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $cbcb5262e5944fcb$var$getDevMessage(message) {
    return $cbcb5262e5944fcb$var$clean("\n  %ctippy.js\n\n  %c" + $cbcb5262e5944fcb$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $cbcb5262e5944fcb$var$getFormattedMessage(message) {
    return [
        $cbcb5262e5944fcb$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $cbcb5262e5944fcb$var$visitedMessages;
function $cbcb5262e5944fcb$var$resetVisitedMessages() {
    $cbcb5262e5944fcb$var$visitedMessages = new Set();
}
function $cbcb5262e5944fcb$var$warnWhen(condition, message) {
    if (condition && !$cbcb5262e5944fcb$var$visitedMessages.has(message)) {
        var _console;
        $cbcb5262e5944fcb$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $cbcb5262e5944fcb$var$getFormattedMessage(message));
    }
}
function $cbcb5262e5944fcb$var$errorWhen(condition, message) {
    if (condition && !$cbcb5262e5944fcb$var$visitedMessages.has(message)) {
        var _console2;
        $cbcb5262e5944fcb$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $cbcb5262e5944fcb$var$getFormattedMessage(message));
    }
}
function $cbcb5262e5944fcb$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $cbcb5262e5944fcb$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $cbcb5262e5944fcb$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $cbcb5262e5944fcb$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $cbcb5262e5944fcb$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $cbcb5262e5944fcb$var$defaultProps = Object.assign({
    appendTo: $cbcb5262e5944fcb$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $cbcb5262e5944fcb$var$pluginProps, $cbcb5262e5944fcb$var$renderProps);
var $cbcb5262e5944fcb$var$defaultKeys = Object.keys($cbcb5262e5944fcb$var$defaultProps);
var $cbcb5262e5944fcb$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $cbcb5262e5944fcb$var$defaultProps[key] = partialProps[key];
    });
};
function $cbcb5262e5944fcb$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $cbcb5262e5944fcb$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $cbcb5262e5944fcb$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($cbcb5262e5944fcb$var$getExtendedPassedProps(Object.assign({}, $cbcb5262e5944fcb$var$defaultProps, {
        plugins: plugins
    }))) : $cbcb5262e5944fcb$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $cbcb5262e5944fcb$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $cbcb5262e5944fcb$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $cbcb5262e5944fcb$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $cbcb5262e5944fcb$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $cbcb5262e5944fcb$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $cbcb5262e5944fcb$var$removeProperties($cbcb5262e5944fcb$var$defaultProps, Object.keys($cbcb5262e5944fcb$var$pluginProps));
        var didPassUnknownProp = !$cbcb5262e5944fcb$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $cbcb5262e5944fcb$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $cbcb5262e5944fcb$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $cbcb5262e5944fcb$var$dangerouslySetInnerHTML(element, html) {
    element[$cbcb5262e5944fcb$var$innerHTML()] = html;
}
function $cbcb5262e5944fcb$var$createArrowElement(value) {
    var arrow = $cbcb5262e5944fcb$var$div();
    if (value === true) arrow.className = $cbcb5262e5944fcb$var$ARROW_CLASS;
    else {
        arrow.className = $cbcb5262e5944fcb$var$SVG_ARROW_CLASS;
        if ($cbcb5262e5944fcb$var$isElement(value)) arrow.appendChild(value);
        else $cbcb5262e5944fcb$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $cbcb5262e5944fcb$var$setContent(content, props) {
    if ($cbcb5262e5944fcb$var$isElement(props.content)) {
        $cbcb5262e5944fcb$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $cbcb5262e5944fcb$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $cbcb5262e5944fcb$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $cbcb5262e5944fcb$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($cbcb5262e5944fcb$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($cbcb5262e5944fcb$var$ARROW_CLASS) || node.classList.contains($cbcb5262e5944fcb$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($cbcb5262e5944fcb$var$BACKDROP_CLASS);
        })
    };
}
function $cbcb5262e5944fcb$var$render(instance) {
    var popper = $cbcb5262e5944fcb$var$div();
    var box = $cbcb5262e5944fcb$var$div();
    box.className = $cbcb5262e5944fcb$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $cbcb5262e5944fcb$var$div();
    content.className = $cbcb5262e5944fcb$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $cbcb5262e5944fcb$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $cbcb5262e5944fcb$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $cbcb5262e5944fcb$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($cbcb5262e5944fcb$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($cbcb5262e5944fcb$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$cbcb5262e5944fcb$var$render.$$tippy = true;
var $cbcb5262e5944fcb$var$idCounter = 1;
var $cbcb5262e5944fcb$var$mouseMoveListeners = []; // Used by `hideAll()`
var $cbcb5262e5944fcb$var$mountedInstances = [];
function $cbcb5262e5944fcb$var$createTippy(reference, passedProps) {
    var props = $cbcb5262e5944fcb$var$evaluateProps(reference, Object.assign({}, $cbcb5262e5944fcb$var$defaultProps, $cbcb5262e5944fcb$var$getExtendedPassedProps($cbcb5262e5944fcb$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $cbcb5262e5944fcb$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $cbcb5262e5944fcb$var$idCounter++;
    var popperInstance = null;
    var plugins = $cbcb5262e5944fcb$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $cbcb5262e5944fcb$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $cbcb5262e5944fcb$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $cbcb5262e5944fcb$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $cbcb5262e5944fcb$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $cbcb5262e5944fcb$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $cbcb5262e5944fcb$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $cbcb5262e5944fcb$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $cbcb5262e5944fcb$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $cbcb5262e5944fcb$var$mouseMoveListeners = $cbcb5262e5944fcb$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($cbcb5262e5944fcb$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $cbcb5262e5944fcb$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($cbcb5262e5944fcb$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $cbcb5262e5944fcb$var$actualContains(el, actualTarget);
        })) {
            if ($cbcb5262e5944fcb$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $cbcb5262e5944fcb$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $cbcb5262e5944fcb$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $cbcb5262e5944fcb$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $cbcb5262e5944fcb$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $cbcb5262e5944fcb$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($cbcb5262e5944fcb$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $cbcb5262e5944fcb$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $cbcb5262e5944fcb$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($cbcb5262e5944fcb$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $cbcb5262e5944fcb$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $cbcb5262e5944fcb$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $233a215823b1eb37$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $cbcb5262e5944fcb$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $cbcb5262e5944fcb$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $cbcb5262e5944fcb$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($cbcb5262e5944fcb$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $cbcb5262e5944fcb$var$evaluateProps(reference, Object.assign({}, prevProps, $cbcb5262e5944fcb$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $cbcb5262e5944fcb$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $cbcb5262e5944fcb$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $cbcb5262e5944fcb$var$currentInput.isTouch && !instance.props.touch;
        var duration = $cbcb5262e5944fcb$var$getValueAtIndexOrReturn(instance.props.duration, 0, $cbcb5262e5944fcb$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $cbcb5262e5944fcb$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $cbcb5262e5944fcb$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $cbcb5262e5944fcb$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $cbcb5262e5944fcb$var$pushIfUnique($cbcb5262e5944fcb$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $cbcb5262e5944fcb$var$getValueAtIndexOrReturn(instance.props.duration, 1, $cbcb5262e5944fcb$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $cbcb5262e5944fcb$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $cbcb5262e5944fcb$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $cbcb5262e5944fcb$var$pushIfUnique($cbcb5262e5944fcb$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $cbcb5262e5944fcb$var$mountedInstances = $cbcb5262e5944fcb$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $cbcb5262e5944fcb$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $cbcb5262e5944fcb$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $cbcb5262e5944fcb$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $cbcb5262e5944fcb$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $cbcb5262e5944fcb$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $cbcb5262e5944fcb$var$isElement(targets) ? instances[0] : instances;
}
$cbcb5262e5944fcb$var$tippy.defaultProps = $cbcb5262e5944fcb$var$defaultProps;
$cbcb5262e5944fcb$var$tippy.setDefaultProps = $cbcb5262e5944fcb$var$setDefaultProps;
$cbcb5262e5944fcb$var$tippy.currentInput = $cbcb5262e5944fcb$var$currentInput;
var $cbcb5262e5944fcb$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $cbcb5262e5944fcb$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $cbcb5262e5944fcb$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $cbcb5262e5944fcb$var$applyStylesModifier = Object.assign({}, (0, $36e1ff64f9481fdf$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $cbcb5262e5944fcb$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $cbcb5262e5944fcb$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $cbcb5262e5944fcb$var$tippy($cbcb5262e5944fcb$var$div(), Object.assign({}, $cbcb5262e5944fcb$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $cbcb5262e5944fcb$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $cbcb5262e5944fcb$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $cbcb5262e5944fcb$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $cbcb5262e5944fcb$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $cbcb5262e5944fcb$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $cbcb5262e5944fcb$var$tippy(targets, parentProps);
    var normalizedReturnValue = $cbcb5262e5944fcb$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $cbcb5262e5944fcb$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($cbcb5262e5944fcb$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $cbcb5262e5944fcb$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $cbcb5262e5944fcb$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $cbcb5262e5944fcb$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $cbcb5262e5944fcb$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $cbcb5262e5944fcb$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $cbcb5262e5944fcb$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $cbcb5262e5944fcb$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $cbcb5262e5944fcb$var$createBackdropElement() {
    var backdrop = $cbcb5262e5944fcb$var$div();
    backdrop.className = $cbcb5262e5944fcb$var$BACKDROP_CLASS;
    $cbcb5262e5944fcb$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $cbcb5262e5944fcb$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $cbcb5262e5944fcb$var$activeInstances = [];
function $cbcb5262e5944fcb$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $cbcb5262e5944fcb$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $cbcb5262e5944fcb$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $cbcb5262e5944fcb$var$storeMouseCoords);
}
function $cbcb5262e5944fcb$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $cbcb5262e5944fcb$var$storeMouseCoords);
}
var $cbcb5262e5944fcb$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $cbcb5262e5944fcb$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $cbcb5262e5944fcb$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $cbcb5262e5944fcb$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $cbcb5262e5944fcb$var$activeInstances = $cbcb5262e5944fcb$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($cbcb5262e5944fcb$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $cbcb5262e5944fcb$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($cbcb5262e5944fcb$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($cbcb5262e5944fcb$var$isMouseEvent(event)) $cbcb5262e5944fcb$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $cbcb5262e5944fcb$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $cbcb5262e5944fcb$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $cbcb5262e5944fcb$var$getInlineBoundingClientRect($cbcb5262e5944fcb$var$getBasePlacement(placement), reference.getBoundingClientRect(), $cbcb5262e5944fcb$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($cbcb5262e5944fcb$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($cbcb5262e5944fcb$var$isMouseEvent(event)) {
                    var rects = $cbcb5262e5944fcb$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $cbcb5262e5944fcb$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $cbcb5262e5944fcb$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $cbcb5262e5944fcb$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $cbcb5262e5944fcb$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $cbcb5262e5944fcb$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$cbcb5262e5944fcb$var$tippy.setDefaultProps({
    render: $cbcb5262e5944fcb$var$render
});
var $cbcb5262e5944fcb$export$2e2bcd8739ae039 = $cbcb5262e5944fcb$var$tippy;


window.initProjectMetaTooltipInfo = function initProjectMetaTooltipInfo1() {
    const adminMetaTooltipsArr = document.querySelectorAll("[data-tippy-tooltip]");
    if (adminMetaTooltipsArr.length && typeof (0, $cbcb5262e5944fcb$export$2e2bcd8739ae039) !== "undefined") adminMetaTooltipsArr.forEach((adminMetaTooltip)=>{
        if (!adminMetaTooltip.classList.contains("is-init-tooltip")) {
            adminMetaTooltip.classList.add("is-init-tooltip");
            const instance = (0, $cbcb5262e5944fcb$export$2e2bcd8739ae039)(adminMetaTooltip, {
                content: adminMetaTooltip.dataset.tippyTooltip || "Info",
                placement: "top",
                animation: "fade",
                arrow: true,
                theme: "project-input-tooltip"
            });
        }
    });
};
initProjectMetaTooltipInfo();
window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector("textarea[data-autosize]")) {
        const autosizeTextareaElements = document.querySelectorAll("textarea[data-autosize]");
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener("input", autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();
// meta counter
const $cf68deaccb5072b2$var$counters = document.querySelectorAll(".meta-counter");
if ($cf68deaccb5072b2$var$counters.length) $cf68deaccb5072b2$var$counters.forEach((counter)=>{
    let count = 1;
    const counterMinus = counter.querySelector(".counter-minus");
    const counterPlus = counter.querySelector(".counter-plus");
    const counterValue = counter.querySelector(".counter-value");
    counterValue.addEventListener("input", ()=>{
        const newValue = parseInt(counterValue.value);
        if (!isNaN(newValue) && newValue > 0 && newValue <= 999) count = newValue;
    });
    counterMinus.addEventListener("click", ()=>{
        if (count - 1 <= 0) return;
        count -= 1;
        counterValue.value = count;
    });
    counterPlus.addEventListener("click", ()=>{
        if (count >= 999) return;
        if (count + 1 > 9999) return;
        count += 1;
        counterValue.value = count;
    });
});
function $cf68deaccb5072b2$var$resizeInput(input) {
    const mirror = document.getElementById("text-mirror");
    mirror.textContent = input.value || input.placeholder;
    input.style.width = `${mirror.offsetWidth + 20}px`;
}
document.addEventListener("DOMContentLoaded", ()=>{
    const inputs = document.querySelectorAll(".counter-value");
    inputs.forEach((input)=>{
        $cf68deaccb5072b2$var$resizeInput(input);
        input.addEventListener("input", ()=>$cf68deaccb5072b2$var$resizeInput(input));
    });
});
function $cf68deaccb5072b2$var$formatInput(inputEl) {
    const sanitizedValue = inputEl.value.replace(/[^\d.,]/g, "");
    inputEl.value = "\u20B9" + sanitizedValue;
}
if (document.querySelector(".salary-input")) {
    const salaryInputsArr = document.querySelectorAll(".salary-input");
    salaryInputsArr.forEach((input)=>{
        input.addEventListener("input", ()=>{
            $cf68deaccb5072b2$var$formatInput(input);
        });
    });
}
window.clearSalaryInput = function clearSalaryInput(id) {
    const salaryInputEl = document.querySelector(`#${id}`);
    salaryInputEl.value = "";
    $cf68deaccb5072b2$var$formatInput(salaryInputEl, 999999);
};
window.passwordInputs = function passwordInputs1() {
    if (document.querySelector(".password-input")) {
        const passwordInputsArr = document.querySelectorAll(".password-input");
        passwordInputsArr.forEach((password)=>{
            const btn = password.querySelector(".password-input__btn");
            const input = password.querySelector("input");
            btn.addEventListener("click", ()=>{
                inputIconFunc();
            });
            function inputIconFunc() {
                if (!btn.classList.contains("is-password-hidden")) {
                    btn.classList.add("is-password-hidden");
                    input.type = "password";
                } else {
                    btn.classList.remove("is-password-hidden");
                    input.type = "text";
                }
            }
            inputIconFunc();
        });
    }
};
passwordInputs();


/*Splitting();*/ var $b5be3fbf97127d69$exports = {};
(function(f) {
    var g;
    $b5be3fbf97127d69$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    // Generated by CoffeeScript 1.12.2
                    (function() {
                        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                            return performance.now();
                        };
                        else if (typeof process !== "undefined" && process !== null && process.hrtime) {
                            module1.exports = function() {
                                return (getNanoSeconds() - nodeLoadTime) / 1e6;
                            };
                            hrtime = process.hrtime;
                            getNanoSeconds = function() {
                                var hr;
                                hr = hrtime();
                                return hr[0] * 1e9 + hr[1];
                            };
                            moduleLoadTime = getNanoSeconds();
                            upTime = process.uptime() * 1e9;
                            nodeLoadTime = moduleLoadTime - upTime;
                        } else if (Date.now) {
                            module1.exports = function() {
                                return Date.now() - loadTime;
                            };
                            loadTime = Date.now();
                        } else {
                            module1.exports = function() {
                                return new Date().getTime() - loadTime;
                            };
                            loadTime = new Date().getTime();
                        }
                    }).call(this);
                }).call(this, require1("_process"));
            },
            {
                "_process": 3
            }
        ],
        3: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                (function(global1) {
                    var now = require1("performance-now"), root = typeof window === "undefined" ? global1 : window, vendors = [
                        "moz",
                        "webkit"
                    ], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
                    for(var i = 0; !raf && i < vendors.length; i++){
                        raf = root[vendors[i] + "Request" + suffix];
                        caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
                    }
                    // Some versions of FF have rAF but not cAF
                    if (!raf || !caf) {
                        var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                        raf = function(callback) {
                            if (queue.length === 0) {
                                var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                                last = next + _now;
                                setTimeout(function() {
                                    var cp = queue.slice(0);
                                    // Clear queue here to prevent
                                    // callbacks from appending listeners
                                    // to the current frame's queue
                                    queue.length = 0;
                                    for(var i = 0; i < cp.length; i++){
                                        if (!cp[i].cancelled) try {
                                            cp[i].callback(last);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw e;
                                            }, 0);
                                        }
                                    }
                                }, Math.round(next));
                            }
                            queue.push({
                                handle: ++id,
                                callback: callback,
                                cancelled: false
                            });
                            return id;
                        };
                        caf = function(handle) {
                            for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                        };
                    }
                    module1.exports = function(fn) {
                        // Wrap in a new function to prevent
                        // `cancel` potentially being assigned
                        // to the native rAF function
                        return raf.call(root, fn);
                    };
                    module1.exports.cancel = function() {
                        caf.apply(root, arguments);
                    };
                    module1.exports.polyfill = function() {
                        root.requestAnimationFrame = raf;
                        root.cancelAnimationFrame = caf;
                    };
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "performance-now": 2
            }
        ],
        5: [
            function(require1, module1, exports) {
                "use strict";
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
* Parallax.js
* @author Matthew Wagerfield - @wagerfield, René Roth - mail@reneroth.org
* @description Creates a parallax effect between an array of layers,
*              driving the motion from the gyroscope output of a smartdevice.
*              If no gyroscope is available, the cursor position is used.
*/ var rqAnFr = require1("raf");
                var objectAssign = require1("object-assign");
                var helpers = {
                    propertyCache: {},
                    vendors: [
                        null,
                        [
                            "-webkit-",
                            "webkit"
                        ],
                        [
                            "-moz-",
                            "Moz"
                        ],
                        [
                            "-o-",
                            "O"
                        ],
                        [
                            "-ms-",
                            "ms"
                        ]
                    ],
                    clamp: function clamp(value, min, max) {
                        return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
                    },
                    data: function data(element, name) {
                        return helpers.deserialize(element.getAttribute("data-" + name));
                    },
                    deserialize: function deserialize(value) {
                        if (value === "true") return true;
                        else if (value === "false") return false;
                        else if (value === "null") return null;
                        else if (!isNaN(parseFloat(value)) && isFinite(value)) return parseFloat(value);
                        else return value;
                    },
                    camelCase: function camelCase(value) {
                        return value.replace(/-+(.)?/g, function(match, character) {
                            return character ? character.toUpperCase() : "";
                        });
                    },
                    accelerate: function accelerate(element) {
                        helpers.css(element, "transform", "translate3d(0,0,0) rotate(0.0001deg)");
                        helpers.css(element, "transform-style", "preserve-3d");
                        helpers.css(element, "backface-visibility", "hidden");
                    },
                    transformSupport: function transformSupport(value) {
                        var element = document.createElement("div"), propertySupport = false, propertyValue = null, featureSupport = false, cssProperty = null, jsProperty = null;
                        for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) {
                                cssProperty = helpers.vendors[i][0] + "transform";
                                jsProperty = helpers.vendors[i][1] + "Transform";
                            } else {
                                cssProperty = "transform";
                                jsProperty = "transform";
                            }
                            if (element.style[jsProperty] !== undefined) {
                                propertySupport = true;
                                break;
                            }
                        }
                        switch(value){
                            case "2D":
                                featureSupport = propertySupport;
                                break;
                            case "3D":
                                if (propertySupport) {
                                    var body = document.body || document.createElement("body"), documentElement = document.documentElement, documentOverflow = documentElement.style.overflow, isCreatedBody = false;
                                    if (!document.body) {
                                        isCreatedBody = true;
                                        documentElement.style.overflow = "hidden";
                                        documentElement.appendChild(body);
                                        body.style.overflow = "hidden";
                                        body.style.background = "";
                                    }
                                    body.appendChild(element);
                                    element.style[jsProperty] = "translate3d(1px,1px,1px)";
                                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
                                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== "none";
                                    documentElement.style.overflow = documentOverflow;
                                    body.removeChild(element);
                                    if (isCreatedBody) {
                                        body.removeAttribute("style");
                                        body.parentNode.removeChild(body);
                                    }
                                }
                                break;
                        }
                        return featureSupport;
                    },
                    css: function css(element, property, value) {
                        var jsProperty = helpers.propertyCache[property];
                        if (!jsProperty) for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) jsProperty = helpers.camelCase(helpers.vendors[i][1] + "-" + property);
                            else jsProperty = property;
                            if (element.style[jsProperty] !== undefined) {
                                helpers.propertyCache[property] = jsProperty;
                                break;
                            }
                        }
                        element.style[jsProperty] = value;
                    }
                };
                var MAGIC_NUMBER = 30, DEFAULTS = {
                    relativeInput: false,
                    clipRelativeInput: false,
                    inputElement: null,
                    hoverOnly: false,
                    calibrationThreshold: 100,
                    calibrationDelay: 500,
                    supportDelay: 500,
                    calibrateX: false,
                    calibrateY: true,
                    invertX: true,
                    invertY: true,
                    limitX: false,
                    limitY: false,
                    scalarX: 10.0,
                    scalarY: 10.0,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5,
                    pointerEvents: false,
                    precision: 1,
                    onReady: null,
                    selector: null
                };
                var Parallax = function() {
                    function Parallax(element, options) {
                        _classCallCheck(this, Parallax);
                        this.element = element;
                        var data = {
                            calibrateX: helpers.data(this.element, "calibrate-x"),
                            calibrateY: helpers.data(this.element, "calibrate-y"),
                            invertX: helpers.data(this.element, "invert-x"),
                            invertY: helpers.data(this.element, "invert-y"),
                            limitX: helpers.data(this.element, "limit-x"),
                            limitY: helpers.data(this.element, "limit-y"),
                            scalarX: helpers.data(this.element, "scalar-x"),
                            scalarY: helpers.data(this.element, "scalar-y"),
                            frictionX: helpers.data(this.element, "friction-x"),
                            frictionY: helpers.data(this.element, "friction-y"),
                            originX: helpers.data(this.element, "origin-x"),
                            originY: helpers.data(this.element, "origin-y"),
                            pointerEvents: helpers.data(this.element, "pointer-events"),
                            precision: helpers.data(this.element, "precision"),
                            relativeInput: helpers.data(this.element, "relative-input"),
                            clipRelativeInput: helpers.data(this.element, "clip-relative-input"),
                            hoverOnly: helpers.data(this.element, "hover-only"),
                            inputElement: document.querySelector(helpers.data(this.element, "input-element")),
                            selector: helpers.data(this.element, "selector")
                        };
                        for(var key in data)if (data[key] === null) delete data[key];
                        objectAssign(this, DEFAULTS, data, options);
                        if (!this.inputElement) this.inputElement = this.element;
                        this.calibrationTimer = null;
                        this.calibrationFlag = true;
                        this.enabled = false;
                        this.depthsX = [];
                        this.depthsY = [];
                        this.raf = null;
                        this.bounds = null;
                        this.elementPositionX = 0;
                        this.elementPositionY = 0;
                        this.elementWidth = 0;
                        this.elementHeight = 0;
                        this.elementCenterX = 0;
                        this.elementCenterY = 0;
                        this.elementRangeX = 0;
                        this.elementRangeY = 0;
                        this.calibrationX = 0;
                        this.calibrationY = 0;
                        this.inputX = 0;
                        this.inputY = 0;
                        this.motionX = 0;
                        this.motionY = 0;
                        this.velocityX = 0;
                        this.velocityY = 0;
                        this.onMouseMove = this.onMouseMove.bind(this);
                        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
                        this.onDeviceMotion = this.onDeviceMotion.bind(this);
                        this.onOrientationTimer = this.onOrientationTimer.bind(this);
                        this.onMotionTimer = this.onMotionTimer.bind(this);
                        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
                        this.onAnimationFrame = this.onAnimationFrame.bind(this);
                        this.onWindowResize = this.onWindowResize.bind(this);
                        this.windowWidth = null;
                        this.windowHeight = null;
                        this.windowCenterX = null;
                        this.windowCenterY = null;
                        this.windowRadiusX = null;
                        this.windowRadiusY = null;
                        this.portrait = false;
                        this.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
                        this.motionSupport = !!window.DeviceMotionEvent && !this.desktop;
                        this.orientationSupport = !!window.DeviceOrientationEvent && !this.desktop;
                        this.orientationStatus = 0;
                        this.motionStatus = 0;
                        this.initialise();
                    }
                    _createClass(Parallax, [
                        {
                            key: "initialise",
                            value: function initialise() {
                                if (this.transform2DSupport === undefined) {
                                    this.transform2DSupport = helpers.transformSupport("2D");
                                    this.transform3DSupport = helpers.transformSupport("3D");
                                }
                                // Configure Context Styles
                                if (this.transform3DSupport) helpers.accelerate(this.element);
                                var style = window.getComputedStyle(this.element);
                                if (style.getPropertyValue("position") === "static") this.element.style.position = "relative";
                                // Pointer events
                                if (!this.pointerEvents) this.element.style.pointerEvents = "none";
                                // Setup
                                this.updateLayers();
                                this.updateDimensions();
                                this.enable();
                                this.queueCalibration(this.calibrationDelay);
                            }
                        },
                        {
                            key: "doReadyCallback",
                            value: function doReadyCallback() {
                                if (this.onReady) this.onReady();
                            }
                        },
                        {
                            key: "updateLayers",
                            value: function updateLayers() {
                                if (this.selector) this.layers = this.element.querySelectorAll(this.selector);
                                else this.layers = this.element.children;
                                if (!this.layers.length) console.warn("ParallaxJS: Your scene does not have any layers.");
                                this.depthsX = [];
                                this.depthsY = [];
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index];
                                    if (this.transform3DSupport) helpers.accelerate(layer);
                                    layer.style.position = index ? "absolute" : "relative";
                                    layer.style.display = "block";
                                    layer.style.left = 0;
                                    layer.style.top = 0;
                                    var depth = helpers.data(layer, "depth") || 0;
                                    this.depthsX.push(helpers.data(layer, "depth-x") || depth);
                                    this.depthsY.push(helpers.data(layer, "depth-y") || depth);
                                }
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions() {
                                this.windowWidth = window.innerWidth;
                                this.windowHeight = window.innerHeight;
                                this.windowCenterX = this.windowWidth * this.originX;
                                this.windowCenterY = this.windowHeight * this.originY;
                                this.windowRadiusX = Math.max(this.windowCenterX, this.windowWidth - this.windowCenterX);
                                this.windowRadiusY = Math.max(this.windowCenterY, this.windowHeight - this.windowCenterY);
                            }
                        },
                        {
                            key: "updateBounds",
                            value: function updateBounds() {
                                this.bounds = this.inputElement.getBoundingClientRect();
                                this.elementPositionX = this.bounds.left;
                                this.elementPositionY = this.bounds.top;
                                this.elementWidth = this.bounds.width;
                                this.elementHeight = this.bounds.height;
                                this.elementCenterX = this.elementWidth * this.originX;
                                this.elementCenterY = this.elementHeight * this.originY;
                                this.elementRangeX = Math.max(this.elementCenterX, this.elementWidth - this.elementCenterX);
                                this.elementRangeY = Math.max(this.elementCenterY, this.elementHeight - this.elementCenterY);
                            }
                        },
                        {
                            key: "queueCalibration",
                            value: function queueCalibration(delay) {
                                clearTimeout(this.calibrationTimer);
                                this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
                            }
                        },
                        {
                            key: "enable",
                            value: function enable() {
                                if (this.enabled) return;
                                this.enabled = true;
                                if (this.orientationSupport) {
                                    this.portrait = false;
                                    window.addEventListener("deviceorientation", this.onDeviceOrientation);
                                    this.detectionTimer = setTimeout(this.onOrientationTimer, this.supportDelay);
                                } else if (this.motionSupport) {
                                    this.portrait = false;
                                    window.addEventListener("devicemotion", this.onDeviceMotion);
                                    this.detectionTimer = setTimeout(this.onMotionTimer, this.supportDelay);
                                } else {
                                    this.calibrationX = 0;
                                    this.calibrationY = 0;
                                    this.portrait = false;
                                    window.addEventListener("mousemove", this.onMouseMove);
                                    this.doReadyCallback();
                                }
                                window.addEventListener("resize", this.onWindowResize);
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "disable",
                            value: function disable() {
                                if (!this.enabled) return;
                                this.enabled = false;
                                if (this.orientationSupport) window.removeEventListener("deviceorientation", this.onDeviceOrientation);
                                else if (this.motionSupport) window.removeEventListener("devicemotion", this.onDeviceMotion);
                                else window.removeEventListener("mousemove", this.onMouseMove);
                                window.removeEventListener("resize", this.onWindowResize);
                                rqAnFr.cancel(this.raf);
                            }
                        },
                        {
                            key: "calibrate",
                            value: function calibrate(x, y) {
                                this.calibrateX = x === undefined ? this.calibrateX : x;
                                this.calibrateY = y === undefined ? this.calibrateY : y;
                            }
                        },
                        {
                            key: "invert",
                            value: function invert(x, y) {
                                this.invertX = x === undefined ? this.invertX : x;
                                this.invertY = y === undefined ? this.invertY : y;
                            }
                        },
                        {
                            key: "friction",
                            value: function friction(x, y) {
                                this.frictionX = x === undefined ? this.frictionX : x;
                                this.frictionY = y === undefined ? this.frictionY : y;
                            }
                        },
                        {
                            key: "scalar",
                            value: function scalar(x, y) {
                                this.scalarX = x === undefined ? this.scalarX : x;
                                this.scalarY = y === undefined ? this.scalarY : y;
                            }
                        },
                        {
                            key: "limit",
                            value: function limit(x, y) {
                                this.limitX = x === undefined ? this.limitX : x;
                                this.limitY = y === undefined ? this.limitY : y;
                            }
                        },
                        {
                            key: "origin",
                            value: function origin(x, y) {
                                this.originX = x === undefined ? this.originX : x;
                                this.originY = y === undefined ? this.originY : y;
                            }
                        },
                        {
                            key: "setInputElement",
                            value: function setInputElement(element) {
                                this.inputElement = element;
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "setPosition",
                            value: function setPosition(element, x, y) {
                                x = x.toFixed(this.precision) + "px";
                                y = y.toFixed(this.precision) + "px";
                                if (this.transform3DSupport) helpers.css(element, "transform", "translate3d(" + x + "," + y + ",0)");
                                else if (this.transform2DSupport) helpers.css(element, "transform", "translate(" + x + "," + y + ")");
                                else {
                                    element.style.left = x;
                                    element.style.top = y;
                                }
                            }
                        },
                        {
                            key: "onOrientationTimer",
                            value: function onOrientationTimer() {
                                if (this.orientationSupport && this.orientationStatus === 0) {
                                    this.disable();
                                    this.orientationSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onMotionTimer",
                            value: function onMotionTimer() {
                                if (this.motionSupport && this.motionStatus === 0) {
                                    this.disable();
                                    this.motionSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onCalibrationTimer",
                            value: function onCalibrationTimer() {
                                this.calibrationFlag = true;
                            }
                        },
                        {
                            key: "onWindowResize",
                            value: function onWindowResize() {
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "onAnimationFrame",
                            value: function onAnimationFrame() {
                                this.updateBounds();
                                var calibratedInputX = this.inputX - this.calibrationX, calibratedInputY = this.inputY - this.calibrationY;
                                if (Math.abs(calibratedInputX) > this.calibrationThreshold || Math.abs(calibratedInputY) > this.calibrationThreshold) this.queueCalibration(0);
                                if (this.portrait) {
                                    this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
                                    this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
                                } else {
                                    this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
                                    this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
                                }
                                this.motionX *= this.elementWidth * (this.scalarX / 100);
                                this.motionY *= this.elementHeight * (this.scalarY / 100);
                                if (!isNaN(parseFloat(this.limitX))) this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
                                if (!isNaN(parseFloat(this.limitY))) this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
                                this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
                                this.velocityY += (this.motionY - this.velocityY) * this.frictionY;
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index], depthX = this.depthsX[index], depthY = this.depthsY[index], xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)), yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1));
                                    this.setPosition(layer, xOffset, yOffset);
                                }
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "rotate",
                            value: function rotate(beta, gamma) {
                                // Extract Rotation
                                var x = (beta || 0) / MAGIC_NUMBER, //  -90 :: 90
                                y = (gamma || 0) / MAGIC_NUMBER; // -180 :: 180
                                // Detect Orientation Change
                                var portrait = this.windowHeight > this.windowWidth;
                                if (this.portrait !== portrait) {
                                    this.portrait = portrait;
                                    this.calibrationFlag = true;
                                }
                                if (this.calibrationFlag) {
                                    this.calibrationFlag = false;
                                    this.calibrationX = x;
                                    this.calibrationY = y;
                                }
                                this.inputX = x;
                                this.inputY = y;
                            }
                        },
                        {
                            key: "onDeviceOrientation",
                            value: function onDeviceOrientation(event) {
                                var beta = event.beta;
                                var gamma = event.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.orientationStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onDeviceMotion",
                            value: function onDeviceMotion(event) {
                                var beta = event.rotationRate.beta;
                                var gamma = event.rotationRate.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.motionStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onMouseMove",
                            value: function onMouseMove(event) {
                                var clientX = event.clientX, clientY = event.clientY;
                                // reset input to center if hoverOnly is set and we're not hovering the element
                                if (this.hoverOnly && (clientX < this.elementPositionX || clientX > this.elementPositionX + this.elementWidth || clientY < this.elementPositionY || clientY > this.elementPositionY + this.elementHeight)) {
                                    this.inputX = 0;
                                    this.inputY = 0;
                                    return;
                                }
                                if (this.relativeInput) {
                                    // Clip mouse coordinates inside element bounds.
                                    if (this.clipRelativeInput) {
                                        clientX = Math.max(clientX, this.elementPositionX);
                                        clientX = Math.min(clientX, this.elementPositionX + this.elementWidth);
                                        clientY = Math.max(clientY, this.elementPositionY);
                                        clientY = Math.min(clientY, this.elementPositionY + this.elementHeight);
                                    }
                                    // Calculate input relative to the element.
                                    if (this.elementRangeX && this.elementRangeY) {
                                        this.inputX = (clientX - this.elementPositionX - this.elementCenterX) / this.elementRangeX;
                                        this.inputY = (clientY - this.elementPositionY - this.elementCenterY) / this.elementRangeY;
                                    }
                                } else // Calculate input relative to the window.
                                if (this.windowRadiusX && this.windowRadiusY) {
                                    this.inputX = (clientX - this.windowCenterX) / this.windowRadiusX;
                                    this.inputY = (clientY - this.windowCenterY) / this.windowRadiusY;
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.disable();
                                clearTimeout(this.calibrationTimer);
                                clearTimeout(this.detectionTimer);
                                this.element.removeAttribute("style");
                                for(var index = 0; index < this.layers.length; index++)this.layers[index].removeAttribute("style");
                                delete this.element;
                                delete this.layers;
                            }
                        },
                        {
                            key: "version",
                            value: function version() {
                                return "3.1.0";
                            }
                        }
                    ]);
                    return Parallax;
                }();
                module1.exports = Parallax;
            },
            {
                "object-assign": 1,
                "raf": 4
            }
        ]
    }, {}, [
        5
    ])(5);
});


var $58c64867bb1128b4$exports = {};
var $58c64867bb1128b4$var$__dirname = "node_modules/.pnpm/sharp@0.31.3/node_modules/sharp/lib";

var $4Ydn9 = parcelRequire("4Ydn9");
"use strict";
var $d770782c5b96d634$exports = {};
"use strict";


var $9ac112f9d1f14f1d$export$edf525f30916fbb8;
var $9ac112f9d1f14f1d$export$640106f6dc7d2706;
var $9ac112f9d1f14f1d$export$3ea386628068cf62;
var $9ac112f9d1f14f1d$export$749d472264fad440;
var $9ac112f9d1f14f1d$export$8b931a48d9488767;
var $9ac112f9d1f14f1d$export$9123f37609399513;
var $9ac112f9d1f14f1d$export$9b60beb643db4d69;
var $9ac112f9d1f14f1d$export$bf9fb029d174d554;
var $9ac112f9d1f14f1d$export$23d3fad09dc44362;
var $9ac112f9d1f14f1d$export$d2f3c2f7e0c7dcf5;
var $9ac112f9d1f14f1d$export$3bf7c33313eba0fe;
var $9ac112f9d1f14f1d$export$7925d89f138dad5b;
var $9ac112f9d1f14f1d$export$722a64dea1b767dc;
var $9ac112f9d1f14f1d$export$9e6c06a7d47f9af7;
var $9ac112f9d1f14f1d$export$6b76988456c0292f;
var $9ac112f9d1f14f1d$export$266d3b9babd1fc45;
var $9ac112f9d1f14f1d$export$c1d46b5ea6262c0b;
$9ac112f9d1f14f1d$export$edf525f30916fbb8 = function() {
    return "LE";
};
$9ac112f9d1f14f1d$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$9ac112f9d1f14f1d$export$3ea386628068cf62 = function() {
    return [];
};
$9ac112f9d1f14f1d$export$749d472264fad440 = function() {
    return 0;
};
$9ac112f9d1f14f1d$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$9ac112f9d1f14f1d$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$9ac112f9d1f14f1d$export$9b60beb643db4d69 = function() {
    return [];
};
$9ac112f9d1f14f1d$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$9ac112f9d1f14f1d$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$9ac112f9d1f14f1d$export$d2f3c2f7e0c7dcf5 = $9ac112f9d1f14f1d$export$3bf7c33313eba0fe = function() {
    return {};
};
$9ac112f9d1f14f1d$export$7925d89f138dad5b = function() {
    return "javascript";
};
$9ac112f9d1f14f1d$export$722a64dea1b767dc = function() {
    return "browser";
};
$9ac112f9d1f14f1d$export$9e6c06a7d47f9af7 = $9ac112f9d1f14f1d$export$6b76988456c0292f = function() {
    return "/tmp";
};
$9ac112f9d1f14f1d$export$266d3b9babd1fc45 = "\n";
$9ac112f9d1f14f1d$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $822d81f77a1c47fb$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Ydn9 = parcelRequire("4Ydn9");
"use strict";
function $822d81f77a1c47fb$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $822d81f77a1c47fb$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $822d81f77a1c47fb$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $822d81f77a1c47fb$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $4Ydn9.cwd();
                path = cwd;
            }
            $822d81f77a1c47fb$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $822d81f77a1c47fb$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $822d81f77a1c47fb$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $822d81f77a1c47fb$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $822d81f77a1c47fb$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $822d81f77a1c47fb$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $822d81f77a1c47fb$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $822d81f77a1c47fb$var$assertPath(from);
        $822d81f77a1c47fb$var$assertPath(to);
        if (from === to) return "";
        from = $822d81f77a1c47fb$var$posix.resolve(from);
        to = $822d81f77a1c47fb$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $822d81f77a1c47fb$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $822d81f77a1c47fb$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $822d81f77a1c47fb$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $822d81f77a1c47fb$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $822d81f77a1c47fb$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$822d81f77a1c47fb$var$posix.posix = $822d81f77a1c47fb$var$posix;
$822d81f77a1c47fb$exports = $822d81f77a1c47fb$var$posix;



var $58c64867bb1128b4$require$spawnSync = $d770782c5b96d634$exports.spawnSync;
var $661e4716f4f8a4b6$exports = {};
var $5d50e4e636096005$exports = {};

var $372xn = parcelRequire("372xn");

var $kFdUg = parcelRequire("kFdUg");
var $5d50e4e636096005$require$MAX_LENGTH = $kFdUg.MAX_LENGTH;
var $5d50e4e636096005$require$MAX_SAFE_INTEGER = $kFdUg.MAX_SAFE_INTEGER;

var $cl4iB = parcelRequire("cl4iB");
var $5d50e4e636096005$require$re = $cl4iB.safeRe;
var $5d50e4e636096005$require$t = $cl4iB.t;
var $572ce6d395ed5872$exports = {};
// parse out just the options we care about
const $572ce6d395ed5872$var$looseOption = Object.freeze({
    loose: true
});
const $572ce6d395ed5872$var$emptyOpts = Object.freeze({});
const $572ce6d395ed5872$var$parseOptions = (options)=>{
    if (!options) return $572ce6d395ed5872$var$emptyOpts;
    if (typeof options !== "object") return $572ce6d395ed5872$var$looseOption;
    return options;
};
$572ce6d395ed5872$exports = $572ce6d395ed5872$var$parseOptions;


var $172eae289ef8cb07$exports = {};
const $172eae289ef8cb07$var$numeric = /^[0-9]+$/;
const $172eae289ef8cb07$var$compareIdentifiers = (a, b)=>{
    const anum = $172eae289ef8cb07$var$numeric.test(a);
    const bnum = $172eae289ef8cb07$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $172eae289ef8cb07$var$rcompareIdentifiers = (a, b)=>$172eae289ef8cb07$var$compareIdentifiers(b, a);
$172eae289ef8cb07$exports = {
    compareIdentifiers: $172eae289ef8cb07$var$compareIdentifiers,
    rcompareIdentifiers: $172eae289ef8cb07$var$rcompareIdentifiers
};


var $5d50e4e636096005$require$compareIdentifiers = $172eae289ef8cb07$exports.compareIdentifiers;
class $5d50e4e636096005$var$SemVer {
    constructor(version, options){
        options = $572ce6d395ed5872$exports(options);
        if (version instanceof $5d50e4e636096005$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $5d50e4e636096005$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$5d50e4e636096005$require$MAX_LENGTH} characters`);
        $372xn("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $5d50e4e636096005$require$re[$5d50e4e636096005$require$t.LOOSE] : $5d50e4e636096005$require$re[$5d50e4e636096005$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $5d50e4e636096005$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $5d50e4e636096005$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $5d50e4e636096005$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $5d50e4e636096005$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $372xn("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $5d50e4e636096005$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $5d50e4e636096005$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $5d50e4e636096005$var$SemVer)) other = new $5d50e4e636096005$var$SemVer(other, this.options);
        return $5d50e4e636096005$require$compareIdentifiers(this.major, other.major) || $5d50e4e636096005$require$compareIdentifiers(this.minor, other.minor) || $5d50e4e636096005$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $5d50e4e636096005$var$SemVer)) other = new $5d50e4e636096005$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $372xn("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $5d50e4e636096005$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $5d50e4e636096005$var$SemVer)) other = new $5d50e4e636096005$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $372xn("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $5d50e4e636096005$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($5d50e4e636096005$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
$5d50e4e636096005$exports = $5d50e4e636096005$var$SemVer;


var $d576ca6ec74153a5$exports = {};

const $d576ca6ec74153a5$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $5d50e4e636096005$exports) return version;
    try {
        return new $5d50e4e636096005$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$d576ca6ec74153a5$exports = $d576ca6ec74153a5$var$parse;



var $cl4iB = parcelRequire("cl4iB");
var $661e4716f4f8a4b6$require$re = $cl4iB.safeRe;
var $661e4716f4f8a4b6$require$t = $cl4iB.t;
const $661e4716f4f8a4b6$var$coerce = (version, options)=>{
    if (version instanceof $5d50e4e636096005$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match($661e4716f4f8a4b6$require$re[$661e4716f4f8a4b6$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        let next;
        while((next = $661e4716f4f8a4b6$require$re[$661e4716f4f8a4b6$require$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $661e4716f4f8a4b6$require$re[$661e4716f4f8a4b6$require$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $661e4716f4f8a4b6$require$re[$661e4716f4f8a4b6$require$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $d576ca6ec74153a5$exports(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
};
$661e4716f4f8a4b6$exports = $661e4716f4f8a4b6$var$coerce;


var $c1ce76c3004fdbd4$exports = {};
var $ab56135acb1d5a4b$exports = {};

const $ab56135acb1d5a4b$var$compare = (a, b, loose)=>new $5d50e4e636096005$exports(a, loose).compare(new $5d50e4e636096005$exports(b, loose));
$ab56135acb1d5a4b$exports = $ab56135acb1d5a4b$var$compare;


const $c1ce76c3004fdbd4$var$gte = (a, b, loose)=>$ab56135acb1d5a4b$exports(a, b, loose) >= 0;
$c1ce76c3004fdbd4$exports = $c1ce76c3004fdbd4$var$gte;


var $dbb0c9ebf41e629d$exports = {};

var $4Ydn9 = parcelRequire("4Ydn9");
"use strict";
var $9f9db44705496819$exports = {};
// Copyright 2017 Lovell Fuller and others.
// SPDX-License-Identifier: Apache-2.0
"use strict";

var $21331f0f49063ed3$exports = {};
// Copyright 2017 Lovell Fuller and others.
// SPDX-License-Identifier: Apache-2.0

var $4Ydn9 = parcelRequire("4Ydn9");
"use strict";
const $21331f0f49063ed3$var$isLinux = ()=>$4Ydn9.platform === "linux";
let $21331f0f49063ed3$var$report = null;
const $21331f0f49063ed3$var$getReport = ()=>{
    if (!$21331f0f49063ed3$var$report) /* istanbul ignore next */ $21331f0f49063ed3$var$report = $21331f0f49063ed3$var$isLinux() && $4Ydn9.report ? $4Ydn9.report.getReport() : {};
    return $21331f0f49063ed3$var$report;
};
$21331f0f49063ed3$exports = {
    isLinux: $21331f0f49063ed3$var$isLinux,
    getReport: $21331f0f49063ed3$var$getReport
};


var $9f9db44705496819$require$isLinux = $21331f0f49063ed3$exports.isLinux;
var $9f9db44705496819$require$getReport = $21331f0f49063ed3$exports.getReport;
var $bdef1ab315a8295c$exports = {};
// Copyright 2017 Lovell Fuller and others.
// SPDX-License-Identifier: Apache-2.0
"use strict";

/**
 * The path where we can find the ldd
 */ const $bdef1ab315a8295c$var$LDD_PATH = "/usr/bin/ldd";
/**
 * Read the content of a file synchronous
 *
 * @param {string} path
 * @returns {string}
 */ const $bdef1ab315a8295c$var$readFileSync = (path)=>$d770782c5b96d634$exports.readFileSync(path, "utf-8");
/**
 * Read the content of a file
 *
 * @param {string} path
 * @returns {Promise<string>}
 */ const $bdef1ab315a8295c$var$readFile = (path)=>new Promise((resolve, reject)=>{
        $d770782c5b96d634$exports.readFile(path, "utf-8", (err, data)=>{
            if (err) reject(err);
            else resolve(data);
        });
    });
$bdef1ab315a8295c$exports = {
    LDD_PATH: $bdef1ab315a8295c$var$LDD_PATH,
    readFileSync: $bdef1ab315a8295c$var$readFileSync,
    readFile: $bdef1ab315a8295c$var$readFile
};


var $9f9db44705496819$require$LDD_PATH = $bdef1ab315a8295c$exports.LDD_PATH;
var $9f9db44705496819$require$readFile = $bdef1ab315a8295c$exports.readFile;
var $9f9db44705496819$require$readFileSync = $bdef1ab315a8295c$exports.readFileSync;
let $9f9db44705496819$var$cachedFamilyFilesystem;
let $9f9db44705496819$var$cachedVersionFilesystem;
const $9f9db44705496819$var$command = "getconf GNU_LIBC_VERSION 2>&1 || true; ldd --version 2>&1 || true";
let $9f9db44705496819$var$commandOut = "";
const $9f9db44705496819$var$safeCommand = ()=>{
    if (!$9f9db44705496819$var$commandOut) return new Promise((resolve)=>{
        $d770782c5b96d634$exports.exec($9f9db44705496819$var$command, (err, out)=>{
            $9f9db44705496819$var$commandOut = err ? " " : out;
            resolve($9f9db44705496819$var$commandOut);
        });
    });
    return $9f9db44705496819$var$commandOut;
};
const $9f9db44705496819$var$safeCommandSync = ()=>{
    if (!$9f9db44705496819$var$commandOut) try {
        $9f9db44705496819$var$commandOut = $d770782c5b96d634$exports.execSync($9f9db44705496819$var$command, {
            encoding: "utf8"
        });
    } catch (_err) {
        $9f9db44705496819$var$commandOut = " ";
    }
    return $9f9db44705496819$var$commandOut;
};
/**
 * A String constant containing the value `glibc`.
 * @type {string}
 * @public
 */ const $9f9db44705496819$var$GLIBC = "glibc";
/**
 * A Regexp constant to get the GLIBC Version.
 * @type {string}
 */ const $9f9db44705496819$var$RE_GLIBC_VERSION = /GLIBC\s(\d+\.\d+)/;
/**
 * A String constant containing the value `musl`.
 * @type {string}
 * @public
 */ const $9f9db44705496819$var$MUSL = "musl";
/**
 * This string is used to find if the {@link LDD_PATH} is GLIBC
 * @type {string}
 */ const $9f9db44705496819$var$GLIBC_ON_LDD = $9f9db44705496819$var$GLIBC.toUpperCase();
/**
 * This string is used to find if the {@link LDD_PATH} is musl
 * @type {string}
 */ const $9f9db44705496819$var$MUSL_ON_LDD = $9f9db44705496819$var$MUSL.toLowerCase();
const $9f9db44705496819$var$isFileMusl = (f)=>f.includes("libc.musl-") || f.includes("ld-musl-");
const $9f9db44705496819$var$familyFromReport = ()=>{
    const report = $9f9db44705496819$require$getReport();
    if (report.header && report.header.glibcVersionRuntime) return $9f9db44705496819$var$GLIBC;
    if (Array.isArray(report.sharedObjects)) {
        if (report.sharedObjects.some($9f9db44705496819$var$isFileMusl)) return $9f9db44705496819$var$MUSL;
    }
    return null;
};
const $9f9db44705496819$var$familyFromCommand = (out)=>{
    const [getconf, ldd1] = out.split(/[\r\n]+/);
    if (getconf && getconf.includes($9f9db44705496819$var$GLIBC)) return $9f9db44705496819$var$GLIBC;
    if (ldd1 && ldd1.includes($9f9db44705496819$var$MUSL)) return $9f9db44705496819$var$MUSL;
    return null;
};
const $9f9db44705496819$var$getFamilyFromLddContent = (content)=>{
    if (content.includes($9f9db44705496819$var$MUSL_ON_LDD)) return $9f9db44705496819$var$MUSL;
    if (content.includes($9f9db44705496819$var$GLIBC_ON_LDD)) return $9f9db44705496819$var$GLIBC;
    return null;
};
const $9f9db44705496819$var$familyFromFilesystem = async ()=>{
    if ($9f9db44705496819$var$cachedFamilyFilesystem !== undefined) return $9f9db44705496819$var$cachedFamilyFilesystem;
    $9f9db44705496819$var$cachedFamilyFilesystem = null;
    try {
        const lddContent = await $9f9db44705496819$require$readFile($9f9db44705496819$require$LDD_PATH);
        $9f9db44705496819$var$cachedFamilyFilesystem = $9f9db44705496819$var$getFamilyFromLddContent(lddContent);
    } catch (e) {}
    return $9f9db44705496819$var$cachedFamilyFilesystem;
};
const $9f9db44705496819$var$familyFromFilesystemSync = ()=>{
    if ($9f9db44705496819$var$cachedFamilyFilesystem !== undefined) return $9f9db44705496819$var$cachedFamilyFilesystem;
    $9f9db44705496819$var$cachedFamilyFilesystem = null;
    try {
        const lddContent = $9f9db44705496819$require$readFileSync($9f9db44705496819$require$LDD_PATH);
        $9f9db44705496819$var$cachedFamilyFilesystem = $9f9db44705496819$var$getFamilyFromLddContent(lddContent);
    } catch (e) {}
    return $9f9db44705496819$var$cachedFamilyFilesystem;
};
/**
 * Resolves with the libc family when it can be determined, `null` otherwise.
 * @returns {Promise<?string>}
 */ const $9f9db44705496819$var$family = async ()=>{
    let family = null;
    if ($9f9db44705496819$require$isLinux()) {
        family = await $9f9db44705496819$var$familyFromFilesystem();
        if (!family) family = $9f9db44705496819$var$familyFromReport();
        if (!family) {
            const out = await $9f9db44705496819$var$safeCommand();
            family = $9f9db44705496819$var$familyFromCommand(out);
        }
    }
    return family;
};
/**
 * Returns the libc family when it can be determined, `null` otherwise.
 * @returns {?string}
 */ const $9f9db44705496819$var$familySync = ()=>{
    let family = null;
    if ($9f9db44705496819$require$isLinux()) {
        family = $9f9db44705496819$var$familyFromFilesystemSync();
        if (!family) family = $9f9db44705496819$var$familyFromReport();
        if (!family) {
            const out = $9f9db44705496819$var$safeCommandSync();
            family = $9f9db44705496819$var$familyFromCommand(out);
        }
    }
    return family;
};
/**
 * Resolves `true` only when the platform is Linux and the libc family is not `glibc`.
 * @returns {Promise<boolean>}
 */ const $9f9db44705496819$var$isNonGlibcLinux = async ()=>$9f9db44705496819$require$isLinux() && await $9f9db44705496819$var$family() !== $9f9db44705496819$var$GLIBC;
/**
 * Returns `true` only when the platform is Linux and the libc family is not `glibc`.
 * @returns {boolean}
 */ const $9f9db44705496819$var$isNonGlibcLinuxSync = ()=>$9f9db44705496819$require$isLinux() && $9f9db44705496819$var$familySync() !== $9f9db44705496819$var$GLIBC;
const $9f9db44705496819$var$versionFromFilesystem = async ()=>{
    if ($9f9db44705496819$var$cachedVersionFilesystem !== undefined) return $9f9db44705496819$var$cachedVersionFilesystem;
    $9f9db44705496819$var$cachedVersionFilesystem = null;
    try {
        const lddContent = await $9f9db44705496819$require$readFile($9f9db44705496819$require$LDD_PATH);
        const versionMatch = lddContent.match($9f9db44705496819$var$RE_GLIBC_VERSION);
        if (versionMatch) $9f9db44705496819$var$cachedVersionFilesystem = versionMatch[1];
    } catch (e) {}
    return $9f9db44705496819$var$cachedVersionFilesystem;
};
const $9f9db44705496819$var$versionFromFilesystemSync = ()=>{
    if ($9f9db44705496819$var$cachedVersionFilesystem !== undefined) return $9f9db44705496819$var$cachedVersionFilesystem;
    $9f9db44705496819$var$cachedVersionFilesystem = null;
    try {
        const lddContent = $9f9db44705496819$require$readFileSync($9f9db44705496819$require$LDD_PATH);
        const versionMatch = lddContent.match($9f9db44705496819$var$RE_GLIBC_VERSION);
        if (versionMatch) $9f9db44705496819$var$cachedVersionFilesystem = versionMatch[1];
    } catch (e) {}
    return $9f9db44705496819$var$cachedVersionFilesystem;
};
const $9f9db44705496819$var$versionFromReport = ()=>{
    const report = $9f9db44705496819$require$getReport();
    if (report.header && report.header.glibcVersionRuntime) return report.header.glibcVersionRuntime;
    return null;
};
const $9f9db44705496819$var$versionSuffix = (s)=>s.trim().split(/\s+/)[1];
const $9f9db44705496819$var$versionFromCommand = (out)=>{
    const [getconf, ldd1, ldd2] = out.split(/[\r\n]+/);
    if (getconf && getconf.includes($9f9db44705496819$var$GLIBC)) return $9f9db44705496819$var$versionSuffix(getconf);
    if (ldd1 && ldd2 && ldd1.includes($9f9db44705496819$var$MUSL)) return $9f9db44705496819$var$versionSuffix(ldd2);
    return null;
};
/**
 * Resolves with the libc version when it can be determined, `null` otherwise.
 * @returns {Promise<?string>}
 */ const $9f9db44705496819$var$version = async ()=>{
    let version = null;
    if ($9f9db44705496819$require$isLinux()) {
        version = await $9f9db44705496819$var$versionFromFilesystem();
        if (!version) version = $9f9db44705496819$var$versionFromReport();
        if (!version) {
            const out = await $9f9db44705496819$var$safeCommand();
            version = $9f9db44705496819$var$versionFromCommand(out);
        }
    }
    return version;
};
/**
 * Returns the libc version when it can be determined, `null` otherwise.
 * @returns {?string}
 */ const $9f9db44705496819$var$versionSync = ()=>{
    let version = null;
    if ($9f9db44705496819$require$isLinux()) {
        version = $9f9db44705496819$var$versionFromFilesystemSync();
        if (!version) version = $9f9db44705496819$var$versionFromReport();
        if (!version) {
            const out = $9f9db44705496819$var$safeCommandSync();
            version = $9f9db44705496819$var$versionFromCommand(out);
        }
    }
    return version;
};
$9f9db44705496819$exports = {
    GLIBC: $9f9db44705496819$var$GLIBC,
    MUSL: $9f9db44705496819$var$MUSL,
    family: $9f9db44705496819$var$family,
    familySync: $9f9db44705496819$var$familySync,
    isNonGlibcLinux: $9f9db44705496819$var$isNonGlibcLinux,
    isNonGlibcLinuxSync: $9f9db44705496819$var$isNonGlibcLinuxSync,
    version: $9f9db44705496819$var$version,
    versionSync: $9f9db44705496819$var$versionSync
};


const $dbb0c9ebf41e629d$var$env = {};
$dbb0c9ebf41e629d$exports = function() {
    const arch = $dbb0c9ebf41e629d$var$env.npm_config_arch || $4Ydn9.arch;
    const platform = $dbb0c9ebf41e629d$var$env.npm_config_platform || $4Ydn9.platform;
    const libc = /* istanbul ignore next */ $9f9db44705496819$exports.isNonGlibcLinuxSync() ? $9f9db44705496819$exports.familySync() : "";
    const libcId = platform !== "linux" || libc === $9f9db44705496819$exports.GLIBC ? "" : libc;
    const platformId = [
        `${platform}${libcId}`
    ];
    if (arch === "arm") {
        const fallback = $4Ydn9.versions.electron ? "7" : "6";
        platformId.push(`armv${$dbb0c9ebf41e629d$var$env.npm_config_arm_version || $4Ydn9.config.variables.arm_version || fallback}`);
    } else if (arch === "arm64") platformId.push(`arm64v${$dbb0c9ebf41e629d$var$env.npm_config_arm_version || "8"}`);
    else platformId.push(arch);
    return platformId.join("-");
};


var $e16b344c5271525f$exports = {};
$e16b344c5271525f$exports = JSON.parse('{"name":"sharp","description":"High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP, GIF, AVIF and TIFF images","version":"0.31.3","author":"Lovell Fuller <npm@lovell.info>","homepage":"https://github.com/lovell/sharp","contributors":["Pierre Inglebert <pierre.inglebert@gmail.com>","Jonathan Ong <jonathanrichardong@gmail.com>","Chanon Sajjamanochai <chanon.s@gmail.com>","Juliano Julio <julianojulio@gmail.com>","Daniel Gasienica <daniel@gasienica.ch>","Julian Walker <julian@fiftythree.com>","Amit Pitaru <pitaru.amit@gmail.com>","Brandon Aaron <hello.brandon@aaron.sh>","Andreas Lind <andreas@one.com>","Maurus Cuelenaere <mcuelenaere@gmail.com>","Linus Unneb\xe4ck <linus@folkdatorn.se>","Victor Mateevitsi <mvictoras@gmail.com>","Alaric Holloway <alaric.holloway@gmail.com>","Bernhard K. Weisshuhn <bkw@codingforce.com>","Chris Riley <criley@primedia.com>","David Carley <dacarley@gmail.com>","John Tobin <john@limelightmobileinc.com>","Kenton Gray <kentongray@gmail.com>","Felix B\xfcnemann <Felix.Buenemann@gmail.com>","Samy Al Zahrani <samyalzahrany@gmail.com>","Chintan Thakkar <lemnisk8@gmail.com>","F. Orlando Galashan <frulo@gmx.de>","Kleis Auke Wolthuizen <info@kleisauke.nl>","Matt Hirsch <mhirsch@media.mit.edu>","Matthias Thoemmes <thoemmes@gmail.com>","Patrick Paskaris <patrick@paskaris.gr>","J\xe9r\xe9my Lal <kapouer@melix.org>","Rahul Nanwani <r.nanwani@gmail.com>","Alice Monday <alice0meta@gmail.com>","Kristo Jorgenson <kristo.jorgenson@gmail.com>","YvesBos <yves_bos@outlook.com>","Guy Maliar <guy@tailorbrands.com>","Nicolas Coden <nicolas@ncoden.fr>","Matt Parrish <matt.r.parrish@gmail.com>","Marcel Bretschneider <marcel.bretschneider@gmail.com>","Matthew McEachen <matthew+github@mceachen.org>","Jarda Kot\u011B\u0161ovec <jarda.kotesovec@gmail.com>","Kenric D\'Souza <kenric.dsouza@gmail.com>","Oleh Aleinyk <oleg.aleynik@gmail.com>","Marcel Bretschneider <marcel.bretschneider@gmail.com>","Andrea Bianco <andrea.bianco@unibas.ch>","Rik Heywood <rik@rik.org>","Thomas Parisot <hi@oncletom.io>","Nathan Graves <nathanrgraves+github@gmail.com>","Tom Lokhorst <tom@lokhorst.eu>","Espen Hovlandsdal <espen@hovlandsdal.com>","Sylvain Dumont <sylvain.dumont35@gmail.com>","Alun Davies <alun.owain.davies@googlemail.com>","Aidan Hoolachan <ajhoolachan21@gmail.com>","Axel Eirola <axel.eirola@iki.fi>","Freezy <freezy@xbmc.org>","Daiz <taneli.vatanen@gmail.com>","Julian Aubourg <j@ubourg.net>","Keith Belovay <keith@picthrive.com>","Michael B. Klein <mbklein@gmail.com>","Jordan Prudhomme <jordan@raboland.fr>","Ilya Ovdin <iovdin@gmail.com>","Andargor <andargor@yahoo.com>","Paul Neave <paul.neave@gmail.com>","Brendan Kennedy <brenwken@gmail.com>","Brychan Bennett-Odlum <git@brychan.io>","Edward Silverton <e.silverton@gmail.com>","Roman Malieiev <aromaleev@gmail.com>","Tomas Szabo <tomas.szabo@deftomat.com>","Robert O\'Rourke <robert@o-rourke.org>","Guillermo Alfonso Varela Chouci\xf1o <guillevch@gmail.com>","Christian Flintrup <chr@gigahost.dk>","Manan Jadhav <manan@motionden.com>","Leon Radley <leon@radley.se>","alza54 <alza54@thiocod.in>","Jacob Smith <jacob@frende.me>","Michael Nutt <michael@nutt.im>","Brad Parham <baparham@gmail.com>","Taneli Vatanen <taneli.vatanen@gmail.com>","Joris Dugu\xe9 <zaruike10@gmail.com>","Chris Banks <christopher.bradley.banks@gmail.com>","Ompal Singh <ompal.hitm09@gmail.com>","Brodan <christopher.hranj@gmail.com","Ankur Parihar <ankur.github@gmail.com>","Brahim Ait elhaj <brahima@gmail.com>","Mart Jansink <m.jansink@gmail.com>"],"scripts":{"install":"(node install/libvips && node install/dll-copy && prebuild-install) || (node install/can-compile && node-gyp rebuild && node install/dll-copy)","clean":"rm -rf node_modules/ build/ vendor/ .nyc_output/ coverage/ test/fixtures/output.*","test":"npm run test-lint && npm run test-unit && npm run test-licensing","test-lint":"semistandard && cpplint","test-unit":"nyc --reporter=lcov --reporter=text --check-coverage --branches=100 mocha","test-licensing":"license-checker --production --summary --onlyAllow=\\"Apache-2.0;BSD;ISC;MIT\\"","test-leak":"./test/leak/leak.sh","docs-build":"documentation lint lib && node docs/build && node docs/search-index/build","docs-serve":"cd docs && npx serve","docs-publish":"cd docs && npx firebase-tools deploy --project pixelplumbing --only hosting:pixelplumbing-sharp"},"main":"lib/index.js","files":["binding.gyp","install/**","lib/**","src/**"],"repository":{"type":"git","url":"git://github.com/lovell/sharp"},"keywords":["jpeg","png","webp","avif","tiff","gif","svg","jp2","dzi","image","resize","thumbnail","crop","embed","libvips","vips"],"dependencies":{"color":"^4.2.3","detect-libc":"^2.0.1","node-addon-api":"^5.0.0","prebuild-install":"^7.1.1","semver":"^7.3.8","simple-get":"^4.0.1","tar-fs":"^2.1.1","tunnel-agent":"^0.6.0"},"devDependencies":{"async":"^3.2.4","cc":"^3.0.1","documentation":"^14.0.1","exif-reader":"^1.0.3","extract-zip":"^2.0.1","icc":"^2.0.0","license-checker":"^25.0.1","mocha":"^10.2.0","mock-fs":"^5.2.0","nyc":"^15.1.0","prebuild":"^11.0.4","rimraf":"^3.0.2","semistandard":"^16.0.1"},"license":"Apache-2.0","config":{"libvips":"8.13.3","integrity":{"darwin-arm64v8":"sha512-xFgYt7CtQSZcWoyUdzPTDNHbioZIrZSEU+gkMxzH4Cgjhi4/N49UsonnIZhKQoTBGloAqEexHeMx4rYTQ2Kgvw==","darwin-x64":"sha512-6SivWKzu15aUMMohe0wg7sNYMPETVnOe40BuWsnKOgzl3o5FpQqNSgs+68Mi8Za3Qti9/DaR+H/fyD0x48Af2w==","linux-arm64v8":"sha512-b+iI9V/ehgDabXYRQcvqa5CEysh+1FQsgFmYc358StCrJCDahwNmsQdsiH1GOVd5WaWh5wHUGByPwMmFOO16Aw==","linux-armv6":"sha512-zRP2F+EiustLE4bXSH8AHCxwfemh9d+QuvmPjira/HL6uJOUuA7SyQgVV1TPwTQle2ioCNnKPm7FEB/MAiT+ug==","linux-armv7":"sha512-6OCChowE5lBXXXAZrnGdA9dVktg7UdODEBpE5qTroiAJYZv4yXRMgyDFYajok7du2NTgoklhxGk8d9+4vGv5hg==","linux-x64":"sha512-OTmlmP2r8ozGKdB96X+K5oQE1ojVZanqLqqKlwDpEnfixyIaDGYbVzcjWBNGU3ai/26bvkaCkjynnc2ecYcsuA==","linuxmusl-arm64v8":"sha512-Qh5Wi+bkKTohFYHzSPssfjMhIkD6z6EHbVmnwmWSsgY9zsUBStFp6+mKcNTQfP5YM5Mz06vJOkLHX2OzEr5TzA==","linuxmusl-x64":"sha512-DwB4Fs3+ISw9etaLCANkueZDdk758iOS+wNp4TKZkHdq0al6B/3Pk7OHLR8a9E3H6wYDD328u++dcJzip5tacA==","win32-arm64v8":"sha512-96r3W+O4BtX602B1MtxU5Ru4lKzRRTZqM4OQEBJ//TNL3fiCZdd9agD+RQBjaeR4KFIyBSt3F7IE425ZWmxz+w==","win32-ia32":"sha512-qfN1MsfQGek1QQd1UNW7JT+5K5Ne1suFQ2GpgpYm3JLSpIve/tz2vOGEGzvTVssOBADJvAkTDFt+yIi3PgU9pA==","win32-x64":"sha512-eb3aAmjbVVBVRbiYgebQwoxkAt69WI8nwmKlilSQ3kWqoc0pXfIe322rF2UR8ebbISCGvYRUfzD2r1k92RXISQ=="},"runtime":"napi","target":7},"engines":{"node":">=14.15.0"},"funding":{"url":"https://opencollective.com/libvips"},"binary":{"napi_versions":[7]},"semistandard":{"env":["mocha"]},"cc":{"linelength":"120","filter":["build/include"]}}');


var $58c64867bb1128b4$require$config = $e16b344c5271525f$exports.config;
const $58c64867bb1128b4$var$env = {};
const $58c64867bb1128b4$var$minimumLibvipsVersionLabelled = $58c64867bb1128b4$var$env.npm_package_config_libvips || /* istanbul ignore next */ $58c64867bb1128b4$require$config.libvips;
const $58c64867bb1128b4$var$minimumLibvipsVersion = $661e4716f4f8a4b6$exports($58c64867bb1128b4$var$minimumLibvipsVersionLabelled).version;
const $58c64867bb1128b4$var$spawnSyncOptions = {
    encoding: "utf8",
    shell: true
};
const $58c64867bb1128b4$var$vendorPath = $822d81f77a1c47fb$exports.join($58c64867bb1128b4$var$__dirname, "..", "vendor", $58c64867bb1128b4$var$minimumLibvipsVersion, $dbb0c9ebf41e629d$exports());
const $58c64867bb1128b4$var$mkdirSync = function(dirPath) {
    try {
        $d770782c5b96d634$exports.mkdirSync(dirPath, {
            recursive: true
        });
    } catch (err) {
        /* istanbul ignore next */ if (err.code !== "EEXIST") throw err;
    }
};
const $58c64867bb1128b4$var$cachePath = function() {
    const npmCachePath = $58c64867bb1128b4$var$env.npm_config_cache || /* istanbul ignore next */ ($58c64867bb1128b4$var$env.APPDATA ? $822d81f77a1c47fb$exports.join($58c64867bb1128b4$var$env.APPDATA, "npm-cache") : $822d81f77a1c47fb$exports.join($9ac112f9d1f14f1d$export$c1d46b5ea6262c0b(), ".npm"));
    $58c64867bb1128b4$var$mkdirSync(npmCachePath);
    const libvipsCachePath = $822d81f77a1c47fb$exports.join(npmCachePath, "_libvips");
    $58c64867bb1128b4$var$mkdirSync(libvipsCachePath);
    return libvipsCachePath;
};
const $58c64867bb1128b4$var$integrity = function(platformAndArch) {
    return $58c64867bb1128b4$var$env[`npm_package_config_integrity_${platformAndArch.replace("-", "_")}`] || $58c64867bb1128b4$require$config.integrity[platformAndArch];
};
const $58c64867bb1128b4$var$log = function(item) {
    if (item instanceof Error) console.error(`sharp: Installation error: ${item.message}`);
    else console.log(`sharp: ${item}`);
};
const $58c64867bb1128b4$var$isRosetta = function() {
    /* istanbul ignore next */ if ($4Ydn9.platform === "darwin" && $4Ydn9.arch === "x64") {
        const translated = $58c64867bb1128b4$require$spawnSync("sysctl sysctl.proc_translated", $58c64867bb1128b4$var$spawnSyncOptions).stdout;
        return (translated || "").trim() === "sysctl.proc_translated: 1";
    }
    return false;
};
const $58c64867bb1128b4$var$globalLibvipsVersion = function() {
    if ($4Ydn9.platform !== "win32") {
        const globalLibvipsVersion = $58c64867bb1128b4$require$spawnSync("pkg-config --modversion vips-cpp", {
            ...$58c64867bb1128b4$var$spawnSyncOptions,
            env: {
                ...$58c64867bb1128b4$var$env,
                PKG_CONFIG_PATH: $58c64867bb1128b4$var$pkgConfigPath()
            }
        }).stdout;
        /* istanbul ignore next */ return (globalLibvipsVersion || "").trim();
    } else return "";
};
const $58c64867bb1128b4$var$hasVendoredLibvips = function() {
    return $d770782c5b96d634$exports.existsSync($58c64867bb1128b4$var$vendorPath);
};
/* istanbul ignore next */ const $58c64867bb1128b4$var$removeVendoredLibvips = function() {
    const rm = $d770782c5b96d634$exports.rmSync ? $d770782c5b96d634$exports.rmSync : $d770782c5b96d634$exports.rmdirSync;
    rm($58c64867bb1128b4$var$vendorPath, {
        recursive: true,
        maxRetries: 3,
        force: true
    });
};
/* istanbul ignore next */ const $58c64867bb1128b4$var$pkgConfigPath = function() {
    if ($4Ydn9.platform !== "win32") {
        const brewPkgConfigPath = $58c64867bb1128b4$require$spawnSync('which brew >/dev/null 2>&1 && brew environment --plain | grep PKG_CONFIG_LIBDIR | cut -d" " -f2', $58c64867bb1128b4$var$spawnSyncOptions).stdout || "";
        return [
            brewPkgConfigPath.trim(),
            $58c64867bb1128b4$var$env.PKG_CONFIG_PATH,
            "/usr/local/lib/pkgconfig",
            "/usr/lib/pkgconfig",
            "/usr/local/libdata/pkgconfig",
            "/usr/libdata/pkgconfig"
        ].filter(Boolean).join(":");
    } else return "";
};
const $58c64867bb1128b4$var$useGlobalLibvips = function() {
    if (Boolean($58c64867bb1128b4$var$env.SHARP_IGNORE_GLOBAL_LIBVIPS) === true) return false;
    /* istanbul ignore next */ if ($58c64867bb1128b4$var$isRosetta()) return false;
    const globalVipsVersion = $58c64867bb1128b4$var$globalLibvipsVersion();
    return !!globalVipsVersion && /* istanbul ignore next */ $c1ce76c3004fdbd4$exports(globalVipsVersion, $58c64867bb1128b4$var$minimumLibvipsVersion);
};
$58c64867bb1128b4$exports = {
    minimumLibvipsVersion: $58c64867bb1128b4$var$minimumLibvipsVersion,
    minimumLibvipsVersionLabelled: $58c64867bb1128b4$var$minimumLibvipsVersionLabelled,
    cachePath: $58c64867bb1128b4$var$cachePath,
    integrity: $58c64867bb1128b4$var$integrity,
    log: $58c64867bb1128b4$var$log,
    globalLibvipsVersion: $58c64867bb1128b4$var$globalLibvipsVersion,
    hasVendoredLibvips: $58c64867bb1128b4$var$hasVendoredLibvips,
    removeVendoredLibvips: $58c64867bb1128b4$var$removeVendoredLibvips,
    pkgConfigPath: $58c64867bb1128b4$var$pkgConfigPath,
    useGlobalLibvips: $58c64867bb1128b4$var$useGlobalLibvips,
    mkdirSync: $58c64867bb1128b4$var$mkdirSync
};


if (document.querySelector("[data-parallax-el]") && window.innerWidth >= 1025) {
    const parallaxContainer = document.querySelectorAll("[data-parallax-el]");
    parallaxContainer.forEach((elem)=>{
        let parallaxInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($b5be3fbf97127d69$exports)))(elem);
        parallaxInstance.enable();
    });
}
if (document.querySelector("[data-duplicate]")) {
    const originalArr = document.querySelectorAll("[data-original]");
    const duplicateArr = document.querySelectorAll("[data-duplicate]");
    originalArr.forEach((originalElement)=>{
        const originalValue = originalElement.dataset.original;
        duplicateArr.forEach((duplicateElement)=>{
            const duplicateValue = duplicateElement.dataset.duplicate;
            if (originalValue === duplicateValue) duplicateElement.textContent = originalElement.textContent;
        });
    });
}
if (document.querySelector("[data-splitting]")) {
    const splittingArr = document.querySelectorAll("[data-splitting]");
    splittingArr.forEach((item, i)=>{
        if (item.hasAttribute("data-splitting-char") === true) {
            const splitting = Splitting({
                target: item
            });
        } else {
            const splitting = Splitting({
                target: item,
                by: "words"
            });
        }
    });
}
window.initTilt = function initTilt1() {
    if (document.querySelector("[data-tilt-init]") && window.innerWidth > 1024) {
        const tiltInitItemsArr = document.querySelectorAll("[data-tilt-init]");
        tiltInitItemsArr.forEach((item)=>{
            VanillaTilt.init(item, {
                max: 7,
                speed: 500
            });
        });
    }
};
initTilt();
if (document.getElementsByClassName("aura-card") && window.innerWidth > 551) {
    const page = document.querySelector("#site");
    const header = document.querySelector("header");
    const headerBurger = document.querySelector(".header .burger");
    const auraContainers = document.querySelectorAll(".aura-container");
    if (window.innerWidth > 1025) auraContainers.forEach((container)=>{
        const auraCursor = container.querySelector(".cursor-aura");
        const auraCursorWidth = auraCursor.offsetWidth;
        const auraCursorHeight = auraCursor.offsetHeight;
        const initLeft = parseFloat(getComputedStyle(auraCursor).left);
        const initTop = parseFloat(getComputedStyle(auraCursor).top);
        function cursorAuraLogic(e) {
            auraCursor.classList.add("active");
            const rect = container.getBoundingClientRect();
            let x = e.clientX - rect.left - auraCursorWidth / 1.85;
            let y = e.clientY - rect.top - auraCursorHeight / 1.95;
            const currentLeft = parseFloat(getComputedStyle(auraCursor).left);
            const currentTop = parseFloat(getComputedStyle(auraCursor).top);
            x -= currentLeft;
            y -= currentTop;
            requestAnimationFrame(()=>{
                auraCursor.style.left = 0;
                auraCursor.style.top = 0;
                auraCursor.style.transform = `translate(${x}px, ${y}px)`;
            });
        }
        function cursorAuraLeaveLogic() {
            auraCursor.classList.remove("active");
            auraCursor.style.left = `${initLeft}px`;
            auraCursor.style.top = `${initTop}px`;
            auraCursor.style.transform = `translate(0, 0)`;
        }
        container.addEventListener("mousemove", (e)=>{
            auraCursor.classList.add("is-init");
            cursorAuraLogic(e);
        });
        container.addEventListener("mouseleave", (event)=>{
            const nextElement = document.elementFromPoint(event.clientX, event.clientY);
            if (header.contains(nextElement)) return;
            cursorAuraLeaveLogic();
        });
        if (header) {
            header.addEventListener("mousemove", (e)=>{
                if (!header.classList.contains("open-menu")) {
                    auraCursor.classList.add("is-init");
                    cursorAuraLogic(e);
                }
            });
            header.addEventListener("mouseleave", (event)=>{
                const nextElement = document.elementFromPoint(event.clientX, event.clientY);
                console.log(nextElement);
                if (container.contains(nextElement)) {
                    console.log(123);
                    return;
                }
                cursorAuraLeaveLogic();
            });
            headerBurger.addEventListener("click", ()=>{
                cursorAuraLeaveLogic();
            });
        }
    /*window.addEventListener('DOMContentLoaded', (event) => {
        const isCursorOverElement = isCursorOverElementOnLoad(container);
        console.log(
          'Курсор на элементе при загрузке страницы:',
          isCursorOverElement
        );
        cursorAuraLogic(event);
      });*/ });
}
// job-descr cursoh hover
const $936dbd06c8961682$var$hoverItem = document.querySelector(".cursor-item");
const $936dbd06c8961682$var$circle = document.querySelector(".first-section__item-circle");
if ($936dbd06c8961682$var$hoverItem && $936dbd06c8961682$var$circle) {
    $936dbd06c8961682$var$hoverItem.addEventListener("mousemove", (e)=>{
        const rect = $936dbd06c8961682$var$hoverItem.getBoundingClientRect();
        const x = e.clientX - rect.left - 20;
        const y = e.clientY - rect.top - 15;
        $936dbd06c8961682$var$circle.style.display = "block";
        $936dbd06c8961682$var$circle.style.left = `${x}px`;
        $936dbd06c8961682$var$circle.style.top = `${y}px`;
    });
    $936dbd06c8961682$var$hoverItem.addEventListener("mouseleave", ()=>{
        $936dbd06c8961682$var$circle.style.display = "none";
    });
}


/**
 * Function to getPosition of element in DOM
 * **/ function $0d3ea76a08c19ef7$export$1690e12b840569b9(element) {
    var xPosition = 0;
    var yPosition = 0;
    while(element){
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }
    return {
        x: xPosition,
        y: yPosition
    };
}
function $0d3ea76a08c19ef7$export$eebd1d6b9908ac73(element, classname) {
    if (element.className.split(" ").indexOf(classname) >= 0) return true;
    return element.parentNode && $0d3ea76a08c19ef7$export$eebd1d6b9908ac73(element.parentNode, classname);
}
function $0d3ea76a08c19ef7$export$ff7f7c97cdce86e(arr, needle) {
    return arr.reduce((a, b)=>{
        return Math.abs(b - needle) < Math.abs(a - needle) ? b : a;
    });
}
const $0d3ea76a08c19ef7$export$ef7b59bbfcfa5534 = (defaultValue, callback, callAfterInit = false)=>{
    const proxyHandler = {
        set (obj, prop, value) {
            if (prop === "value") {
                obj[prop] = value;
                callback(value);
                return true;
            }
            return true;
        }
    };
    if (callAfterInit) callback(defaultValue);
    return new Proxy({
        value: defaultValue
    }, proxyHandler);
};


const $a502e768f184a449$export$7d21786059c86dc = ({ sidebar: sidebar, contentSticky: contentSticky, sidebarInnerSelector: sidebarInnerSelector = ".following-sidebar-inner", isHeaderCalc: // calc header height for top side gap
isHeaderCalc = false, gap: // gap on top and bottom of sticky sidebar
gap = 30 })=>{
    console.log(sidebar);
    const sidebarInner = sidebar.querySelector(sidebarInnerSelector);
    const sidebarBuffer = document.createElement("DIV");
    sidebarBuffer.classList.add("following-sidebar-buffer");
    sidebarInner.style.position = "sticky";
    const header = document.querySelector("header");
    sidebar.insertAdjacentElement("afterbegin", sidebarBuffer);
    const headerHeight = isHeaderCalc && header ? header.offsetHeight : 0;
    let lastScrollTop = 0;
    // if flag true === scrolling down else scrolling up
    let isScrollingDown = null;
    // if isSidebarHigherViewport true === sidebar is higher than viewport height
    let isSidebarHigherViewport = sidebarInner.getBoundingClientRect().height > window.innerHeight - headerHeight;
    function calcHeightOfSidebar(isScrollingDown) {
        const contentStickyTop = (0, $0d3ea76a08c19ef7$export$1690e12b840569b9)(contentSticky).y;
        const sidebarInnerTop = (0, $0d3ea76a08c19ef7$export$1690e12b840569b9)(sidebarInner).y;
        sidebarBuffer.style.height = `${sidebarInnerTop - contentStickyTop}px`;
        if (isScrollingDown) {
            // scroll down
            sidebarInner.style.top = "";
            sidebarInner.style.bottom = `${-headerHeight - gap + window.innerHeight - sidebarInner.getBoundingClientRect().height}px`;
        } else {
            // scroll up
            sidebarInner.style.bottom = "";
            sidebarInner.style.top = `${Math.min(window.innerHeight - sidebarInner.getBoundingClientRect().height, headerHeight) - gap}px`;
        }
        isSidebarHigherViewport = sidebarInner.getBoundingClientRect().height > window.innerHeight - headerHeight;
    }
    function resetSticky() {
        sidebarInner.style.bottom = "";
        sidebarInner.style.top = `${headerHeight + gap}px`;
        sidebarBuffer.style.height = "0";
    }
    if (!isSidebarHigherViewport) resetSticky();
    else calcHeightOfSidebar(false);
    window.addEventListener("scroll", function() {
        let st = window.scrollY || document.documentElement.scrollTop;
        if (!isSidebarHigherViewport) resetSticky();
        if (st > lastScrollTop && !isScrollingDown) {
            // scroll down
            calcHeightOfSidebar(isScrollingDown);
            isScrollingDown = true;
        } else if (st < lastScrollTop && isScrollingDown) {
            // scroll up
            calcHeightOfSidebar(isScrollingDown);
            isScrollingDown = false;
        }
        lastScrollTop = st <= 0 ? 0 : st;
    });
    const updateSidebar = ()=>{
        if (!isSidebarHigherViewport) resetSticky();
        calcHeightOfSidebar(true);
        calcHeightOfSidebar(false);
    };
    let windowWidth = window.innerWidth;
    window.addEventListener("resize", ()=>{
        if (windowWidth !== window.innerWidth) {
            windowWidth = window.innerWidth;
            updateSidebar();
        }
    });
};


if (document.querySelector(".job-search-section")) {
    const sidebar = document.querySelector("#sidebar");
    const contentSticky = document.querySelector("#content-sticky");
    const filtersBtn = document.querySelector(".filters-btn");
    const btnClose = sidebar.querySelector(".job-search-section__sidebar .btn-close");
    const contentResult = document.querySelector(".job-search-section__result-bg");
    const sidebarItemsArr = document.querySelectorAll(".job-search-section__sidebar-item.with-accordion");
    const searchButton = document.querySelector(".btn.sidebar-search");
    sidebarItemsArr.forEach((item, i)=>{
        item.addEventListener("click", ()=>{
            item.classList.toggle("active");
        });
    });
    if (sidebar && window.innerWidth >= 640) (0, $a502e768f184a449$export$7d21786059c86dc)({
        sidebar: sidebar,
        contentSticky: contentSticky
    });
    if (filtersBtn) {
        filtersBtn.addEventListener("click", ()=>{
            filtersBtn.classList.toggle("active");
            contentSticky.classList.toggle("active");
            contentResult.classList.toggle("active");
        });
        contentResult.addEventListener("click", ()=>{
            if (contentResult.classList.contains("active")) {
                filtersBtn.classList.remove("active");
                contentSticky.classList.remove("active");
                contentResult.classList.remove("active");
            }
        });
        btnClose.addEventListener("click", (e)=>{
            if (contentResult.classList.contains("active")) {
                e.preventDefault();
                filtersBtn.classList.remove("active");
                contentSticky.classList.remove("active");
                contentResult.classList.remove("active");
            }
        });
    }
    if (searchButton) searchButton.addEventListener("click", ()=>{
        filtersBtn.classList.remove("active");
        contentSticky.classList.remove("active");
        contentResult.classList.remove("active");
        sidebar.classList.remove("active");
    });
}
const $feb91ca644b68c12$var$btnShowHideArr = document.querySelectorAll(".btn-show-hide");
const $feb91ca644b68c12$var$showHideContentArr = document.querySelectorAll(".show-hide-content");
function $feb91ca644b68c12$var$itemCalcMaxHeight(item, content) {
    const children = Array.from(content.children);
    const totalHeight = children.reduce((acc, child)=>{
        const childHeight = child.offsetHeight;
        return acc + childHeight;
    }, 0);
    return totalHeight + 100;
}
$feb91ca644b68c12$var$showHideContentArr.forEach((content, i)=>{
    const items = content.querySelectorAll(".meta-checkbox");
    console.log(items);
    const maxVisibleItems = content.dataset.visible ? parseInt(content.dataset.visible) : 6;
    console.log(maxVisibleItems);
    items.forEach((item, index)=>{
        if (index > maxVisibleItems - 1) item.classList.add("is-hidden");
    });
    if (items.length > maxVisibleItems) {
        const btnShowHide = $feb91ca644b68c12$var$btnShowHideArr[i];
        if (btnShowHide) {
            btnShowHide.classList.add("is-visible");
            btnShowHide.addEventListener("click", ()=>{
                btnShowHide.classList.toggle("active");
                items.forEach((item, index)=>{
                    if (index > maxVisibleItems - 1) item.classList.toggle("is-hidden");
                });
                content.parentElement.style.maxHeight = `${$feb91ca644b68c12$var$itemCalcMaxHeight(content.parentElement.parentElement, content.parentElement)}px`;
            });
        }
    }
});
if (document.getElementsByClassName("job-search-section__sidebar-accordion")[0]) {
    const jobsAccordionArr = document.querySelectorAll(".job-search-section__sidebar-accordion");
    jobsAccordionArr.forEach((jobsAccordion)=>{
        const jobsItemsArr = jobsAccordion.querySelectorAll(".job-search-section__sidebar-accordion-item");
        jobsItemsArr.forEach((item, i)=>{
            const btn = item.querySelector(".job-search-section__sidebar-accordion-item-top");
            const content = item.querySelector(".job-search-section__sidebar-accordion-item-content");
            /*item.addEventListener('click', (event) => {
        if (event.target !== btn) {
          openAccordion(item);
        } else if (event.target === btn && item.classList.contains('active')) {
          item.classList.remove('active');
        } else {
          openAccordion(item);
        }
      });*/ btn.addEventListener("click", ()=>{
                if (item.classList.contains("active")) item.classList.remove("active");
                else openAccordion(item);
            });
            function openAccordion(item) {
                // for (let j = 0; j < jobsItemsArr.length; j++) {
                //   jobsItemsArr[j].classList.remove('active');
                // }
                item.classList.add("active");
                content.style.maxHeight = `${$feb91ca644b68c12$var$itemCalcMaxHeight(item, content)}px`;
            }
        });
    });
}


var $ed5e59f538d5fd92$exports = {};
!function(e, t) {
    $ed5e59f538d5fd92$exports = t();
}($ed5e59f538d5fd92$exports, function() {
    return function() {
        "use strict";
        var e = {
            d: function(t, i) {
                for(var s in i)e.o(i, s) && !e.o(t, s) && Object.defineProperty(t, s, {
                    enumerable: !0,
                    get: i[s]
                });
            },
            o: function(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
        }, t = {};
        e.d(t, {
            default: function() {
                return R;
            }
        });
        var i = {
            days: "days",
            months: "months",
            years: "years",
            day: "day",
            month: "month",
            year: "year",
            eventChangeViewDate: "changeViewDate",
            eventChangeCurrentView: "changeCurrentView",
            eventChangeFocusDate: "changeFocusDate",
            eventChangeSelectedDate: "changeSelectedDate",
            eventChangeTime: "changeTime",
            eventChangeLastSelectedDate: "changeLastSelectedDate",
            actionSelectDate: "selectDate",
            actionUnselectDate: "unselectDate",
            cssClassWeekend: "-weekend-"
        }, s = {
            classes: "",
            inline: !1,
            locale: {
                days: [
                    "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
                    "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
                    "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
                    "\u0421\u0440\u0435\u0434\u0430",
                    "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
                    "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
                    "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
                ],
                daysShort: [
                    "\u0412\u043E\u0441",
                    "\u041F\u043E\u043D",
                    "\u0412\u0442\u043E",
                    "\u0421\u0440\u0435",
                    "\u0427\u0435\u0442",
                    "\u041F\u044F\u0442",
                    "\u0421\u0443\u0431"
                ],
                daysMin: [
                    "\u0412\u0441",
                    "\u041F\u043D",
                    "\u0412\u0442",
                    "\u0421\u0440",
                    "\u0427\u0442",
                    "\u041F\u0442",
                    "\u0421\u0431"
                ],
                months: [
                    "\u042F\u043D\u0432\u0430\u0440\u044C",
                    "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
                    "\u041C\u0430\u0440\u0442",
                    "\u0410\u043F\u0440\u0435\u043B\u044C",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D\u044C",
                    "\u0418\u044E\u043B\u044C",
                    "\u0410\u0432\u0433\u0443\u0441\u0442",
                    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
                    "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
                    "\u041D\u043E\u044F\u0431\u0440\u044C",
                    "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
                ],
                monthsShort: [
                    "\u042F\u043D\u0432",
                    "\u0424\u0435\u0432",
                    "\u041C\u0430\u0440",
                    "\u0410\u043F\u0440",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D",
                    "\u0418\u044E\u043B",
                    "\u0410\u0432\u0433",
                    "\u0421\u0435\u043D",
                    "\u041E\u043A\u0442",
                    "\u041D\u043E\u044F",
                    "\u0414\u0435\u043A"
                ],
                today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
                clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                dateFormat: "dd.MM.yyyy",
                timeFormat: "HH:mm",
                firstDay: 1
            },
            startDate: new Date,
            firstDay: "",
            weekends: [
                6,
                0
            ],
            dateFormat: "",
            altField: "",
            altFieldDateFormat: "T",
            toggleSelected: !0,
            keyboardNav: !0,
            selectedDates: !1,
            container: "",
            isMobile: !1,
            visible: !1,
            position: "bottom left",
            offset: 12,
            view: i.days,
            minView: i.days,
            showOtherMonths: !0,
            selectOtherMonths: !0,
            moveToOtherMonthsOnSelect: !0,
            showOtherYears: !0,
            selectOtherYears: !0,
            moveToOtherYearsOnSelect: !0,
            minDate: "",
            maxDate: "",
            disableNavWhenOutOfRange: !0,
            multipleDates: !1,
            multipleDatesSeparator: ", ",
            range: !1,
            dynamicRange: !0,
            buttons: !1,
            monthsField: "monthsShort",
            showEvent: "focus",
            autoClose: !1,
            fixedHeight: !1,
            prevHtml: '<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',
            nextHtml: '<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',
            navTitles: {
                days: "MMMM, <i>yyyy</i>",
                months: "yyyy",
                years: "yyyy1 - yyyy2"
            },
            timepicker: !1,
            onlyTimepicker: !1,
            dateTimeSeparator: " ",
            timeFormat: "",
            minHours: 0,
            maxHours: 24,
            minMinutes: 0,
            maxMinutes: 59,
            hoursStep: 1,
            minutesStep: 1,
            onSelect: !1,
            onChangeViewDate: !1,
            onChangeView: !1,
            onRenderCell: !1,
            onShow: !1,
            onHide: !1,
            onClickDayName: !1
        };
        function a(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
            return "string" == typeof e ? t.querySelector(e) : e;
        }
        function n() {
            let { tagName: e = "div", className: t = "", innerHtml: i = "", id: s = "", attrs: a = {} } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = document.createElement(e);
            return t && n.classList.add(...t.split(" ")), s && (n.id = s), i && (n.innerHTML = i), a && r(n, a), n;
        }
        function r(e, t) {
            for (let [i, s] of Object.entries(t))void 0 !== s && e.setAttribute(i, s);
            return e;
        }
        function o(e) {
            return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
        }
        function h(e) {
            let t = e.getHours(), { hours: i, dayPeriod: s } = l(t);
            return {
                year: e.getFullYear(),
                month: e.getMonth(),
                fullMonth: e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1,
                date: e.getDate(),
                fullDate: e.getDate() < 10 ? "0" + e.getDate() : e.getDate(),
                day: e.getDay(),
                hours: t,
                fullHours: d(t),
                hours12: i,
                dayPeriod: s,
                fullHours12: d(i),
                minutes: e.getMinutes(),
                fullMinutes: e.getMinutes() < 10 ? "0" + e.getMinutes() : e.getMinutes()
            };
        }
        function l(e) {
            return {
                dayPeriod: e > 11 ? "pm" : "am",
                hours: e % 12 == 0 ? 12 : e % 12
            };
        }
        function d(e) {
            return e < 10 ? "0" + e : e;
        }
        function c(e) {
            let t = 10 * Math.floor(e.getFullYear() / 10);
            return [
                t,
                t + 9
            ];
        }
        function u() {
            let e = [];
            for(var t = arguments.length, i = new Array(t), s = 0; s < t; s++)i[s] = arguments[s];
            return i.forEach((t)=>{
                if ("object" == typeof t) for(let i in t)t[i] && e.push(i);
                else t && e.push(t);
            }), e.join(" ");
        }
        function p(e, t) {
            let s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.days;
            if (!e || !t) return !1;
            let a = h(e), n = h(t);
            return ({
                [i.days]: a.date === n.date && a.month === n.month && a.year === n.year,
                [i.months]: a.month === n.month && a.year === n.year,
                [i.years]: a.year === n.year
            })[s];
        }
        function m(e, t, i) {
            let s = g(e, !1).getTime(), a = g(t, !1).getTime();
            return i ? s >= a : s > a;
        }
        function v(e, t) {
            return !m(e, t, !0);
        }
        function g(e) {
            let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = new Date(e.getTime());
            return "boolean" != typeof t || t || function(e) {
                e.setHours(0, 0, 0, 0);
            }(i), i;
        }
        function D(e, t, i) {
            e.length ? e.forEach((e)=>{
                e.addEventListener(t, i);
            }) : e.addEventListener(t, i);
        }
        function y(e, t) {
            return !(!e || e === document || e instanceof DocumentFragment) && (e.matches(t) ? e : y(e.parentNode, t));
        }
        function f(e, t, i) {
            return e > i ? i : e < t ? t : e;
        }
        function w(e) {
            for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
            return i.filter((e)=>e).forEach((t)=>{
                for (let [i, s] of Object.entries(t))if (void 0 !== s && "[object Object]" === s.toString()) {
                    let t = void 0 !== e[i] ? e[i].toString() : void 0, a = s.toString(), n = Array.isArray(s) ? [] : {};
                    e[i] = e[i] ? t !== a ? n : e[i] : n, w(e[i], s);
                } else e[i] = s;
            }), e;
        }
        function b(e) {
            let t = e;
            return e instanceof Date || ("string" == typeof e && /^\d{4}-\d{2}-\d{2}$/.test(e) && (e += "T00:00:00"), t = new Date(e)), isNaN(t.getTime()) && (console.log(`Unable to convert value "${e}" to Date object`), t = !1), t;
        }
        function k(e) {
            let t = "\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";
            return new RegExp("(^|>|" + t + ")(" + e + ")($|<|" + t + ")", "g");
        }
        function $(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class C {
            constructor(){
                let { type: e, date: t, dp: i, opts: s, body: a } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                $(this, "focus", ()=>{
                    this.$cell.classList.add("-focus-"), this.focused = !0;
                }), $(this, "removeFocus", ()=>{
                    this.$cell.classList.remove("-focus-"), this.focused = !1;
                }), $(this, "select", ()=>{
                    this.$cell.classList.add("-selected-"), this.selected = !0;
                }), $(this, "removeSelect", ()=>{
                    this.$cell.classList.remove("-selected-", "-range-from-", "-range-to-"), this.selected = !1;
                }), $(this, "onChangeSelectedDate", ()=>{
                    this.isDisabled || (this._handleSelectedStatus(), this.opts.range && this._handleRangeStatus());
                }), $(this, "onChangeFocusDate", (e)=>{
                    if (!e) return void (this.focused && this.removeFocus());
                    let t = p(e, this.date, this.type);
                    t ? this.focus() : !t && this.focused && this.removeFocus(), this.opts.range && this._handleRangeStatus();
                }), $(this, "render", ()=>(this.$cell.innerHTML = this._getHtml(), this._handleClasses(), this.$cell)), this.type = e, this.singleType = this.type.slice(0, -1), this.date = t, this.dp = i, this.opts = s, this.body = a, this.customData = !1, this.init();
            }
            init() {
                var e;
                let { onRenderCell: t } = this.opts;
                t && (this.customData = t({
                    date: this.date,
                    cellType: this.singleType,
                    datepicker: this.dp
                })), this._createElement(), this._bindDatepickerEvents(), null !== (e = this.customData) && void 0 !== e && e.disabled && this.dp.disableDate(this.date);
            }
            _bindDatepickerEvents() {
                this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeFocusDate, this.onChangeFocusDate);
            }
            unbindDatepickerEvents() {
                this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeFocusDate, this.onChangeFocusDate);
            }
            _createElement() {
                var e;
                let { year: t, month: i, date: s } = h(this.date), a = (null === (e = this.customData) || void 0 === e ? void 0 : e.attrs) || {};
                this.$cell = n({
                    attrs: {
                        "data-year": t,
                        "data-month": i,
                        "data-date": s,
                        ...a
                    }
                }), this.$cell.adpCell = this;
            }
            _getClassName() {
                var e;
                let t = new Date, { selectOtherMonths: s, selectOtherYears: a } = this.opts, { minDate: n, maxDate: r, isDateDisabled: o } = this.dp, { day: l } = h(this.date), d = this._isOutOfMinMaxRange(), c = o(this.date), m = u("air-datepicker-cell", `-${this.singleType}-`, {
                    "-current-": p(t, this.date, this.type),
                    "-min-date-": n && p(n, this.date, this.type),
                    "-max-date-": r && p(r, this.date, this.type)
                }), v = "";
                switch(this.type){
                    case i.days:
                        v = u({
                            "-weekend-": this.dp.isWeekend(l),
                            "-other-month-": this.isOtherMonth,
                            "-disabled-": this.isOtherMonth && !s || d || c
                        });
                        break;
                    case i.months:
                        v = u({
                            "-disabled-": d
                        });
                        break;
                    case i.years:
                        v = u({
                            "-other-decade-": this.isOtherDecade,
                            "-disabled-": d || this.isOtherDecade && !a
                        });
                }
                return u(m, v, null === (e = this.customData) || void 0 === e ? void 0 : e.classes).split(" ");
            }
            _getHtml() {
                var e;
                let { year: t, month: s, date: a } = h(this.date), { showOtherMonths: n, showOtherYears: r } = this.opts;
                if (null !== (e = this.customData) && void 0 !== e && e.html) return this.customData.html;
                switch(this.type){
                    case i.days:
                        return !n && this.isOtherMonth ? "" : a;
                    case i.months:
                        return this.dp.locale[this.opts.monthsField][s];
                    case i.years:
                        return !r && this.isOtherDecade ? "" : t;
                }
            }
            _isOutOfMinMaxRange() {
                let { minDate: e, maxDate: t } = this.dp, { type: s, date: a } = this, { month: n, year: r, date: o } = h(a), l = s === i.days, d = s === i.years, c = !!e && new Date(r, d ? e.getMonth() : n, l ? o : e.getDate()), u = !!t && new Date(r, d ? t.getMonth() : n, l ? o : t.getDate());
                return e && t ? v(c, e) || m(u, t) : e ? v(c, e) : t ? m(u, t) : void 0;
            }
            destroy() {
                this.unbindDatepickerEvents();
            }
            _handleRangeStatus() {
                const { selectedDates: e, focusDate: t, rangeDateTo: i, rangeDateFrom: s } = this.dp, a = e.length;
                if (!a) return;
                let n = s, r = i;
                if (1 === a && t) {
                    const i = m(t, e[0]);
                    n = i ? e[0] : t, r = i ? t : e[0];
                }
                let o = u({
                    "-in-range-": n && r && (h = this.date, l = n, d = r, m(h, l) && v(h, d)),
                    "-range-from-": n && p(this.date, n, this.type),
                    "-range-to-": r && p(this.date, r, this.type)
                });
                var h, l, d;
                this.$cell.classList.remove("-range-from-", "-range-to-", "-in-range-"), o && this.$cell.classList.add(...o.split(" "));
            }
            _handleSelectedStatus() {
                let e = this.dp._checkIfDateIsSelected(this.date, this.type);
                e ? this.select() : !e && this.selected && this.removeSelect();
            }
            _handleInitialFocusStatus() {
                p(this.dp.focusDate, this.date, this.type) && this.focus();
            }
            _handleClasses() {
                this.$cell.setAttribute("class", ""), this._handleInitialFocusStatus(), this.dp.hasSelectedDates && (this._handleSelectedStatus(), this.dp.opts.range && this._handleRangeStatus()), this.$cell.classList.add(...this._getClassName());
            }
            get isDisabled() {
                return this.$cell.matches(".-disabled-");
            }
            get isOtherMonth() {
                return this.dp.isOtherMonth(this.date);
            }
            get isOtherDecade() {
                return this.dp.isOtherDecade(this.date);
            }
        }
        function _(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        let M = {
            [i.days]: `<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -${i.days}-"></div>`,
            [i.months]: `<div class="air-datepicker-body--cells -${i.months}-"></div>`,
            [i.years]: `<div class="air-datepicker-body--cells -${i.years}-"></div>`
        };
        const S = ".air-datepicker-cell";
        class T {
            constructor(e){
                let { dp: t, type: s, opts: a } = e;
                _(this, "handleClick", (e)=>{
                    let t = e.target.closest(S).adpCell;
                    if (t.isDisabled) return;
                    if (!this.dp.isMinViewReached) return void this.dp.down();
                    let i = this.dp._checkIfDateIsSelected(t.date, t.type);
                    i ? this.dp._handleAlreadySelectedDates(i, t.date) : this.dp.selectDate(t.date);
                }), _(this, "handleDayNameClick", (e)=>{
                    let t = e.target.getAttribute("data-day-index");
                    this.opts.onClickDayName({
                        dayIndex: Number(t),
                        datepicker: this.dp
                    });
                }), _(this, "onChangeCurrentView", (e)=>{
                    e !== this.type ? this.hide() : (this.show(), this.render());
                }), _(this, "onMouseOverCell", (e)=>{
                    let t = y(e.target, S);
                    this.dp.setFocusDate(!!t && t.adpCell.date);
                }), _(this, "onMouseOutCell", ()=>{
                    this.dp.setFocusDate(!1);
                }), _(this, "onClickBody", (e)=>{
                    let { onClickDayName: t } = this.opts, i = e.target;
                    i.closest(S) && this.handleClick(e), t && i.closest(".air-datepicker-body--day-name") && this.handleDayNameClick(e);
                }), _(this, "onMouseDown", (e)=>{
                    this.pressed = !0;
                    let t = y(e.target, S), i = t && t.adpCell;
                    p(i.date, this.dp.rangeDateFrom) && (this.rangeFromFocused = !0), p(i.date, this.dp.rangeDateTo) && (this.rangeToFocused = !0);
                }), _(this, "onMouseMove", (e)=>{
                    if (!this.pressed || !this.dp.isMinViewReached) return;
                    e.preventDefault();
                    let t = y(e.target, S), i = t && t.adpCell, { selectedDates: s, rangeDateTo: a, rangeDateFrom: n } = this.dp;
                    if (!i || i.isDisabled) return;
                    let { date: r } = i;
                    if (2 === s.length) {
                        if (this.rangeFromFocused && !m(r, a)) {
                            let { hours: e, minutes: t } = h(n);
                            r.setHours(e), r.setMinutes(t), this.dp.rangeDateFrom = r, this.dp.replaceDate(n, r);
                        }
                        if (this.rangeToFocused && !v(r, n)) {
                            let { hours: e, minutes: t } = h(a);
                            r.setHours(e), r.setMinutes(t), this.dp.rangeDateTo = r, this.dp.replaceDate(a, r);
                        }
                    }
                }), _(this, "onMouseUp", ()=>{
                    this.pressed = !1, this.rangeFromFocused = !1, this.rangeToFocused = !1;
                }), _(this, "onChangeViewDate", (e, t)=>{
                    if (!this.isVisible) return;
                    let s = c(e), a = c(t);
                    switch(this.dp.currentView){
                        case i.days:
                            if (p(e, t, i.months)) return;
                            break;
                        case i.months:
                            if (p(e, t, i.years)) return;
                            break;
                        case i.years:
                            if (s[0] === a[0] && s[1] === a[1]) return;
                    }
                    this.render();
                }), _(this, "render", ()=>{
                    this.destroyCells(), this._generateCells(), this.cells.forEach((e)=>{
                        this.$cells.appendChild(e.render());
                    });
                }), this.dp = t, this.type = s, this.opts = a, this.cells = [], this.$el = "", this.pressed = !1, this.isVisible = !0, this.init();
            }
            init() {
                this._buildBaseHtml(), this.type === i.days && this.renderDayNames(), this.render(), this._bindEvents(), this._bindDatepickerEvents();
            }
            _bindEvents() {
                let { range: e, dynamicRange: t } = this.opts;
                D(this.$el, "mouseover", this.onMouseOverCell), D(this.$el, "mouseout", this.onMouseOutCell), D(this.$el, "click", this.onClickBody), e && t && (D(this.$el, "mousedown", this.onMouseDown), D(this.$el, "mousemove", this.onMouseMove), D(window.document, "mouseup", this.onMouseUp));
            }
            _bindDatepickerEvents() {
                this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView);
            }
            _buildBaseHtml() {
                this.$el = n({
                    className: `air-datepicker-body -${this.type}-`,
                    innerHtml: M[this.type]
                }), this.$names = a(".air-datepicker-body--day-names", this.$el), this.$cells = a(".air-datepicker-body--cells", this.$el);
            }
            _getDayNamesHtml() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.dp.locale.firstDay, t = "", s = this.dp.isWeekend, { onClickDayName: a } = this.opts, n = e, r = 0;
                for(; r < 7;){
                    let e = n % 7;
                    t += `<div class="${u("air-datepicker-body--day-name", {
                        [i.cssClassWeekend]: s(e),
                        "-clickable-": !!a
                    })}" data-day-index='${e}'>${this.dp.locale.daysMin[e]}</div>`, r++, n++;
                }
                return t;
            }
            renderDayNames() {
                this.$names.innerHTML = this._getDayNamesHtml();
            }
            _generateCell(e) {
                let { type: t, dp: i, opts: s } = this;
                return new C({
                    type: t,
                    dp: i,
                    opts: s,
                    date: e,
                    body: this
                });
            }
            _generateCells() {
                T.getDatesFunction(this.type)(this.dp, (e)=>{
                    this.cells.push(this._generateCell(e));
                });
            }
            show() {
                this.isVisible = !0, this.$el.classList.remove("-hidden-");
            }
            hide() {
                this.isVisible = !1, this.$el.classList.add("-hidden-");
            }
            destroyCells() {
                this.cells.forEach((e)=>e.destroy()), this.cells = [], this.$cells.innerHTML = "";
            }
            destroy() {
                this.destroyCells(), this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView);
            }
            static getDaysDates(e, t) {
                let { viewDate: i, opts: { fixedHeight: s }, locale: { firstDay: a } } = e, n = o(i), { year: r, month: l } = h(i), d = new Date(r, l, 1), c = new Date(r, l, n), u = d.getDay() - a, p = 6 - c.getDay() + a;
                u = u < 0 ? u + 7 : u, p = p > 6 ? p - 7 : p;
                let m = function(e, t) {
                    let { year: i, month: s, date: a } = h(e);
                    return new Date(i, s, a - t);
                }(d, u), v = n + u + p, g = m.getDate(), { year: D, month: y } = h(m), f = 0;
                s && (v = 42);
                const w = [];
                for(; f < v;){
                    let e = new Date(D, y, g + f);
                    t && t(e), w.push(e), f++;
                }
                return w;
            }
            static getMonthsDates(e, t) {
                let { year: i } = e.parsedViewDate, s = 0, a = [];
                for(; s < 12;){
                    const e = new Date(i, s);
                    a.push(e), t && t(e), s++;
                }
                return a;
            }
            static getYearsDates(e, t) {
                let i = c(e.viewDate), s = i[0] - 1, a = i[1] + 1, n = s, r = [];
                for(; n <= a;){
                    const e = new Date(n, 0);
                    r.push(e), t && t(e), n++;
                }
                return r;
            }
            static getDatesFunction() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                return ({
                    [i.days]: T.getDaysDates,
                    [i.months]: T.getMonthsDates,
                    [i.years]: T.getYearsDates
                })[e];
            }
        }
        function F(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class V {
            constructor(e){
                let { dp: t, opts: i } = e;
                F(this, "onClickNav", (e)=>{
                    let t = y(e.target, ".air-datepicker-nav--action");
                    if (!t) return;
                    let i = t.dataset.action;
                    this.dp[i]();
                }), F(this, "onChangeViewDate", ()=>{
                    this.render(), this._resetNavStatus(), this.handleNavStatus();
                }), F(this, "onChangeCurrentView", ()=>{
                    this.render(), this._resetNavStatus(), this.handleNavStatus();
                }), F(this, "onClickNavTitle", ()=>{
                    this.dp.isFinalView || this.dp.up();
                }), F(this, "update", ()=>{
                    let { prevHtml: e, nextHtml: t } = this.opts;
                    this.$prev.innerHTML = e, this.$next.innerHTML = t, this._resetNavStatus(), this.render(), this.handleNavStatus();
                }), F(this, "renderDelay", ()=>{
                    setTimeout(this.render);
                }), F(this, "render", ()=>{
                    this.$title.innerHTML = this._getTitle(), function(e, t) {
                        for(let i in t)t[i] ? e.classList.add(i) : e.classList.remove(i);
                    }(this.$title, {
                        "-disabled-": this.dp.isFinalView
                    });
                }), this.dp = t, this.opts = i, this.init();
            }
            init() {
                this._createElement(), this._buildBaseHtml(), this._defineDOM(), this.render(), this.handleNavStatus(), this._bindEvents(), this._bindDatepickerEvents();
            }
            _defineDOM() {
                this.$title = a(".air-datepicker-nav--title", this.$el), this.$prev = a('[data-action="prev"]', this.$el), this.$next = a('[data-action="next"]', this.$el);
            }
            _bindEvents() {
                this.$el.addEventListener("click", this.onClickNav), this.$title.addEventListener("click", this.onClickNavTitle);
            }
            _bindDatepickerEvents() {
                this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.on(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.on(i.eventChangeTime, this.render));
            }
            destroy() {
                this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.off(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.off(i.eventChangeTime, this.render));
            }
            _createElement() {
                this.$el = n({
                    tagName: "nav",
                    className: "air-datepicker-nav"
                });
            }
            _getTitle() {
                let { dp: e, opts: t } = this, i = t.navTitles[e.currentView];
                return "function" == typeof i ? i(e) : e.formatDate(e.viewDate, i);
            }
            handleNavStatus() {
                let { disableNavWhenOutOfRange: e } = this.opts, { minDate: t, maxDate: s } = this.dp;
                if (!t && !s || !e) return;
                let { year: a, month: n } = this.dp.parsedViewDate, r = !!t && h(t), o = !!s && h(s);
                switch(this.dp.currentView){
                    case i.days:
                        t && r.month >= n && r.year >= a && this._disableNav("prev"), s && o.month <= n && o.year <= a && this._disableNav("next");
                        break;
                    case i.months:
                        t && r.year >= a && this._disableNav("prev"), s && o.year <= a && this._disableNav("next");
                        break;
                    case i.years:
                        {
                            let e = c(this.dp.viewDate);
                            t && r.year >= e[0] && this._disableNav("prev"), s && o.year <= e[1] && this._disableNav("next");
                            break;
                        }
                }
            }
            _disableNav(e) {
                a('[data-action="' + e + '"]', this.$el).classList.add("-disabled-");
            }
            _resetNavStatus() {
                !function(e) {
                    for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
                    e.length ? e.forEach((e)=>{
                        e.classList.remove(...i);
                    }) : e.classList.remove(...i);
                }(this.$el.querySelectorAll(".air-datepicker-nav--action"), "-disabled-");
            }
            _buildBaseHtml() {
                let { prevHtml: e, nextHtml: t } = this.opts;
                this.$el.innerHTML = `<div class="air-datepicker-nav--action" data-action="prev">${e}</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">${t}</div>`;
            }
            get isNavIsFunction() {
                let { navTitles: e } = this.opts;
                return Object.keys(e).find((t)=>"function" == typeof e[t]);
            }
        }
        var x = {
            today: {
                content: (e)=>e.locale.today,
                onClick: (e)=>e.setViewDate(new Date)
            },
            clear: {
                content: (e)=>e.locale.clear,
                onClick: (e)=>e.clear()
            }
        };
        class H {
            constructor(e){
                let { dp: t, opts: i } = e;
                this.dp = t, this.opts = i, this.init();
            }
            init() {
                this.createElement(), this.render();
            }
            createElement() {
                this.$el = n({
                    className: "air-datepicker-buttons"
                });
            }
            destroy() {
                this.$el.parentNode.removeChild(this.$el);
            }
            clearHtml() {
                return this.$el.innerHTML = "", this;
            }
            generateButtons() {
                let { buttons: e } = this.opts;
                Array.isArray(e) || (e = [
                    e
                ]), e.forEach((e)=>{
                    let t = e;
                    "string" == typeof e && x[e] && (t = x[e]);
                    let i = this.createButton(t);
                    t.onClick && this.attachEventToButton(i, t.onClick), this.$el.appendChild(i);
                });
            }
            attachEventToButton(e, t) {
                e.addEventListener("click", ()=>{
                    t(this.dp);
                });
            }
            createButton(e) {
                let { content: t, className: i, tagName: s = "button", attrs: a = {} } = e;
                return n({
                    tagName: s,
                    innerHtml: `<span tabindex='-1'>${"function" == typeof t ? t(this.dp) : t}</span>`,
                    className: u("air-datepicker-button", i),
                    attrs: a
                });
            }
            render() {
                this.generateButtons();
            }
        }
        function E(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class L {
            constructor(){
                let { opts: e, dp: t } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                E(this, "toggleTimepickerIsActive", (e)=>{
                    this.dp.timepickerIsActive = e;
                }), E(this, "onChangeSelectedDate", (e)=>{
                    let { date: t, updateTime: i = !1 } = e;
                    t && (this.setMinMaxTime(t), this.setCurrentTime(!!i && t), this.addTimeToDate(t));
                }), E(this, "onChangeLastSelectedDate", (e)=>{
                    e && (this.setTime(e), this.render());
                }), E(this, "onChangeInputRange", (e)=>{
                    let t = e.target;
                    this[t.getAttribute("name")] = t.value, this.updateText(), this.dp.trigger(i.eventChangeTime, {
                        hours: this.hours,
                        minutes: this.minutes
                    });
                }), E(this, "onMouseEnterLeave", (e)=>{
                    let t = e.target.getAttribute("name"), i = this.$minutesText;
                    "hours" === t && (i = this.$hoursText), i.classList.toggle("-focus-");
                }), E(this, "onFocus", ()=>{
                    this.toggleTimepickerIsActive(!0);
                }), E(this, "onBlur", ()=>{
                    this.toggleTimepickerIsActive(!1);
                }), this.opts = e, this.dp = t;
                let { timeFormat: s } = this.dp.locale;
                s && (s.match(k("h")) || s.match(k("hh"))) && (this.ampm = !0), this.init();
            }
            init() {
                this.setTime(this.dp.lastSelectedDate || this.dp.viewDate), this.createElement(), this.buildHtml(), this.defineDOM(), this.render(), this.bindDatepickerEvents(), this.bindDOMEvents();
            }
            bindDatepickerEvents() {
                this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
            }
            bindDOMEvents() {
                let e = "input";
                navigator.userAgent.match(/trident/gi) && (e = "change"), D(this.$ranges, e, this.onChangeInputRange), D(this.$ranges, "mouseenter", this.onMouseEnterLeave), D(this.$ranges, "mouseleave", this.onMouseEnterLeave), D(this.$ranges, "focus", this.onFocus), D(this.$ranges, "mousedown", this.onFocus), D(this.$ranges, "blur", this.onBlur);
            }
            createElement() {
                this.$el = n({
                    className: u("air-datepicker-time", {
                        "-am-pm-": this.dp.ampm
                    })
                });
            }
            destroy() {
                this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate), this.$el.parentNode.removeChild(this.$el);
            }
            buildHtml() {
                let { ampm: e, hours: t, displayHours: i, minutes: s, minHours: a, minMinutes: n, maxHours: r, maxMinutes: o, dayPeriod: h, opts: { hoursStep: l, minutesStep: c } } = this;
                this.$el.innerHTML = `<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">${d(i)}</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">${d(s)}</span>   ` + (e ? `<span class='air-datepicker-time--current-ampm'>${h}</span>` : "") + '</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">' + `      <input type="range" name="hours" value="${t}" min="${a}" max="${r}" step="${l}"/>   </div>   <div class="air-datepicker-time--row">` + `      <input type="range" name="minutes" value="${s}" min="${n}" max="${o}" step="${c}"/>   </div></div>`;
            }
            defineDOM() {
                let e = (e)=>a(e, this.$el);
                this.$ranges = this.$el.querySelectorAll('[type="range"]'), this.$hours = e('[name="hours"]'), this.$minutes = e('[name="minutes"]'), this.$hoursText = e(".air-datepicker-time--current-hours"), this.$minutesText = e(".air-datepicker-time--current-minutes"), this.$ampm = e(".air-datepicker-time--current-ampm");
            }
            setTime(e) {
                this.setMinMaxTime(e), this.setCurrentTime(e);
            }
            addTimeToDate(e) {
                e && (e.setHours(this.hours), e.setMinutes(this.minutes));
            }
            setMinMaxTime(e) {
                if (this.setMinMaxTimeFromOptions(), e) {
                    let { minDate: t, maxDate: i } = this.dp;
                    t && p(e, t) && this.setMinTimeFromMinDate(t), i && p(e, i) && this.setMaxTimeFromMaxDate(i);
                }
            }
            setCurrentTime(e) {
                let { hours: t, minutes: i } = e ? h(e) : this;
                this.hours = f(t, this.minHours, this.maxHours), this.minutes = f(i, this.minMinutes, this.maxMinutes);
            }
            setMinMaxTimeFromOptions() {
                let { minHours: e, minMinutes: t, maxHours: i, maxMinutes: s } = this.opts;
                this.minHours = f(e, 0, 23), this.minMinutes = f(t, 0, 59), this.maxHours = f(i, 0, 23), this.maxMinutes = f(s, 0, 59);
            }
            setMinTimeFromMinDate(e) {
                let { lastSelectedDate: t } = this.dp;
                this.minHours = e.getHours(), t && t.getHours() > e.getHours() ? this.minMinutes = this.opts.minMinutes : this.minMinutes = e.getMinutes();
            }
            setMaxTimeFromMaxDate(e) {
                let { lastSelectedDate: t } = this.dp;
                this.maxHours = e.getHours(), t && t.getHours() < e.getHours() ? this.maxMinutes = this.opts.maxMinutes : this.maxMinutes = e.getMinutes();
            }
            updateSliders() {
                r(this.$hours, {
                    min: this.minHours,
                    max: this.maxHours
                }).value = this.hours, r(this.$minutes, {
                    min: this.minMinutes,
                    max: this.maxMinutes
                }).value = this.minutes;
            }
            updateText() {
                this.$hoursText.innerHTML = d(this.displayHours), this.$minutesText.innerHTML = d(this.minutes), this.ampm && (this.$ampm.innerHTML = this.dayPeriod);
            }
            set hours(e) {
                this._hours = e;
                let { hours: t, dayPeriod: i } = l(e);
                this.displayHours = this.ampm ? t : e, this.dayPeriod = i;
            }
            get hours() {
                return this._hours;
            }
            render() {
                this.updateSliders(), this.updateText();
            }
        }
        function O(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class A {
            constructor(e){
                let { dp: t, opts: i } = e;
                O(this, "pressedKeys", new Set), O(this, "hotKeys", new Map([
                    [
                        [
                            [
                                "Control",
                                "ArrowRight"
                            ],
                            [
                                "Control",
                                "ArrowUp"
                            ]
                        ],
                        (e)=>e.month++
                    ],
                    [
                        [
                            [
                                "Control",
                                "ArrowLeft"
                            ],
                            [
                                "Control",
                                "ArrowDown"
                            ]
                        ],
                        (e)=>e.month--
                    ],
                    [
                        [
                            [
                                "Shift",
                                "ArrowRight"
                            ],
                            [
                                "Shift",
                                "ArrowUp"
                            ]
                        ],
                        (e)=>e.year++
                    ],
                    [
                        [
                            [
                                "Shift",
                                "ArrowLeft"
                            ],
                            [
                                "Shift",
                                "ArrowDown"
                            ]
                        ],
                        (e)=>e.year--
                    ],
                    [
                        [
                            [
                                "Alt",
                                "ArrowRight"
                            ],
                            [
                                "Alt",
                                "ArrowUp"
                            ]
                        ],
                        (e)=>e.year += 10
                    ],
                    [
                        [
                            [
                                "Alt",
                                "ArrowLeft"
                            ],
                            [
                                "Alt",
                                "ArrowDown"
                            ]
                        ],
                        (e)=>e.year -= 10
                    ],
                    [
                        [
                            "Control",
                            "Shift",
                            "ArrowUp"
                        ],
                        (e, t)=>t.up()
                    ]
                ])), O(this, "handleHotKey", (e)=>{
                    let t = this.hotKeys.get(e), i = h(this.getInitialFocusDate());
                    t(i, this.dp);
                    let { year: s, month: a, date: n } = i, r = o(new Date(s, a));
                    r < n && (n = r);
                    let l = this.dp.getClampedDate(new Date(s, a, n));
                    this.dp.setFocusDate(l, {
                        viewDateTransition: !0
                    });
                }), O(this, "isHotKeyPressed", ()=>{
                    let e = !1, t = this.pressedKeys.size, i = (e)=>this.pressedKeys.has(e);
                    for (let [s] of this.hotKeys){
                        if (e) break;
                        if (Array.isArray(s[0])) s.forEach((a)=>{
                            e || t !== a.length || (e = a.every(i) && s);
                        });
                        else {
                            if (t !== s.length) continue;
                            e = s.every(i) && s;
                        }
                    }
                    return e;
                }), O(this, "isArrow", (e)=>e >= 37 && e <= 40), O(this, "onKeyDown", (e)=>{
                    let { key: t, which: i } = e, { dp: s, dp: { focusDate: a }, opts: n } = this;
                    this.registerKey(t);
                    let r = this.isHotKeyPressed();
                    if (r) return e.preventDefault(), void this.handleHotKey(r);
                    if (this.isArrow(i)) return e.preventDefault(), void this.focusNextCell(t);
                    if ("Enter" === t) {
                        if (s.currentView !== n.minView) return void s.down();
                        if (a) {
                            let e = s._checkIfDateIsSelected(a);
                            return void (e ? s._handleAlreadySelectedDates(e, a) : s.selectDate(a));
                        }
                    }
                    "Escape" === t && this.dp.hide();
                }), O(this, "onKeyUp", (e)=>{
                    this.removeKey(e.key);
                }), this.dp = t, this.opts = i, this.init();
            }
            init() {
                this.bindKeyboardEvents();
            }
            bindKeyboardEvents() {
                let { $el: e } = this.dp;
                e.addEventListener("keydown", this.onKeyDown), e.addEventListener("keyup", this.onKeyUp);
            }
            destroy() {
                let { $el: e } = this.dp;
                e.removeEventListener("keydown", this.onKeyDown), e.removeEventListener("keyup", this.onKeyUp), this.hotKeys = null, this.pressedKeys = null;
            }
            getInitialFocusDate() {
                let { focusDate: e, currentView: t, selectedDates: s, parsedViewDate: { year: a, month: n } } = this.dp, r = e || s[s.length - 1];
                if (!r) switch(t){
                    case i.days:
                        r = new Date(a, n, (new Date).getDate());
                        break;
                    case i.months:
                        r = new Date(a, n, 1);
                        break;
                    case i.years:
                        r = new Date(a, 0, 1);
                }
                return r;
            }
            focusNextCell(e) {
                let t = this.getInitialFocusDate(), { currentView: s } = this.dp, { days: a, months: n, years: r } = i, o = h(t), l = o.year, d = o.month, c = o.date;
                switch(e){
                    case "ArrowLeft":
                        s === a && (c -= 1), s === n && (d -= 1), s === r && (l -= 1);
                        break;
                    case "ArrowUp":
                        s === a && (c -= 7), s === n && (d -= 3), s === r && (l -= 4);
                        break;
                    case "ArrowRight":
                        s === a && (c += 1), s === n && (d += 1), s === r && (l += 1);
                        break;
                    case "ArrowDown":
                        s === a && (c += 7), s === n && (d += 3), s === r && (l += 4);
                }
                let u = this.dp.getClampedDate(new Date(l, d, c));
                this.dp.setFocusDate(u, {
                    viewDateTransition: !0
                });
            }
            registerKey(e) {
                this.pressedKeys.add(e);
            }
            removeKey(e) {
                this.pressedKeys.delete(e);
            }
        }
        let N = {
            on (e, t) {
                this.__events || (this.__events = {}), this.__events[e] ? this.__events[e].push(t) : this.__events[e] = [
                    t
                ];
            },
            off (e, t) {
                this.__events && this.__events[e] && (this.__events[e] = this.__events[e].filter((e)=>e !== t));
            },
            removeAllEvents () {
                this.__events = {};
            },
            trigger (e) {
                for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
                this.__events && this.__events[e] && this.__events[e].forEach((e)=>{
                    e(...i);
                });
            }
        };
        function I(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        let P = "", j = "", B = !1;
        class R {
            static buildGlobalContainer(e) {
                B = !0, P = n({
                    className: e,
                    id: e
                }), a("body").appendChild(P);
            }
            constructor(e, t){
                var r = this;
                if (I(this, "viewIndexes", [
                    i.days,
                    i.months,
                    i.years
                ]), I(this, "next", ()=>{
                    let { year: e, month: t } = this.parsedViewDate;
                    switch(this.currentView){
                        case i.days:
                            this.setViewDate(new Date(e, t + 1, 1));
                            break;
                        case i.months:
                            this.setViewDate(new Date(e + 1, t, 1));
                            break;
                        case i.years:
                            this.setViewDate(new Date(e + 10, 0, 1));
                    }
                }), I(this, "prev", ()=>{
                    let { year: e, month: t } = this.parsedViewDate;
                    switch(this.currentView){
                        case i.days:
                            this.setViewDate(new Date(e, t - 1, 1));
                            break;
                        case i.months:
                            this.setViewDate(new Date(e - 1, t, 1));
                            break;
                        case i.years:
                            this.setViewDate(new Date(e - 10, 0, 1));
                    }
                }), I(this, "_finishHide", ()=>{
                    this.hideAnimation = !1, this._destroyComponents(), this.$container.removeChild(this.$datepicker);
                }), I(this, "setPosition", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if ("function" == typeof (e = e || r.opts.position)) return void (r.customHide = e({
                        $datepicker: r.$datepicker,
                        $target: r.$el,
                        $pointer: r.$pointer,
                        isViewChange: t,
                        done: r._finishHide
                    }));
                    let i, s, { isMobile: a } = r.opts, n = r.$el.getBoundingClientRect(), o = r.$el.getBoundingClientRect(), h = r.$datepicker.offsetParent, l = r.$el.offsetParent, d = r.$datepicker.getBoundingClientRect(), c = e.split(" "), u = window.scrollY, p = window.scrollX, m = r.opts.offset, v = c[0], g = c[1];
                    if (a) r.$datepicker.style.cssText = "left: 50%; top: 50%";
                    else {
                        if (h === l && h !== document.body && (o = {
                            top: r.$el.offsetTop,
                            left: r.$el.offsetLeft,
                            width: n.width,
                            height: r.$el.offsetHeight
                        }, u = 0, p = 0), h !== l && h !== document.body) {
                            let e = h.getBoundingClientRect();
                            o = {
                                top: n.top - e.top,
                                left: n.left - e.left,
                                width: n.width,
                                height: n.height
                            }, u = 0, p = 0;
                        }
                        switch(v){
                            case "top":
                                i = o.top - d.height - m;
                                break;
                            case "right":
                                s = o.left + o.width + m;
                                break;
                            case "bottom":
                                i = o.top + o.height + m;
                                break;
                            case "left":
                                s = o.left - d.width - m;
                        }
                        switch(g){
                            case "top":
                                i = o.top;
                                break;
                            case "right":
                                s = o.left + o.width - d.width;
                                break;
                            case "bottom":
                                i = o.top + o.height - d.height;
                                break;
                            case "left":
                                s = o.left;
                                break;
                            case "center":
                                /left|right/.test(v) ? i = o.top + o.height / 2 - d.height / 2 : s = o.left + o.width / 2 - d.width / 2;
                        }
                        r.$datepicker.style.cssText = `left: ${s + p}px; top: ${i + u}px`;
                    }
                }), I(this, "_setInputValue", ()=>{
                    let { opts: e, $altField: t, locale: { dateFormat: i } } = this, { altFieldDateFormat: s, altField: a } = e;
                    a && t && (t.value = this._getInputValue(s)), this.$el.value = this._getInputValue(i);
                }), I(this, "_getInputValue", (e)=>{
                    let { selectedDates: t, opts: i } = this, { multipleDates: s, multipleDatesSeparator: a } = i;
                    if (!t.length) return "";
                    let n = "function" == typeof e, r = n ? e(s ? t : t[0]) : t.map((t)=>this.formatDate(t, e));
                    return r = n ? r : r.join(a), r;
                }), I(this, "_checkIfDateIsSelected", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.days, s = !1;
                    return r.selectedDates.some((i)=>{
                        let a = p(e, i, t);
                        return s = a && i, a;
                    }), s;
                }), I(this, "_scheduleCallAfterTransition", (e)=>{
                    this._cancelScheduledCall(), e && e(!1), this._onTransitionEnd = ()=>{
                        e && e(!0);
                    }, this.$datepicker.addEventListener("transitionend", this._onTransitionEnd, {
                        once: !0
                    });
                }), I(this, "_cancelScheduledCall", ()=>{
                    this.$datepicker.removeEventListener("transitionend", this._onTransitionEnd);
                }), I(this, "setViewDate", (e)=>{
                    if (!((e = b(e)) instanceof Date)) return;
                    if (p(e, this.viewDate)) return;
                    let t = this.viewDate;
                    this.viewDate = e;
                    let { onChangeViewDate: s } = this.opts;
                    if (s) {
                        let { month: e, year: t } = this.parsedViewDate;
                        s({
                            month: e,
                            year: t,
                            decade: this.curDecade
                        });
                    }
                    this.trigger(i.eventChangeViewDate, e, t);
                }), I(this, "setFocusDate", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (!e || (e = b(e)) instanceof Date) && (r.focusDate = e, r.trigger(i.eventChangeFocusDate, e, t));
                }), I(this, "setCurrentView", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (r.viewIndexes.includes(e)) {
                        if (r.currentView = e, r.elIsInput && r.visible && r.setPosition(void 0, !0), r.trigger(i.eventChangeCurrentView, e), !r.views[e]) {
                            let t = r.views[e] = new T({
                                dp: r,
                                opts: r.opts,
                                type: e
                            });
                            r.shouldUpdateDOM && r.$content.appendChild(t.$el);
                        }
                        r.opts.onChangeView && !t.silent && r.opts.onChangeView(e);
                    }
                }), I(this, "_updateLastSelectedDate", (e)=>{
                    this.lastSelectedDate = e, this.trigger(i.eventChangeLastSelectedDate, e);
                }), I(this, "destroy", ()=>{
                    if (this.isDestroyed) return;
                    let { showEvent: e, isMobile: t } = this.opts, i = this.$datepicker.parentNode;
                    i && i.removeChild(this.$datepicker), this.$el.removeEventListener(e, this._onFocus), this.$el.removeEventListener("blur", this._onBlur), window.removeEventListener("resize", this._onResize), t && this._removeMobileAttributes(), this.keyboardNav && this.keyboardNav.destroy(), this.views = null, this.nav = null, this.$datepicker = null, this.opts = {}, this.$customContainer = null, this.viewDate = null, this.focusDate = null, this.selectedDates = [], this.rangeDateFrom = null, this.rangeDateTo = null, this.isDestroyed = !0;
                }), I(this, "update", function() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, s = w({}, r.opts), { silent: a } = t;
                    w(r.opts, e);
                    let { timepicker: n, buttons: o, range: h, selectedDates: l, isMobile: d } = r.opts, c = r.visible || r.treatAsInline;
                    r._createMinMaxDates(), r._limitViewDateByMaxMinDates(), r._handleLocale(), l && (r.selectedDates = [], r.selectDate(l, {
                        silent: a
                    })), e.view && r.setCurrentView(e.view, {
                        silent: a
                    }), r._setInputValue(), s.range && !h ? (r.rangeDateTo = !1, r.rangeDateFrom = !1) : !s.range && h && r.selectedDates.length && (r.rangeDateFrom = r.selectedDates[0], r.rangeDateTo = r.selectedDates[1]), s.timepicker && !n ? (c && r.timepicker.destroy(), r.timepicker = !1, r.$timepicker.parentNode.removeChild(r.$timepicker)) : !s.timepicker && n && r._addTimepicker(), !s.buttons && o ? r._addButtons() : s.buttons && !o ? (r.buttons.destroy(), r.$buttons.parentNode.removeChild(r.$buttons)) : c && s.buttons && o && r.buttons.clearHtml().render(), !s.isMobile && d ? (r.treatAsInline || j || r._createMobileOverlay(), r._addMobileAttributes(), r.visible && r._showMobileOverlay()) : s.isMobile && !d && (r._removeMobileAttributes(), r.visible && (j.classList.remove("-active-"), "function" != typeof r.opts.position && r.setPosition())), c && (r.nav.update(), r.views[r.currentView].render(), r.currentView === i.days && r.views[r.currentView].renderDayNames());
                }), I(this, "disableDate", (e, t)=>{
                    (Array.isArray(e) ? e : [
                        e
                    ]).forEach((e)=>{
                        let i = b(e);
                        if (!i) return;
                        let s = t ? "delete" : "add";
                        this.disabledDates[s](this.formatDate(i, "yyyy-MM-dd"));
                        let a = this.getCell(i, this.currentViewSingular);
                        a && a.adpCell.render();
                    }, []);
                }), I(this, "enableDate", (e)=>{
                    this.disableDate(e, !0);
                }), I(this, "isDateDisabled", (e)=>{
                    let t = b(e);
                    return this.disabledDates.has(this.formatDate(t, "yyyy-MM-dd"));
                }), I(this, "isOtherMonth", (e)=>{
                    let { month: t } = h(e);
                    return t !== this.parsedViewDate.month;
                }), I(this, "isOtherYear", (e)=>{
                    let { year: t } = h(e);
                    return t !== this.parsedViewDate.year;
                }), I(this, "isOtherDecade", (e)=>{
                    let { year: t } = h(e), [i, s] = c(this.viewDate);
                    return t < i || t > s;
                }), I(this, "_onChangeSelectedDate", (e)=>{
                    let { silent: t } = e;
                    setTimeout(()=>{
                        this._setInputValue(), this.opts.onSelect && !t && this._triggerOnSelect();
                    });
                }), I(this, "_onChangeFocusedDate", function(e) {
                    let { viewDateTransition: t } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e) return;
                    let i = !1;
                    t && (i = r.isOtherMonth(e) || r.isOtherYear(e) || r.isOtherDecade(e)), i && r.setViewDate(e), r.opts.onFocus && r.opts.onFocus({
                        datepicker: r,
                        date: e
                    });
                }), I(this, "_onChangeTime", (e)=>{
                    let { hours: t, minutes: i } = e, s = new Date, { lastSelectedDate: a, opts: { onSelect: n } } = this, r = a;
                    a || (r = s);
                    let o = this.getCell(r, this.currentViewSingular), h = o && o.adpCell;
                    h && h.isDisabled || (r.setHours(t), r.setMinutes(i), a ? (this._setInputValue(), n && this._triggerOnSelect()) : this.selectDate(r));
                }), I(this, "_onFocus", (e)=>{
                    this.visible || this.show();
                }), I(this, "_onBlur", (e)=>{
                    this.inFocus || !this.visible || this.opts.isMobile || this.hide();
                }), I(this, "_onMouseDown", (e)=>{
                    this.inFocus = !0;
                }), I(this, "_onMouseUp", (e)=>{
                    this.inFocus = !1, this.$el.focus();
                }), I(this, "_onResize", ()=>{
                    this.visible && "function" != typeof this.opts.position && this.setPosition();
                }), I(this, "_onClickOverlay", ()=>{
                    this.visible && this.hide();
                }), I(this, "getViewDates", function() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                    return T.getDatesFunction(e)(r);
                }), I(this, "isWeekend", (e)=>this.opts.weekends.includes(e)), I(this, "getClampedDate", (e)=>{
                    let { minDate: t, maxDate: i } = this, s = e;
                    return i && m(e, i) ? s = i : t && v(e, t) && (s = t), s;
                }), this.$el = a(e), !this.$el) return;
                this.$datepicker = n({
                    className: "air-datepicker"
                }), this.opts = w({}, s, t), this.$customContainer = !!this.opts.container && a(this.opts.container), this.$altField = a(this.opts.altField || !1);
                let { view: o, startDate: l } = this.opts;
                l || (this.opts.startDate = new Date), "INPUT" === this.$el.nodeName && (this.elIsInput = !0), this.inited = !1, this.visible = !1, this.viewDate = b(this.opts.startDate), this.focusDate = !1, this.initialReadonly = this.$el.getAttribute("readonly"), this.customHide = !1, this.currentView = o, this.selectedDates = [], this.disabledDates = new Set, this.isDestroyed = !1, this.views = {}, this.keys = [], this.rangeDateFrom = "", this.rangeDateTo = "", this.timepickerIsActive = !1, this.treatAsInline = this.opts.inline || !this.elIsInput, this.init();
            }
            init() {
                let { opts: e, treatAsInline: t, opts: { inline: i, isMobile: s, selectedDates: n, keyboardNav: r, onlyTimepicker: o } } = this, h = a("body");
                (!B || B && P && !h.contains(P)) && !i && this.elIsInput && !this.$customContainer && R.buildGlobalContainer(R.defaultGlobalContainerId), !s || j || t || this._createMobileOverlay(), this._handleLocale(), this._bindSubEvents(), this._createMinMaxDates(), this._limitViewDateByMaxMinDates(), this.elIsInput && (i || this._bindEvents(), r && !o && (this.keyboardNav = new A({
                    dp: this,
                    opts: e
                }))), n && this.selectDate(n, {
                    silent: !0
                }), this.opts.visible && !t && this.show(), s && !t && this.$el.setAttribute("readonly", !0), t && this._createComponents();
            }
            _createMobileOverlay() {
                j = n({
                    className: "air-datepicker-overlay"
                }), P.appendChild(j);
            }
            _createComponents() {
                let { opts: e, treatAsInline: t, opts: { inline: i, buttons: s, timepicker: a, position: n, classes: r, onlyTimepicker: o, isMobile: h } } = this;
                this._buildBaseHtml(), this.elIsInput && (i || this._setPositionClasses(n)), !i && this.elIsInput || this.$datepicker.classList.add("-inline-"), r && this.$datepicker.classList.add(...r.split(" ")), o && this.$datepicker.classList.add("-only-timepicker-"), h && !t && this._addMobileAttributes(), this.views[this.currentView] = new T({
                    dp: this,
                    type: this.currentView,
                    opts: e
                }), this.nav = new V({
                    dp: this,
                    opts: e
                }), a && this._addTimepicker(), s && this._addButtons(), this.$content.appendChild(this.views[this.currentView].$el), this.$nav.appendChild(this.nav.$el);
            }
            _destroyComponents() {
                for(let e in this.views)this.views[e].destroy();
                this.views = {}, this.nav.destroy(), this.timepicker && this.timepicker.destroy();
            }
            _addMobileAttributes() {
                j.addEventListener("click", this._onClickOverlay), this.$datepicker.classList.add("-is-mobile-"), this.$el.setAttribute("readonly", !0);
            }
            _removeMobileAttributes() {
                j.removeEventListener("click", this._onClickOverlay), this.$datepicker.classList.remove("-is-mobile-"), this.initialReadonly || "" === this.initialReadonly || this.$el.removeAttribute("readonly");
            }
            _createMinMaxDates() {
                let { minDate: e, maxDate: t } = this.opts;
                this.minDate = !!e && b(e), this.maxDate = !!t && b(t);
            }
            _addTimepicker() {
                this.$timepicker = n({
                    className: "air-datepicker--time"
                }), this.$datepicker.appendChild(this.$timepicker), this.timepicker = new L({
                    dp: this,
                    opts: this.opts
                }), this.$timepicker.appendChild(this.timepicker.$el);
            }
            _addButtons() {
                this.$buttons = n({
                    className: "air-datepicker--buttons"
                }), this.$datepicker.appendChild(this.$buttons), this.buttons = new H({
                    dp: this,
                    opts: this.opts
                }), this.$buttons.appendChild(this.buttons.$el);
            }
            _bindSubEvents() {
                this.on(i.eventChangeSelectedDate, this._onChangeSelectedDate), this.on(i.eventChangeFocusDate, this._onChangeFocusedDate), this.on(i.eventChangeTime, this._onChangeTime);
            }
            _buildBaseHtml() {
                let { inline: e } = this.opts;
                var t, i;
                this.elIsInput ? e ? (t = this.$datepicker, (i = this.$el).parentNode.insertBefore(t, i.nextSibling)) : this.$container.appendChild(this.$datepicker) : this.$el.appendChild(this.$datepicker), this.$datepicker.innerHTML = '<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>', this.$content = a(".air-datepicker--content", this.$datepicker), this.$pointer = a(".air-datepicker--pointer", this.$datepicker), this.$nav = a(".air-datepicker--navigation", this.$datepicker);
            }
            _handleLocale() {
                let { locale: e, dateFormat: t, firstDay: i, timepicker: s, onlyTimepicker: a, timeFormat: n, dateTimeSeparator: r } = this.opts;
                var o;
                this.locale = (o = e, JSON.parse(JSON.stringify(o))), t && (this.locale.dateFormat = t), void 0 !== n && "" !== n && (this.locale.timeFormat = n);
                let { timeFormat: h } = this.locale;
                if ("" !== i && (this.locale.firstDay = i), s && "function" != typeof t) {
                    let e = h ? r : "";
                    this.locale.dateFormat = [
                        this.locale.dateFormat,
                        h || ""
                    ].join(e);
                }
                a && "function" != typeof t && (this.locale.dateFormat = this.locale.timeFormat);
            }
            _setPositionClasses(e) {
                if ("function" == typeof e) return void this.$datepicker.classList.add("-custom-position-");
                let t = (e = e.split(" "))[0], i = `air-datepicker -${t}-${e[1]}- -from-${t}-`;
                this.$datepicker.classList.add(...i.split(" "));
            }
            _bindEvents() {
                this.$el.addEventListener(this.opts.showEvent, this._onFocus), this.$el.addEventListener("blur", this._onBlur), this.$datepicker.addEventListener("mousedown", this._onMouseDown), this.$datepicker.addEventListener("mouseup", this._onMouseUp), window.addEventListener("resize", this._onResize);
            }
            _limitViewDateByMaxMinDates() {
                let { viewDate: e, minDate: t, maxDate: i } = this;
                i && m(e, i) && this.setViewDate(i), t && v(e, t) && this.setViewDate(t);
            }
            formatDate() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.viewDate, t = arguments.length > 1 ? arguments[1] : void 0;
                if (e = b(e), !(e instanceof Date)) return;
                let i = t, s = this.locale, a = h(e), n = a.dayPeriod, r = c(e), o = R.replacer, l = {
                    T: e.getTime(),
                    m: a.minutes,
                    mm: a.fullMinutes,
                    h: a.hours12,
                    hh: a.fullHours12,
                    H: a.hours,
                    HH: a.fullHours,
                    aa: n,
                    AA: n.toUpperCase(),
                    E: s.daysShort[a.day],
                    EEEE: s.days[a.day],
                    d: a.date,
                    dd: a.fullDate,
                    M: a.month + 1,
                    MM: a.fullMonth,
                    MMM: s.monthsShort[a.month],
                    MMMM: s.months[a.month],
                    yy: a.year.toString().slice(-2),
                    yyyy: a.year,
                    yyyy1: r[0],
                    yyyy2: r[1]
                };
                for (let [e, t] of Object.entries(l))i = o(i, k(e), t);
                return i;
            }
            down(e) {
                this._handleUpDownActions(e, "down");
            }
            up(e) {
                this._handleUpDownActions(e, "up");
            }
            selectDate(e) {
                let t, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { currentView: a, parsedViewDate: n, selectedDates: r } = this, { updateTime: o } = s, { moveToOtherMonthsOnSelect: h, moveToOtherYearsOnSelect: l, multipleDates: d, range: c, autoClose: u, onBeforeSelect: p } = this.opts, v = r.length;
                if (Array.isArray(e)) return e.forEach((e)=>{
                    this.selectDate(e, s);
                }), new Promise((e)=>{
                    setTimeout(e);
                });
                if ((e = b(e)) instanceof Date) {
                    if (p && !p({
                        date: e,
                        datepicker: this
                    })) return Promise.resolve();
                    if (a === i.days && e.getMonth() !== n.month && h && (t = new Date(e.getFullYear(), e.getMonth(), 1)), a === i.years && e.getFullYear() !== n.year && l && (t = new Date(e.getFullYear(), 0, 1)), t && this.setViewDate(t), d && !c) {
                        if (v === d) return;
                        this._checkIfDateIsSelected(e) || r.push(e);
                    } else if (c) switch(v){
                        case 1:
                            r.push(e), this.rangeDateTo || (this.rangeDateTo = e), m(this.rangeDateFrom, this.rangeDateTo) && (this.rangeDateTo = this.rangeDateFrom, this.rangeDateFrom = e), this.selectedDates = [
                                this.rangeDateFrom,
                                this.rangeDateTo
                            ];
                            break;
                        case 2:
                            this.selectedDates = [
                                e
                            ], this.rangeDateFrom = e, this.rangeDateTo = "";
                            break;
                        default:
                            this.selectedDates = [
                                e
                            ], this.rangeDateFrom = e;
                    }
                    else this.selectedDates = [
                        e
                    ];
                    return this.trigger(i.eventChangeSelectedDate, {
                        action: i.actionSelectDate,
                        silent: null == s ? void 0 : s.silent,
                        date: e,
                        updateTime: o
                    }), this._updateLastSelectedDate(e), u && !this.timepickerIsActive && this.visible && (d || c ? c && 1 === v && this.hide() : this.hide()), new Promise((e)=>{
                        setTimeout(e);
                    });
                }
            }
            unselectDate(e) {
                let t = this.selectedDates, s = this;
                if ((e = b(e)) instanceof Date) return t.some((a, n)=>{
                    if (p(a, e)) return t.splice(n, 1), s.selectedDates.length ? (s.rangeDateTo = "", s.rangeDateFrom = t[0], s._updateLastSelectedDate(s.selectedDates[s.selectedDates.length - 1])) : (s.rangeDateFrom = "", s.rangeDateTo = "", s._updateLastSelectedDate(!1)), this.trigger(i.eventChangeSelectedDate, {
                        action: i.actionUnselectDate,
                        date: e
                    }), !0;
                });
            }
            replaceDate(e, t) {
                let s = this.selectedDates.find((t)=>p(t, e, this.currentView)), a = this.selectedDates.indexOf(s);
                a < 0 || p(this.selectedDates[a], t, this.currentView) || (this.selectedDates[a] = t, this.trigger(i.eventChangeSelectedDate, {
                    action: i.actionSelectDate,
                    date: t,
                    updateTime: !0
                }), this._updateLastSelectedDate(t));
            }
            clear() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return this.selectedDates = [], this.rangeDateFrom = !1, this.rangeDateTo = !1, this.lastSelectedDate = !1, this.trigger(i.eventChangeSelectedDate, {
                    action: i.actionUnselectDate,
                    silent: e.silent
                }), new Promise((e)=>{
                    setTimeout(e);
                });
            }
            show() {
                let { onShow: e, isMobile: t } = this.opts;
                this._cancelScheduledCall(), this.visible || this.hideAnimation || this._createComponents(), this.setPosition(this.opts.position), this.$datepicker.classList.add("-active-"), this.visible = !0, e && this._scheduleCallAfterTransition(e), t && this._showMobileOverlay();
            }
            hide() {
                let { onHide: e, isMobile: t } = this.opts, i = this._hasTransition();
                this.visible = !1, this.hideAnimation = !0, this.$datepicker.classList.remove("-active-"), this.customHide && this.customHide(), this.elIsInput && this.$el.blur(), this._scheduleCallAfterTransition((t)=>{
                    !this.customHide && (t && i || !t && !i) && this._finishHide(), e && e(t);
                }), t && j.classList.remove("-active-");
            }
            _triggerOnSelect() {
                let e = [], t = [], { selectedDates: i, locale: s, opts: { onSelect: a, multipleDates: n, range: r } } = this, o = n || r, h = "function" == typeof s.dateFormat;
                i.length && (e = i.map(g), t = h ? n ? s.dateFormat(e) : e.map((e)=>s.dateFormat(e)) : e.map((e)=>this.formatDate(e, s.dateFormat))), a({
                    date: o ? e : e[0],
                    formattedDate: o ? t : t[0],
                    datepicker: this
                });
            }
            _handleAlreadySelectedDates(e, t) {
                let { selectedDates: i, rangeDateFrom: s, rangeDateTo: a } = this, { range: n, toggleSelected: r } = this.opts, o = i.length, h = "function" == typeof r ? r({
                    datepicker: this,
                    date: t
                }) : r, l = Boolean(n && 1 === o && e), d = l ? g(t) : t;
                n && !h && (2 !== o && this.selectDate(d), 2 === o && p(s, a)) || (h ? this.unselectDate(d) : this._updateLastSelectedDate(l ? d : e));
            }
            _handleUpDownActions(e, t) {
                if (!((e = b(e || this.focusDate || this.viewDate)) instanceof Date)) return;
                let i = "up" === t ? this.viewIndex + 1 : this.viewIndex - 1;
                i > 2 && (i = 2), i < 0 && (i = 0), this.setViewDate(new Date(e.getFullYear(), e.getMonth(), 1)), this.setCurrentView(this.viewIndexes[i]);
            }
            getCell(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.day;
                if (!((e = b(e)) instanceof Date)) return;
                let { year: s, month: a, date: n } = h(e), r = `[data-year="${s}"]`, o = `[data-month="${a}"]`, l = {
                    [i.day]: `${r}${o}[data-date="${n}"]`,
                    [i.month]: `${r}${o}`,
                    [i.year]: `${r}`
                };
                return this.views[this.currentView] ? this.views[this.currentView].$el.querySelector(l[t]) : void 0;
            }
            _showMobileOverlay() {
                j.classList.add("-active-");
            }
            _hasTransition() {
                return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce((e, t)=>parseFloat(t) + e, 0) > 0;
            }
            get shouldUpdateDOM() {
                return this.visible || this.treatAsInline;
            }
            get parsedViewDate() {
                return h(this.viewDate);
            }
            get currentViewSingular() {
                return this.currentView.slice(0, -1);
            }
            get curDecade() {
                return c(this.viewDate);
            }
            get viewIndex() {
                return this.viewIndexes.indexOf(this.currentView);
            }
            get isFinalView() {
                return this.currentView === i.years;
            }
            get hasSelectedDates() {
                return this.selectedDates.length > 0;
            }
            get isMinViewReached() {
                return this.currentView === this.opts.minView || this.currentView === i.days;
            }
            get $container() {
                return this.$customContainer || P;
            }
            static replacer(e, t, i) {
                return e.replace(t, function(e, t, s, a) {
                    return t + i + a;
                });
            }
        }
        var K;
        return I(R, "defaults", s), I(R, "version", "3.5.3"), I(R, "defaultGlobalContainerId", "air-datepicker-global-container"), K = R.prototype, Object.assign(K, N), t.default;
    }();
});


var $ab3f7f6753b36ea0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($ed5e59f538d5fd92$exports)));


const $04a49e74a6e0fbe0$var$localeEn = {
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    daysShort: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    daysMin: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    monthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    today: "Today",
    clear: "Clear",
    dateFormat: "MM/dd/yyyy",
    timeFormat: "hh:mm aa",
    firstDay: 0
};
window.dateInput = function dateInput1() {
    if (document.getElementsByClassName("date-input")[0]) {
        const dateInputsArr = document.querySelectorAll(".date-input");
        dateInputsArr.forEach((dateInput1)=>{
            if (!dateInput1.classList.contains("is-init")) {
                dateInput1.classList.add("is-init");
                const isStartDateInput = dateInput1.classList.contains("start-date-input");
                const isEndDateInput = dateInput1.classList.contains("end-date-input");
                const endDateRange = isEndDateInput ? parseInt(dateInput1.getAttribute("data-end-date"), 10) : null;
                // Получаем родителя родителя
                const grandParent = dateInput1.parentElement?.parentElement.parentElement;
                // Инициализируем AirDatepicker
                const airDatepicker = new (0, $ab3f7f6753b36ea0$export$2e2bcd8739ae039)(dateInput1, {
                    dateFormat: "dd/MM/yyyy",
                    locale: $04a49e74a6e0fbe0$var$localeEn,
                    onSelect: function(formattedDate, date) {
                        dateInput1.value = formattedDate.formattedDate;
                        // Если это start-date-input, сохраняем дату в data-start-date
                        if (isStartDateInput && grandParent) grandParent.setAttribute("data-start-date", formattedDate.formattedDate);
                        // При изменении start-date, обновляем ограничения для end-date
                        if (isStartDateInput && grandParent) $04a49e74a6e0fbe0$var$updateEndDateConstraints(grandParent);
                    },
                    onRenderCell: function({ date: date }) {
                        if (isEndDateInput && endDateRange) {
                            let startDate = new Date(); // По умолчанию сегодняшняя дата
                            startDate.setHours(0, 0, 0, 0);
                            // Проверяем data-start-date
                            if (grandParent && grandParent.getAttribute("data-start-date")) {
                                const [day, month, year] = grandParent.getAttribute("data-start-date").split("/");
                                startDate = new Date(`${year}-${month}-${day}`);
                                startDate.setHours(0, 0, 0, 0);
                            }
                            // Считаем минимальную доступную дату (startDate + 1 день)
                            const minDate = new Date(startDate);
                            minDate.setDate(startDate.getDate() + 1);
                            // Считаем максимальную доступную дату (startDate + 30 дней)
                            const maxDate = new Date(startDate);
                            maxDate.setDate(startDate.getDate() + endDateRange);
                            // Блокируем даты до minDate и после maxDate
                            if (date < minDate || date > maxDate) return {
                                disabled: true
                            };
                        }
                    },
                    onShow: function() {
                        // Срабатывает при открытии календаря
                        if (isEndDateInput && grandParent) {
                            const startDateValue = grandParent.getAttribute("data-start-date");
                            let startDateObj = new Date();
                            if (startDateValue) {
                                const [day, month, year] = startDateValue.split("/");
                                startDateObj = new Date(`${year}-${month}-${day}`);
                            }
                            startDateObj.setHours(0, 0, 0, 0);
                            // Считаем минимальную дату (startDate + 1 день)
                            const minDate = new Date(startDateObj);
                            minDate.setDate(startDateObj.getDate() + 1);
                            // Считаем максимальную дату (startDate + 30 дней)
                            const maxDate = new Date(startDateObj);
                            maxDate.setDate(startDateObj.getDate() + endDateRange);
                            airDatepicker.update({
                                minDate: new Date(),
                                maxDate: new Date().setFullYear(new Date().getFullYear() + 1)
                            });
                            // Применяем ограничения
                            airDatepicker.update({
                                minDate: minDate,
                                maxDate: maxDate
                            });
                            // Логирование для проверки
                            console.log("Start Date:", startDateObj);
                            console.log("Min Date:", minDate);
                            console.log("Max Date:", maxDate);
                        }
                    }
                });
                // Если это start-date-input, добавляем обновление ограничений для end-date-input
                if (isStartDateInput && grandParent) {
                    const endDateInput = grandParent.querySelector(".end-date-input");
                    if (endDateInput) dateInput1.addEventListener("change", ()=>{
                        // Обновляем ограничения в end-date-input
                        $04a49e74a6e0fbe0$var$updateEndDateConstraints(grandParent);
                    });
                }
                // При открытии календаря для end-date-input обновляем его ограничения
                if (isEndDateInput && grandParent) {
                    const startDate = grandParent.querySelector(".start-date-input");
                    if (startDate) // Слушаем событие "open", когда календарь будет открыт
                    airDatepicker.on("open", function() {
                        const startDateValue = grandParent.getAttribute("data-start-date");
                        let startDateObj = new Date();
                        if (startDateValue) {
                            const [day, month, year] = startDateValue.split("/");
                            startDateObj = new Date(`${year}-${month}-${day}`);
                        }
                        startDateObj.setHours(0, 0, 0, 0);
                        // Считаем минимальную дату (startDate + 1 день)
                        const minDate = new Date(startDateObj);
                        minDate.setDate(startDateObj.getDate() + 1);
                        // Считаем максимальную дату (startDate + 30 дней)
                        const maxDate = new Date(startDateObj);
                        maxDate.setDate(startDateObj.getDate() + endDateRange);
                        // Применяем ограничения
                        airDatepicker.update({
                            minDate: minDate,
                            maxDate: maxDate
                        });
                        // Логирование для проверки
                        console.log("Start Date:", startDateObj);
                        console.log("Min Date:", minDate);
                        console.log("Max Date:", maxDate);
                    });
                }
                dateInput1.setAttribute("readonly", "true");
                dateInput1.setAttribute("autocomplete", "off");
                dateInput1.setAttribute("inputmode", "none");
            }
        });
    }
};
function $04a49e74a6e0fbe0$var$newAirEndDatepicker(grandParent) {
    const endInput = grandParent.querySelector(".end-date-input");
    if (endInput) {
        const savedBlock = endInput.cloneNode(true);
        savedBlock.classList.remove("is-init");
        const parent = endInput.parentElement;
        const nextSibling = endInput.nextElementSibling;
        parent.removeChild(endInput);
        if (nextSibling) parent.insertBefore(savedBlock, nextSibling);
        else parent.appendChild(savedBlock);
        dateInput();
    }
}
function $04a49e74a6e0fbe0$var$updateEndDateConstraints(grandParent) {
    const endDateInput = grandParent.querySelector(".end-date-input");
    if (endDateInput) {
        const startDateValue = grandParent.getAttribute("data-start-date");
        let startDateObj = new Date();
        if (startDateValue) {
            const [day, month, year] = startDateValue.split("/");
            startDateObj = new Date(`${year}-${month}-${day}`);
        }
        startDateObj.setHours(0, 0, 0, 0);
        // Считаем минимальную дату (startDate + 1 день)
        const minDate = new Date(startDateObj);
        minDate.setDate(startDateObj.getDate() + 1);
        // Считаем максимальную дату (startDate + 30 дней)
        const maxDate = new Date(startDateObj);
        maxDate.setDate(startDateObj.getDate() + 30);
        const airDatepicker = endDateInput.airdatepicker;
        if (airDatepicker) {
            // Обновляем ограничения для endDate
            airDatepicker.update({
                minDate: minDate,
                maxDate: maxDate
            });
            // Логируем для отладки
            console.log("Updated End Date Constraints");
            console.log("Min Date:", minDate);
            console.log("Max Date:", maxDate);
            // Проверяем, если выбранная дата в end-date выходит за пределы допустимого диапазона
            const selectedEndDate = new Date(endDateInput.value);
            if (selectedEndDate < minDate) endDateInput.value = airDatepicker.formatDate(minDate);
            else if (selectedEndDate > maxDate) endDateInput.value = airDatepicker.formatDate(maxDate);
        }
        $04a49e74a6e0fbe0$var$newAirEndDatepicker(grandParent);
    }
}
dateInput();
const $04a49e74a6e0fbe0$var$addNewButtons = document.querySelectorAll(".profile-block__new");
if ($04a49e74a6e0fbe0$var$addNewButtons.length) $04a49e74a6e0fbe0$var$addNewButtons.forEach((item)=>{
    item.addEventListener("click", ()=>{
        setTimeout(()=>{
            console.log("test init");
            dateInput();
        }, 1);
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    const accordionItems = document.querySelectorAll(".accordion__item");
    accordionItems.forEach((item)=>{
        item.addEventListener("click", ()=>{
            item.classList.toggle("active");
        });
    });
});


window.choicesArray = [];
window.initChoices = function initChoices1(elementsArr) {
    const choicesDOM = document.querySelector(elementsArr);
    if (choicesDOM) {
        const choicesArr = document.querySelectorAll(`${elementsArr}`);
        for(let i = 0; i < choicesArr.length; i++)if (!choicesArr[i].classList.contains("is-init")) {
            choicesArr[i].classList.add("is-init");
            console.log("init");
            const parentContainer = choicesArr[i].parentNode;
            const choices = new Choices(choicesArr[i], {
                searchEnabled: false,
                itemSelectText: "",
                placeholder: true,
                searchPlaceholderValue: "Search",
                removeItems: true,
                removeItemButton: true,
                maxItemCount: 5,
                shouldSort: false,
                shouldSortItems: false
            });
            console.log(parentContainer);
            choicesArray.push(choices);
            const choicesMultipleElement = parentContainer.querySelector(".choices[data-type='select-multiple']");
            if (choicesMultipleElement) choicesMultipleElement.addEventListener("click", ()=>{
                if (parentContainer.querySelector(".is-open")) choices.hideDropdown();
            });
        }
    }
};
window.getChoice = function getChoice1(select) {
    let selectEl = typeof select === "object" ? select : document.querySelector(select);
    let choicesArr = window.choicesArray;
    let targetChoice;
    if (choicesArr) window.choicesArray.forEach((choices)=>{
        let choicesSelect = choices.passedElement.element;
        if (choicesSelect == selectEl) targetChoice = choices;
    });
    return targetChoice;
};
window.resetChoice = function resetChoice(select) {
    let choice = getChoice(select);
    if (choice) {
        let startValue = choice.config.choices[0].value;
        choice.setChoiceByValue(startValue);
    }
};
const $f9d9117d056bb82c$var$addNewButtons = document.querySelectorAll(".profile-block__new");
if ($f9d9117d056bb82c$var$addNewButtons.length) $f9d9117d056bb82c$var$addNewButtons.forEach((item)=>{
    item.addEventListener("click", ()=>{
        setTimeout(()=>{
            initChoices("[data-choices]");
        }, 1);
    });
});
initChoices("[data-choices]");
/*window.initSelect2Func = function initSelect2Func() {
  $(document).ready(function () {
    const select2Arr = document.querySelectorAll('.select-2');

    $('.select-2:not(.is-init)').select2({
      tags: true,
      dropdownPosition: 'below',
    });

    select2Arr.forEach((select) => {
      if (!select.classList.contains('is-init')) {
        select.classList.add('is-init');
        const parentContainer = select.parentNode;

        const parentContainerWidth = parentContainer.offsetWidth;

        parentContainer.style.maxWidth = `${parentContainerWidth}px`;
      }
    });
  });
};
initSelect2Func();*/ window.initSelect2Func = function initSelect2Func1() {
    $(document).ready(function() {
        const select2Arr = document.querySelectorAll(".select-2");
        const placeholderText = "Type here...";
        $(".select-2:not(.is-init)").select2({
            tags: true,
            dropdownPosition: "below",
            placeholder: placeholderText,
            createTag: function() {
                return null;
            }
        });
        select2Arr.forEach((select)=>{
            if (!select.classList.contains("is-init")) {
                select.classList.add("is-init");
                const parentContainer = select.parentNode;
                const placeholderField = parentContainer.querySelector(".select2-search__field");
                const parentContainerWidth = parentContainer.offsetWidth;
                parentContainer.style.maxWidth = `${parentContainerWidth}px`;
                const selectedOptionsContainer = document.createElement("div");
                selectedOptionsContainer.classList.add("selected-options-container");
                parentContainer.appendChild(selectedOptionsContainer);
                const updateSelectedOptionsContainer = ()=>{
                    selectedOptionsContainer.innerHTML = "";
                    const selectedOptions = $(select).val() || [];
                    selectedOptions.forEach((optionValue)=>{
                        const optionText = $(select).find(`option[value="${optionValue}"]`).text();
                        const optionElement = document.createElement("span");
                        optionElement.classList.add("selected-option");
                        optionElement.textContent = optionText;
                        optionElement.addEventListener("click", ()=>{
                            const currentValues = $(select).val();
                            const newValues = currentValues.filter((value)=>value !== optionValue);
                            $(select).val(newValues).trigger("change");
                        });
                        selectedOptionsContainer.appendChild(optionElement);
                    });
                    if (selectedOptions.length > 0) {
                        selectedOptionsContainer.style.marginTop = "10px";
                        if (placeholderField) placeholderField.placeholder = placeholderText;
                    } else {
                        selectedOptionsContainer.style.marginTop = "0px";
                        if (placeholderField) placeholderField.placeholder = placeholderText;
                    }
                };
                $(select).on("change", updateSelectedOptionsContainer);
                updateSelectedOptionsContainer();
            }
        });
    });
};
initSelect2Func();
window.customSelectsLogic = function customSelectsLogic1() {
    const defaultCustomSelect = document.getElementsByClassName("default-custom-select")[0];
    if (defaultCustomSelect) {
        const defaultCustomSelectArr = document.querySelectorAll(".default-custom-select");
        defaultCustomSelectArr.forEach((customSelect, i)=>{
            const parentContainer = customSelect.parentElement;
            if (parentContainer.classList.contains("is-open")) customSelect.classList.add("active");
            if (!customSelect.classList.contains("is-init")) {
                customSelect.classList.add("is-init");
                const zIndexValue = defaultCustomSelectArr.length - i;
                customSelect.style.zIndex = zIndexValue + 10;
                const customSelectPlaceholder = customSelect.querySelector(".default-custom-select__placeholder");
                const customSelectList = customSelect.querySelector(".default-custom-select__list");
                const customSelectPlaceholderTextContent = customSelect.querySelector(".default-custom-select__placeholder").textContent;
                customSelectPlaceholder.setAttribute("data-original-placeholder", customSelectPlaceholderTextContent);
                customSelect.addEventListener("click", (e)=>{
                    if (!customSelect.classList.contains("active")) {
                        customSelect.classList.add("active");
                        parentContainer.classList.add("is-open");
                    } else if (!e.target.classList.contains("default-custom-select__list") && !e.target.closest(".default-custom-select__list")) {
                        customSelect.classList.remove("active");
                        parentContainer.classList.remove("is-open");
                    }
                });
                document.addEventListener("click", (event)=>{
                    if (!customSelectList.contains(event.target) && !customSelect.contains(event.target) && !event.target.closest(".default-custom-select__list")) {
                        customSelect.classList.remove("active");
                        parentContainer.classList.remove("is-open");
                    }
                });
                const checkboxesSelect = customSelect.querySelectorAll('input[type="checkbox"]');
                function placeholderCheck() {
                    const checkedCount = customSelect.querySelectorAll('input[type="checkbox"]:checked').length;
                    /*console.log(
            customSelect.querySelectorAll('input[type="checkbox"]:checked')
          );*/ if (checkedCount === 1) {
                        const checkedItem = customSelect.querySelector('input[type="checkbox"]:checked');
                        customSelectPlaceholder.textContent = checkedItem.nextElementSibling.nextElementSibling.textContent;
                    } else customSelectPlaceholder.textContent = checkedCount > 0 ? `${checkedCount} items selected` : customSelectPlaceholderTextContent;
                    const notCheckedInputArr = customSelect.querySelectorAll('input[type="checkbox"]:not(:checked)');
                    if (notCheckedInputArr.length > 0) for(let j = 0; j < notCheckedInputArr.length; j++)notCheckedInputArr[j].parentElement.classList.remove("is-checked");
                    if (checkedCount > 0) {
                        const checkedInputArr = customSelect.querySelectorAll('input[type="checkbox"]:checked');
                        checkedInputArr.forEach((checkedInput)=>{
                            const parentEl = checkedInput.parentElement;
                            parentEl.classList.add("is-checked");
                        });
                    }
                }
                function allChecked(checkbox) {
                    const checkboxAll = customSelect.querySelector('input[type="checkbox"][value="all"]');
                    if (checkbox.value === "all" && checkbox.checked) {
                        console.log(1);
                        for(let j = 0; j < checkboxesSelect.length; j++)checkboxesSelect[j].checked = true;
                    } else if (checkbox.value === "all" && checkbox.checked === false) {
                        console.log(2);
                        for(let j = 0; j < checkboxesSelect.length; j++)checkboxesSelect[j].checked = false;
                    } else if (checkboxAll.checked) checkboxAll.click();
                    console.log(checkboxAll);
                }
                checkboxesSelect.forEach((checkbox)=>{
                    checkbox.addEventListener("change", ()=>{
                        allChecked(checkbox);
                        placeholderCheck();
                    });
                });
                const checkboxes = document.querySelectorAll('input[type="checkbox"]');
                for(let j = 0; j < checkboxes.length; j++)checkboxes[j].addEventListener("change", ()=>{
                    /*allChecked(checkboxes[j]);*/ placeholderCheck();
                });
                placeholderCheck();
            }
        });
    }
};
customSelectsLogic();
window.initFieldChoices = function initChoices1(elementsArr) {
    const choicesDOM = document.querySelector(elementsArr);
    if (choicesDOM) {
        const choicesArr = document.querySelectorAll(`${elementsArr}`);
        for(let i = 0; i < choicesArr.length; i++)if (!choicesArr[i].classList.contains("is-init")) {
            choicesArr[i].classList.add("is-init");
            const parentContainer = choicesArr[i].parentNode.parentNode;
            const newOptionEl = parentContainer.querySelector(".profile-block__new-option");
            const choices = new Choices(choicesArr[i], {
                searchEnabled: false,
                itemSelectText: "",
                placeholder: true,
                removeItems: true,
                removeItemButton: true,
                maxItemCount: 5,
                shouldSort: false,
                shouldSortItems: false
            });
            choicesArr[i].addEventListener("change", function() {
                const selectedValue = choicesArr[i].value;
                console.log(choicesArr[i].value);
                if (selectedValue === "radio" || selectedValue === "checkboxes") newOptionEl?.classList.remove("is-hidden");
                else newOptionEl?.classList.add("is-hidden");
            });
            const initialValue = choicesArr[i].value;
            if (initialValue === "radio" || initialValue === "checkboxes") newOptionEl?.classList.remove("is-hidden");
            else newOptionEl?.classList.add("is-hidden");
        }
    }
};
initFieldChoices("[data-field-choices]");


const $123db17bd816f09a$var$ranges = document.querySelectorAll(".meta-range");
if ($123db17bd816f09a$var$ranges.length) $123db17bd816f09a$var$ranges.forEach((range)=>{
    const labelValue = range.querySelector("label span");
    const rangeInput = range.querySelector("input");
    labelValue.textContent = rangeInput.value;
    rangeInput.addEventListener("input", ()=>{
        labelValue.textContent = rangeInput.value;
    });
});
const $123db17bd816f09a$var$doubleRangeSliderInputs = ()=>{
    const doubleRange = document.getElementsByClassName("double-range-inputs")[0];
    if (doubleRange) {
        const slider = doubleRange.querySelector("#double-range-inputs");
        const max = +slider.dataset.max;
        const min = +slider.dataset.min;
        const unit = slider.dataset?.unit || "\xa3";
        const step = +slider.dataset.step;
        const inputs = doubleRange.querySelectorAll(".double-range-input");
        const units = doubleRange.querySelectorAll(".unit");
        const startValueMin = +inputs[0].value;
        const startValueMax = +inputs[1].value;
        noUiSlider.create(slider, {
            start: [
                startValueMin,
                startValueMax
            ],
            connect: true,
            margin: 10,
            step: step,
            range: {
                min: min,
                max: max
            }
        });
        units.forEach((elem)=>{
            elem.textContent = unit;
        });
        slider.noUiSlider.on("update", function(values, handle) {
            inputs[handle].value = Math.round(values[handle]);
        });
        inputs.forEach((elem, i)=>{
            elem.addEventListener("input", function() {
                elem.value = elem.value.replace(/[^\d.]/g, "");
                slider.noUiSlider.set(this.value);
            });
        });
    }
};
$123db17bd816f09a$var$doubleRangeSliderInputs();


// @ts-check
/**
 * Shorthand for `document.getElementsByClassName`
 *
 * @param {String} selClass - The selector's class
 * @param {Element|HTMLElement|Document} [parent=document] - Parent element
 *
 * @returns {HTMLCollectionOf<Element>} - The selected elements
 */ function $41d84434f5fde280$var$byClass(selClass, parent = document) {
    return parent.getElementsByClassName(selClass);
}
/**
 * Shorthand for `document.querySelector`
 *
 * @param {String} selector - Selector
 * @param {Element|HTMLElement|Document} [parent=document] - Parent element
 *
 * @returns {Element|HTMLElementTagNameMap|SVGElementTagNameMap|null} - The selected element
 */ function $41d84434f5fde280$var$query(selector, parent = document) {
    return parent.querySelector(selector);
}
/**
 * Shorthand for `document.querySelectorAll`
 *
 * @param {String} selector - Selector
 * @param {Element|HTMLElement|Document} [parent=document] - Parent element
 *
 * @returns {NodeList} - The selected element
 */ function $41d84434f5fde280$var$queryAll(selector, parent = document) {
    return parent.querySelectorAll(selector);
}
// @ts-check
/**
 * Foreach polyfill for NodeList and HTMLCollection
 * https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
 *
 * @param {Array<any>|NodeList|HTMLCollection} els - A list of elements
 * @param {foreachCB} fn - Callback containing ( value, index ) as arguments
 * @param {Function} [scope] - Scope
 */ function $41d84434f5fde280$var$forEachHTML(els, fn, scope) {
    for(let i = 0, numEls = els.length; i < numEls; i++)fn.call(scope, els[i], i);
}
// @ts-check
/**
 * Shorthand for `element.classList.add`, works with multiple nodes
 *
 * @param {Element|HTMLElement|HTMLCollection|NodeList} el - A list of elements
 * @param {...String} classes - Classes to add
 */ function $41d84434f5fde280$var$addClass(el, ...classes) {
    // @ts-ignore
    if (el.length === undefined) // @ts-ignore
    addClassEl(el, ...classes);
    else // @ts-ignore
    $41d84434f5fde280$var$forEachHTML(el, (currEl)=>{
        addClassEl(currEl, ...classes);
    });
    /**
   * Adds classes to a single element
   *
   * @param {Element|HTMLElement} elem - An HTML element
   * @param {...String} remClass - Classes to add
   */ function addClassEl(elem, ...remClass) {
        remClass.forEach((singleClass)=>{
            elem.classList.add(singleClass);
        });
    }
}
// @ts-check
/**
 * Shorthand for `element.addEventListener`
 *
 * @param {Element|HTMLElement|Window|Document|MediaQueryList} el - A list of elements
 * @param {String} ev - Event's name
 * @param {EventListenerOrEventListenerObject} fn - Event's function
 * @param {Object} [opts] - Optional event options
 */ function $41d84434f5fde280$var$addEvent(el, ev, fn, opts) {
    el.addEventListener(ev, fn, opts);
}
/**
 * Shorthand for `element.removeEventListener`
 *
 * @param {Element|HTMLElement|Window|Document|MediaQueryList} el - A list of elements
 * @param {String} ev - Event's name
 * @param {EventListenerOrEventListenerObject} fn - Event's function
 * @param {Object} [opts] - Optional event options
 */ function $41d84434f5fde280$var$removeEvent(el, ev, fn, opts) {
    el.removeEventListener(ev, fn, opts);
}
// @ts-check
/**
 * Shorthand for `element.getAttribute`
 *
 * @param {Element|HTMLElement} el - An HTML element
 * @param {String} attr - The attribute to retrieve
 *
 * @returns {String|null} - The attribute's value
 */ function $41d84434f5fde280$var$getAttr(el, attr) {
    return el.getAttribute(attr);
}
/**
 * Shorthand for `element.setAttribute`
 *
 * @param {Element|HTMLElement} el - An HTML element
 * @param {String} attr - The attribute to retrieve
 * @param {String} val - The value to set to the attribute
 */ function $41d84434f5fde280$var$setAttr(el, attr, val) {
    el.setAttribute(attr, val);
}
/**
 * Shorthand for `element.removeAttribute`
 *
 * @param {Element|HTMLElement} el - An HTML element
 * @param {String} attr - The attribute to remove
 */ function $41d84434f5fde280$var$remAttr(el, attr) {
    el.removeAttribute(attr);
}
/**
 * @typedef defaultOptions
 * @property {String} [css3easing='linear'] - A css3 transtion timing
 * @property {Number} [delayBeforeStart=1000] - Time in milliseconds before the marquee starts animating
 * @property {String} [direction='left'] - Direction towards which the marquee will animate ` 'left' | 'right' | 'up' | 'down'`
 * @property {Boolean} [duplicated=false] - Should the marquee be duplicated to show an effect of continuous flow. Use this only when the text is shorter than the container
 * @property {Number} [duration=5000] - Duration in milliseconds in which you want your element to travel
 * @property {Number} [gap=20] - Gap in pixels between the tickers. Will work only when the `duplicated` option is set to `true`
 * @property {Boolean} [pauseOnHover=false] - Pause the marquee on hover
 * @property {Boolean} [recalcResize=false] - Recalculate the marquee position on resize (breaks compatibility with jquery.marquee)
 * @property {Number} [speed=0] - Speed will override duration. Speed allows you to set a relatively constant marquee speed regardless of the width of the containing element. Speed is measured in pixels/second
 * @property {Boolean} [startVisible=false] - The marquee will be visible from the start if set to `true`
 */ const $41d84434f5fde280$var$defOpts = {
    css3easing: "linear",
    delayBeforeStart: 1000,
    direction: "left",
    duplicated: false,
    duration: 5000,
    gap: 20,
    pauseOnHover: false,
    recalcResize: false,
    speed: 0,
    startVisible: false
};
let $41d84434f5fde280$var$instances = 0;
/**
 * Vanilla js marquee based on jQuery.marquee
 * https://github.com/aamirafridi/jQuery.Marquee
 */ class $41d84434f5fde280$export$2e2bcd8739ae039 {
    /**
   * Constructor
   *
   * @param {Element} el - The element where the marquee is applied
   * @param {defaultOptions} opts - the options
   */ constructor(el, opts){
        if (typeof el === "undefined") throw new Error("el cannot be undefined");
        if (typeof el === "string") throw new Error("el cannot be just a selector");
        if (el === null) throw new Error("el cannot be null");
        opts = {
            ...$41d84434f5fde280$var$defOpts,
            ...opts
        };
        this.el = el;
        this._loopCount = 3;
        // Check for data-option since they have top priority
        for(const option in $41d84434f5fde280$var$defOpts){
            let currData = $41d84434f5fde280$var$getAttr(el, `data-${$41d84434f5fde280$var$defOpts[option]}`);
            if (currData !== null && currData !== "") {
                if (currData === "true" || currData === "false") currData = Boolean(currData);
                opts[option] = currData;
            }
        }
        // Reintroduce speed as an option. It calculates duration as a factor of the container width
        // measured in pixels per second.
        if (opts.speed) opts.duration = parseInt(el.clientWidth) / opts.speed * 1000;
        // no gap if not duplicated
        opts.gap = opts.duplicated ? parseInt(opts.gap) : 0;
        // wrap inner content into a div
        el.innerHTML = `<div class="js-marquee">${el.innerHTML}</div>`;
        // Make a copy of the element
        const marq = $41d84434f5fde280$var$byClass("js-marquee", el)[0];
        marq.style.marginRight = `${opts.gap}px`;
        marq.style.willChange = "transform";
        marq.style.float = "left";
        if (opts.duplicated) el.appendChild(marq.cloneNode(true));
        // wrap both inner elements into one div
        el.innerHTML = `<div style="width:100000px" class="js-marquee-wrapper">${el.innerHTML}</div>`;
        // Save the reference of the wrapper
        const marqWrap = $41d84434f5fde280$var$byClass("js-marquee-wrapper", el)[0], vertical = opts.direction === "up" || opts.direction === "down";
        this._marqWrap = marqWrap;
        this._vertical = vertical;
        this._duration = opts.duration;
        this._opts = opts;
        this._calcSizes();
        const animationName = `marqueeAnimation-${Math.floor(Math.random() * 10000000)}`, animStr = this._animationStr(animationName, opts.duration / 1000, opts.delayBeforeStart / 1000, "infinite");
        this._animName = animationName;
        this._animStr = animStr;
        // if duplicated option is set to true than position the wrapper
        if (opts.duplicated) {
            if (vertical) {
                if (opts.startVisible) this._marqWrap.style.transform = "translateY(0px)";
                else this._marqWrap.style.transform = `translateY(${opts.direction === "up" ? this._contHeight : -1 * (this._elHeight * 2 - opts.gap)}px)`;
            } else if (opts.startVisible) this._marqWrap.style.transform = "translateX(0px)";
            else this._marqWrap.style.transform = `translateX(${opts.direction === "left" ? this._contWidth : -1 * (this._elWidth * 2 - opts.gap)}px)`;
            // If the text starts out visible we can skip the two initial loops
            if (!opts.startVisible) this._loopCount = 1;
        } else if (opts.startVisible) // We only have two different loops if marquee is duplicated and starts visible
        this._loopCount = 2;
        else if (vertical) this._repositionVert();
        else this._repositionHor();
        $41d84434f5fde280$var$addEvent(this.el, "pause", this.pause.bind(this));
        $41d84434f5fde280$var$addEvent(this.el, "resume", this.resume.bind(this));
        if (opts.pauseOnHover) {
            $41d84434f5fde280$var$addEvent(this.el, "mouseover", this.pause.bind(this));
            $41d84434f5fde280$var$addEvent(this.el, "mouseout", this.resume.bind(this));
        }
        /**
     * Method for animation end event
     */ this._animEnd = ()=>{
            this._animate(vertical);
            this.el.dispatchEvent(new CustomEvent("finished"));
        };
        this._instance = $41d84434f5fde280$var$instances;
        $41d84434f5fde280$var$instances++;
        this._animate(vertical);
        if (opts.recalcResize) $41d84434f5fde280$var$addEvent(window, "resize", this._recalcResize.bind(this));
    }
    /**
   * Build the css string for the animation
   *
   * @privte
   * @param {String} [name=''] - animation name
   * @param {Number} [duration=0] - Animation duration (in s)
   * @param {Number} [delay=0] - Animation delay before starting (in s)
   * @param {String} [loops=''] - Animation iterations
   *
   * @returns {String} css animation string
   */ _animationStr(name = "", duration = 0, delay = 0, loops = "") {
        return `${name} ${duration}s ${delay}s ${loops} ${this._opts.css3easing}`;
    }
    /**
   * Animation of the marquee
   *
   * @private
   * @param {Boolean} vertical - Vertical direction
   */ _animate(vertical = false) {
        const opts = this._opts;
        if (opts.duplicated) {
            // When duplicated, the first loop will be scroll longer so double the duration
            if (this._loopCount === 1) {
                let duration = opts.duration;
                if (vertical) duration = opts.direction === "up" ? duration + this._contHeight / (this._elHeight / duration) : duration * 2;
                else duration = opts.direction === "left" ? duration + this._contWidth / (this._elWidth / duration) : duration * 2;
                this._animStr = this._animationStr(this._animName, duration / 1000, opts.delayBeforeStart / 1000);
            // On 2nd loop things back to normal, normal duration for the rest of animations
            } else if (this._loopCount === 2) {
                this._animName = `${this._animName}0`;
                this._animStr = this._animationStr(this._animName, opts.duration / 1000, 0, "infinite");
            }
            this._loopCount++;
        }
        let animationCss = "";
        if (vertical) {
            if (opts.duplicated) {
                // Adjust the starting point of animation only when first loops finishes
                if (this._loopCount > 2) this._marqWrap.style.transform = `translateY(${opts.direction === "up" ? 0 : -1 * this._elHeight}px)`;
                animationCss = `translateY(${opts.direction === "up" ? -1 * this._elHeight : 0}px)`;
            } else if (opts.startVisible) {
                // This loop moves the marquee out of the container
                if (this._loopCount === 2) {
                    // Adjust the css3 animation as well
                    this._animStr = this._animationStr(this._animName, opts.duration / 1000, opts.delayBeforeStart / 1000);
                    animationCss = `translateY(${opts.direction === "up" ? -1 * this._elHeight : this._contHeight}px)`;
                    this._loopCount++;
                } else if (this._loopCount === 3) {
                    this._animName = `${this._animName}0`;
                    this._animStr = this._animationStr(this._animName, this._completeDuration / 1000, 0, "infinite");
                    this._repositionVert();
                }
            } else {
                this._repositionVert();
                animationCss = `translateY(${opts.direction === "up" ? -1 * this._marqWrap.clientHeight : this._contHeight}px)`;
            }
        } else {
            if (opts.duplicated) {
                // Adjust the starting point of animation only when first loops finishes
                if (this._loopCount > 2) this._marqWrap.style.transform = `translateX(${opts.direction === "left" ? 0 : -1 * this._elWidth}px)`;
                animationCss = `translateX(${opts.direction === "left" ? -1 * this._elWidth : 0}px)`;
            } else if (opts.startVisible) {
                // This loop moves the marquee out of the container
                if (this._loopCount === 2) {
                    // Adjust the css3 animation as well
                    this._animStr = this._animationStr(this._animName, opts.duration / 1000, opts.delayBeforeStart / 1000);
                    animationCss = `translateX(${opts.direction === "left" ? -1 * this._elWidth : this._contWidth}px)`;
                    this._loopCount++;
                } else if (this._loopCount === 3) {
                    // Adjust the animation
                    this._animName = `${this._animName}0`;
                    this._animStr = this._animationStr(this._animName, opts.duration / 1000, 0, "infinite");
                    this._repositionHor();
                }
            } else {
                this._repositionHor();
                animationCss = `translateX(${opts.direction === "left" ? -1 * this._elWidth : this._contWidth}px)`;
            }
        }
        // fire event
        this.el.dispatchEvent(new CustomEvent("beforeStarting"));
        // Append animation
        this._marqWrap.style.animation = this._animStr;
        const keyFrameCss = `@keyframes ${this._animName} {
        100% {
          transform: ${animationCss};
        }
      }`, styles = $41d84434f5fde280$var$queryAll("style", this._marqWrap);
        if (styles.length) styles[styles.length - 1].innerHTML = keyFrameCss;
        else if ($41d84434f5fde280$var$byClass(`marq-wrap-style-${this._instance}`).length) $41d84434f5fde280$var$byClass(`marq-wrap-style-${this._instance}`)[0].innerHTML = keyFrameCss;
        else {
            const styleEl = document.createElement("style");
            $41d84434f5fde280$var$addClass(styleEl, `marq-wrap-style-${this._instance}`);
            styleEl.innerHTML = keyFrameCss;
            $41d84434f5fde280$var$query("head").appendChild(styleEl);
        }
        // Animation iteration event
        $41d84434f5fde280$var$addEvent(this._marqWrap, "animationiteration", this._animIter.bind(this), {
            once: true
        });
        // Animation stopped
        $41d84434f5fde280$var$addEvent(this._marqWrap, "animationend", this._animEnd.bind(this), {
            once: true
        });
        this._status = "running";
        $41d84434f5fde280$var$setAttr(this.el, "data-runningStatus", "resumed");
    }
    /**
   * Event fired on Animation iteration
   *
   * @private
   */ _animIter() {
        this.el.dispatchEvent(new CustomEvent("finished"));
    }
    /**
   * Reposition the Wrapper vertically
   *
   * @private
   */ _repositionVert() {
        this._marqWrap.style.transform = `translateY(${this._opts.direction === "up" ? this._contHeight : this._elHeight * -1}px)`;
    }
    /**
   * Reposition the Wrapper horizontally
   *
   * @private
   */ _repositionHor() {
        this._marqWrap.style.transform = `translateX(${this._opts.direction === "left" ? this._contWidth : this._elWidth * -1}px)`;
    }
    /**
   * Calculates the speed and the dimension of the marquee
   *
   * @private
   */ _calcSizes() {
        const el = this.el, opts = this._opts;
        // If direction is up or down, get the height of main element
        if (this._vertical) {
            const contHeight = el.clientHeight;
            this._contHeight = contHeight;
            $41d84434f5fde280$var$remAttr(this._marqWrap, "style");
            el.style.clientHeight = `${contHeight}px`;
            const marqs = $41d84434f5fde280$var$byClass("js-marquee", el), marqNums = marqs.length - 1;
            // Change the CSS for js-marquee element
            $41d84434f5fde280$var$forEachHTML(marqs, (currEl, ind)=>{
                currEl.style.float = "none";
                currEl.style.marginRight = "0px";
                // Remove bottom margin from 2nd element if duplicated
                if (opts.duplicated && ind === marqNums) currEl.style.marginBottom = "0px";
                else currEl.style.marginBottom = `${opts.gap}px`;
            });
            const elHeight = parseInt(marqs[0].clientHeight + opts.gap);
            this._elHeight = elHeight;
            // adjust the animation duration according to the text length
            if (opts.startVisible && !opts.duplicated) {
                // Compute the complete animation duration and save it for later reference
                // formula is to: (Height of the text node + height of the main container / Height of the main container) * duration;
                this._completeDuration = (elHeight + contHeight) / parseInt(contHeight) * this._duration; // eslint-disable-line max-len
                opts.duration = elHeight / parseInt(contHeight) * this._duration;
            } else opts.duration = elHeight / parseInt(contHeight) / parseInt(contHeight) * this._duration;
        } else {
            // Save the width of the each element so we can use it in animation
            const elWidth = parseInt($41d84434f5fde280$var$byClass("js-marquee", el)[0].clientWidth + opts.gap), contWidth = el.clientWidth;
            this._contWidth = contWidth;
            this._elWidth = elWidth;
            // adjust the animation duration according to the text length
            if (opts.startVisible && !opts.duplicated) {
                // Compute the complete animation duration and save it for later reference
                // formula is to: (Width of the text node + width of the main container / Width of the main container) * duration;
                this._completeDuration = (elWidth + contWidth) / parseInt(contWidth) * this._duration;
                // (Width of the text node / width of the main container) * duration
                opts.duration = elWidth / parseInt(contWidth) * this._duration;
            } else opts.duration = (elWidth + parseInt(contWidth)) / parseInt(contWidth) * this._duration; // eslint-disable-line max-len
        }
        // if duplicated then reduce the duration
        if (opts.duplicated) opts.duration = opts.duration / 2;
    }
    /**
   * Recalculates the dimensions and positon of the marquee on page resize
   *
   * @private
   */ _recalcResize() {
        this._calcSizes();
        this._loopCount = 2;
        this._animEnd();
    }
    /**
   * Pause the animation
   */ pause() {
        this._marqWrap.style.animationPlayState = "paused";
        this._status = "paused";
        $41d84434f5fde280$var$setAttr(this.el, "data-runningStatus", "paused");
        this.el.dispatchEvent(new CustomEvent("paused"));
    }
    /**
   * Resume the animation
   */ resume() {
        this._marqWrap.style.animationPlayState = "running";
        this._status = "running";
        $41d84434f5fde280$var$setAttr(this.el, "data-runningStatus", "resumed");
        this.el.dispatchEvent(new CustomEvent("resumed"));
    }
    /**
   * Toggle animation playing status
   */ toggle() {
        if (this._status === "paused") this.resume();
        else if (this._status === "running") this.pause();
    }
    /**
   * Destorys the instance and removes events
   */ destroy() {
        $41d84434f5fde280$var$removeEvent(this.el, "pause", this.pause.bind(this));
        $41d84434f5fde280$var$removeEvent(this.el, "resume", this.resume.bind(this));
        if (this._opts.pauseOnHover) {
            $41d84434f5fde280$var$removeEvent(this.el, "mouseover", this.pause.bind(this));
            $41d84434f5fde280$var$removeEvent(this.el, "mouseout", this.resume.bind(this));
        }
        $41d84434f5fde280$var$removeEvent(this._marqWrap, "animationiteration", this._animIter.bind(this), {
            once: true
        });
        $41d84434f5fde280$var$removeEvent(this._marqWrap, "animationend", this._animEnd.bind(this), {
            once: true
        });
        if (this._opts.recalcResize) $41d84434f5fde280$var$removeEvent(window, "resize", this._recalcResize.bind(this));
    }
    /**
   * Forces a refresh (like recalcResize) but done manually
   */ refresh() {
        this._recalcResize();
    }
}


/*let speedMarque = 20;

if (document.getElementById('marquee_1')) {
  if (window.innerWidth <= 640) {
    speedMarque = 10;
  }
  new marquee(document.getElementById('marquee_1'), {
    duplicated: true,
    gap: 12,
    speed: speedMarque,
    pauseOnHover: true,
    recalcResize: false,
    startVisible: true,
  });
}

if (document.getElementById('marquee_2')) {
  new marquee(document.getElementById('marquee_2'), {
    duplicated: true,
    gap: 12,
    speed: speedMarque,
    pauseOnHover: true,
    direction: 'right',
    recalcResize: false,
    startVisible: true,
  });
}*/ if (document.querySelector(".clients__marquee")) {
    const marqueeArray = [];
    const marqueeArr = document.querySelectorAll(".clients__marquee");
    marqueeArr.forEach((marqueeEl, i)=>{
        /* const itemsArr = marqueeEl.querySelectorAll('.clients__logo');
    itemsArr.forEach((itemEl) => {
      const clone = itemEl.cloneNode(true);
      marqueeEl.appendChild(clone);
    });
    itemsArr.forEach((itemEl) => {
      const clone = itemEl.cloneNode(true);
      marqueeEl.appendChild(clone);
    });
    itemsArr.forEach((itemEl) => {
      const clone = itemEl.cloneNode(true);
      marqueeEl.appendChild(clone);
    });*/ const container = 1440;
        const finalItemsArr = marqueeEl.querySelectorAll(".clients__logo");
        let duration = 5000;
        const totalWidth = finalItemsArr.length * (finalItemsArr[0].clientWidth + 12);
        let baseSpeed = 4;
        const scalingFactor = window.innerWidth < 768 ? 1.1 : 1.5;
        baseSpeed *= scalingFactor;
        duration = totalWidth / window.innerWidth * baseSpeed;
        let direction = "up";
        let pauseOnHover = true;
        if (window.innerWidth <= 1024) pauseOnHover = false;
        direction = "left";
        if (i % 2) direction = "right";
        const mq = new (0, $41d84434f5fde280$export$2e2bcd8739ae039)(marqueeEl, {
            delayBeforeStart: 0,
            direction: direction,
            pauseOnHover: pauseOnHover,
            duplicated: true,
            recalcResize: true,
            startVisible: true,
            gap: 12,
            duration: duration * 1000
        });
        marqueeArray.push(mq);
        if (window.innerWidth <= 1024) setTimeout(function() {
            const itemsArr = marqueeEl.querySelectorAll(".clients__logo");
            itemsArr.forEach((item)=>{
                item.addEventListener("click", (e)=>{
                    if (item.classList.contains("is-hover")) {
                        item.classList.remove("is-hover");
                        mq.resume();
                    } else {
                        const newArr = document.querySelectorAll(".clients__logo");
                        for(let j = 0; j < newArr.length; j++)newArr[j].classList.remove("is-hover");
                        item.classList.add("is-hover");
                        for(let j = 0; j < marqueeArray.length; j++)marqueeArray[j].resume();
                        mq.pause();
                    }
                });
            });
        }, 100);
    });
    document.addEventListener("click", function(event) {
        if (!marqueeArr[0].parentElement.contains(event.target)) {
            const newArr = document.querySelectorAll(".clients__logo");
            for(let j = 0; j < newArr.length; j++)newArr[j].classList.remove("is-hover");
            for(let j = 0; j < marqueeArray.length; j++)marqueeArray[j].resume();
        }
    });
}


const $0ccaa1c6c17cf942$var$togetherList = document.querySelector(".together-section__list");
if ($0ccaa1c6c17cf942$var$togetherList) {
    const togetherItemsArr = $0ccaa1c6c17cf942$var$togetherList.querySelectorAll(".together-section__item");
    togetherItemsArr.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            if (!item.classList.contains("active")) {
                for(let i = 0; i < togetherItemsArr.length; i++)togetherItemsArr[i].classList.remove("active");
                item.classList.add("active");
            }
        });
    });
}




document.addEventListener("DOMContentLoaded", ()=>{
    const extraItemsLinks = document.querySelectorAll(".news-section__bottom-link");
    extraItemsLinks.forEach((link)=>{
        link.addEventListener("click", (event)=>{
            event.preventDefault();
            const isActive = link.classList.contains("active");
            // Убираем класс 'active' у всех ссылок и элементов extra-items
            extraItemsLinks.forEach((item)=>{
                item.classList.remove("active");
                const bottomSection = item.closest(".news-section__bottom");
                const extraItems = bottomSection.querySelector(".extra-items");
                extraItems.classList.remove("active");
            });
            if (!isActive) {
                const bottomSection = link.closest(".news-section__bottom");
                const extraItems = bottomSection.querySelector(".extra-items");
                link.classList.add("active");
                extraItems.classList.add("active");
            }
        });
    });
});


const $0dc0d94a00eaf343$var$profileComponent = document.querySelector(".profile");
if ($0dc0d94a00eaf343$var$profileComponent) {
    const profileSidebar = $0dc0d94a00eaf343$var$profileComponent.querySelector(".profile-sidebar");
    const profileSidebarBtn = $0dc0d94a00eaf343$var$profileComponent.querySelector(".profile-sidebar__btn");
    const profileOpenMobBtn = $0dc0d94a00eaf343$var$profileComponent.querySelector(".profile-mob-open.fixed-btn");
    const profileOpenMob = $0dc0d94a00eaf343$var$profileComponent.querySelector(".profile-mob-open");
    const profileContainer = $0dc0d94a00eaf343$var$profileComponent.querySelector(".profile-container");
    const profileSideBarLinks = $0dc0d94a00eaf343$var$profileComponent.querySelectorAll(".profile-sidebar__link");
    function openSidebarFunc() {
        const isOpen = $0dc0d94a00eaf343$var$profileComponent.classList.contains("is-open-sidebar");
        if (!isOpen) {
            $0dc0d94a00eaf343$var$profileComponent.classList.add("is-open-sidebar");
            localStorage.setItem("profileSidebarState", "open");
        } else {
            $0dc0d94a00eaf343$var$profileComponent.classList.remove("is-open-sidebar");
            localStorage.setItem("profileSidebarState", "closed");
        }
    }
    function closeSideBarFunc() {
        if ($0dc0d94a00eaf343$var$profileComponent.classList.contains("is-open-sidebar")) {
            $0dc0d94a00eaf343$var$profileComponent.classList.remove("is-open-sidebar");
            localStorage.setItem("profileSidebarState", "closed");
        }
    }
    profileSidebarBtn.addEventListener("click", ()=>{
        openSidebarFunc();
    });
    profileOpenMobBtn.addEventListener("click", ()=>{
        openSidebarFunc();
    });
    profileOpenMob.addEventListener("click", ()=>{
        openSidebarFunc();
    });
    profileContainer.addEventListener("click", ()=>{
        if (window.innerWidth <= 851 && $0dc0d94a00eaf343$var$profileComponent.classList.contains("is-open-sidebar")) {
            $0dc0d94a00eaf343$var$profileComponent.classList.remove("is-open-sidebar");
            localStorage.setItem("profileSidebarState", "closed");
        }
    });
    if (window.innerWidth < 850) profileSideBarLinks.forEach((link)=>{
        link.addEventListener("click", ()=>{
            closeSideBarFunc();
        });
    });
}


/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $bsOiL = parcelRequire("bsOiL");

var $dgs9t = parcelRequire("dgs9t");
const $09a2488a0b838f2a$var$Methods = {
    addClass: $dgs9t.addClass,
    removeClass: $dgs9t.removeClass,
    hasClass: $dgs9t.hasClass,
    toggleClass: $dgs9t.toggleClass,
    attr: $dgs9t.attr,
    removeAttr: $dgs9t.removeAttr,
    transform: $dgs9t.transform,
    transition: $dgs9t.transition,
    on: $dgs9t.on,
    off: $dgs9t.off,
    trigger: $dgs9t.trigger,
    transitionEnd: $dgs9t.transitionEnd,
    outerWidth: $dgs9t.outerWidth,
    outerHeight: $dgs9t.outerHeight,
    styles: $dgs9t.styles,
    offset: $dgs9t.offset,
    css: $dgs9t.css,
    each: $dgs9t.each,
    html: $dgs9t.html,
    text: $dgs9t.text,
    is: $dgs9t.is,
    index: $dgs9t.index,
    eq: $dgs9t.eq,
    append: $dgs9t.append,
    prepend: $dgs9t.prepend,
    next: $dgs9t.next,
    nextAll: $dgs9t.nextAll,
    prev: $dgs9t.prev,
    prevAll: $dgs9t.prevAll,
    parent: $dgs9t.parent,
    parents: $dgs9t.parents,
    closest: $dgs9t.closest,
    find: $dgs9t.find,
    children: $dgs9t.children,
    filter: $dgs9t.filter,
    remove: $dgs9t.remove
};
Object.keys($09a2488a0b838f2a$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $dgs9t.$).fn, methodName, {
        value: $09a2488a0b838f2a$var$Methods[methodName],
        writable: true
    });
});
var $09a2488a0b838f2a$export$2e2bcd8739ae039 = (0, $dgs9t.$);



var $bsOiL = parcelRequire("bsOiL");
function $66763f78a062fe47$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $66763f78a062fe47$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $66763f78a062fe47$export$461939dd4422153() {
    return Date.now();
}
function $66763f78a062fe47$export$3735103072e4a80(el) {
    const window1 = (0, $bsOiL.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $66763f78a062fe47$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $bsOiL.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $66763f78a062fe47$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $66763f78a062fe47$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $66763f78a062fe47$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $66763f78a062fe47$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$66763f78a062fe47$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($66763f78a062fe47$export$a6cdc56e425d0d0a(to[nextKey]) && $66763f78a062fe47$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $66763f78a062fe47$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$66763f78a062fe47$export$a6cdc56e425d0d0a(to[nextKey]) && $66763f78a062fe47$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $66763f78a062fe47$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $66763f78a062fe47$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $66763f78a062fe47$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $bsOiL.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $bsOiL = parcelRequire("bsOiL");
let $d37d3ba6ecfe5a72$var$support;
function $d37d3ba6ecfe5a72$var$calcSupport() {
    const window = (0, $bsOiL.getWindow)();
    const document = (0, $bsOiL.getDocument)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $d37d3ba6ecfe5a72$export$d61c7b85ff180578() {
    if (!$d37d3ba6ecfe5a72$var$support) $d37d3ba6ecfe5a72$var$support = $d37d3ba6ecfe5a72$var$calcSupport();
    return $d37d3ba6ecfe5a72$var$support;
}



var $bsOiL = parcelRequire("bsOiL");

let $ae582f4d24f7c2fb$var$deviceCached;
function $ae582f4d24f7c2fb$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $d37d3ba6ecfe5a72$export$d61c7b85ff180578)();
    const window = (0, $bsOiL.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel"; // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $ae582f4d24f7c2fb$export$30c823bc834d6ab4(overrides = {}) {
    if (!$ae582f4d24f7c2fb$var$deviceCached) $ae582f4d24f7c2fb$var$deviceCached = $ae582f4d24f7c2fb$var$calcDevice(overrides);
    return $ae582f4d24f7c2fb$var$deviceCached;
}



var $bsOiL = parcelRequire("bsOiL");
let $a30ceb5533f64505$var$browser;
function $a30ceb5533f64505$var$calcBrowser() {
    const window = (0, $bsOiL.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $a30ceb5533f64505$export$89e15fc796a4a429() {
    if (!$a30ceb5533f64505$var$browser) $a30ceb5533f64505$var$browser = $a30ceb5533f64505$var$calcBrowser();
    return $a30ceb5533f64505$var$browser;
}



var $bsOiL = parcelRequire("bsOiL");
function $cd460839c9cbbc59$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $bsOiL.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}



var $bsOiL = parcelRequire("bsOiL");
function $ef57bcfb5c097272$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $bsOiL.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}


/* eslint-disable no-underscore-dangle */ var $6a8281605c772701$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $210f60d32123e8e7$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $68eb0cf121c59169$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $426fa933ee75f219$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", `${newHeight}px`);
}


function $2af765414d9eaf96$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $b85aeb1d32e07acf$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $25eb2b21e967947d$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}


function $98a889da9c221704$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $133b671b7a081d15$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}



function $b7207ab419786c61$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $75ff85ec5879b45b$export$2e2bcd8739ae039 = {
    updateSize: $210f60d32123e8e7$export$2e2bcd8739ae039,
    updateSlides: $68eb0cf121c59169$export$2e2bcd8739ae039,
    updateAutoHeight: $426fa933ee75f219$export$2e2bcd8739ae039,
    updateSlidesOffset: $2af765414d9eaf96$export$2e2bcd8739ae039,
    updateSlidesProgress: $b85aeb1d32e07acf$export$2e2bcd8739ae039,
    updateProgress: $25eb2b21e967947d$export$2e2bcd8739ae039,
    updateSlidesClasses: $98a889da9c221704$export$2e2bcd8739ae039,
    updateActiveIndex: $133b671b7a081d15$export$2e2bcd8739ae039,
    updateClickedSlide: $b7207ab419786c61$export$2e2bcd8739ae039
};



function $0546a0b151930c41$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $66763f78a062fe47$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $7ac2389e38f913c5$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}


function $5b58634c8d191622$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $7aa1f25adfe5bdab$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $5798041355eced0a$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $66763f78a062fe47$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $962db72774df1284$export$2e2bcd8739ae039 = {
    getTranslate: $0546a0b151930c41$export$2e2bcd8739ae039,
    setTranslate: $7ac2389e38f913c5$export$2e2bcd8739ae039,
    minTranslate: $5b58634c8d191622$export$2e2bcd8739ae039,
    maxTranslate: $7aa1f25adfe5bdab$export$2e2bcd8739ae039,
    translateTo: $5798041355eced0a$export$2e2bcd8739ae039
};


function $3190c9998aec4ae7$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}


function $24e62f98c4361c80$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $f4d802a159993cd3$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $24e62f98c4361c80$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}



function $2b50bb871008a11b$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $24e62f98c4361c80$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}


var $89616bdae253e41c$export$2e2bcd8739ae039 = {
    setTransition: $3190c9998aec4ae7$export$2e2bcd8739ae039,
    transitionStart: $f4d802a159993cd3$export$2e2bcd8739ae039,
    transitionEnd: $2b50bb871008a11b$export$2e2bcd8739ae039
};



function $6ea64ad839f2c279$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== "number" && typeof index !== "string") throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $66763f78a062fe47$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $a4e955b960cd8fc8$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $4fb48a23c4503556$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $19c996edfff8eb5b$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $0e118ee037a33a24$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $a7269f78c96724cc$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $e8252889e03a0b18$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $a6edf884942961cd$export$2e2bcd8739ae039 = {
    slideTo: $6ea64ad839f2c279$export$2e2bcd8739ae039,
    slideToLoop: $a4e955b960cd8fc8$export$2e2bcd8739ae039,
    slideNext: $4fb48a23c4503556$export$2e2bcd8739ae039,
    slidePrev: $19c996edfff8eb5b$export$2e2bcd8739ae039,
    slideReset: $0e118ee037a33a24$export$2e2bcd8739ae039,
    slideToClosest: $a7269f78c96724cc$export$2e2bcd8739ae039,
    slideToClickedSlide: $e8252889e03a0b18$export$2e2bcd8739ae039
};



var $bsOiL = parcelRequire("bsOiL");

function $14baa2eb2e7097b0$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $bsOiL.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $a4c52dcbb96873be$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}


function $2d57ee0418aa66b4$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
}


var $f15e4c9cc0e03817$export$2e2bcd8739ae039 = {
    loopCreate: $14baa2eb2e7097b0$export$2e2bcd8739ae039,
    loopFix: $a4c52dcbb96873be$export$2e2bcd8739ae039,
    loopDestroy: $2d57ee0418aa66b4$export$2e2bcd8739ae039
};


function $da7fb8973a20037f$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
}


function $0b67149cd017787a$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}


var $5be8069dbb5c8df7$export$2e2bcd8739ae039 = {
    setGrabCursor: $da7fb8973a20037f$export$2e2bcd8739ae039,
    unsetGrabCursor: $0b67149cd017787a$export$2e2bcd8739ae039
};



var $bsOiL = parcelRequire("bsOiL");

var $bsOiL = parcelRequire("bsOiL");


function $354123c9cafb5485$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $bsOiL.getDocument)() || el === (0, $bsOiL.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $354123c9cafb5485$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $bsOiL.getDocument)();
    const window = (0, $bsOiL.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ""; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $354123c9cafb5485$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === "SELECT") data.isTouched = false;
        }
        if (document.activeElement && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}



var $bsOiL = parcelRequire("bsOiL");


function $99259322ff43828e$export$2e2bcd8739ae039(event) {
    const document = (0, $bsOiL.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $66763f78a062fe47$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $bbede752bca22337$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $1572e748929275a7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $c4b0db16c657f9a5$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $b228fe3831925206$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}


let $7e78f1d37a3135f1$var$dummyEventAttached = false;
function $7e78f1d37a3135f1$var$dummyEventListener() {}
const $7e78f1d37a3135f1$var$events = (swiper, method)=>{
    const document = (0, $bsOiL.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $1572e748929275a7$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]("observerUpdate", (0, $1572e748929275a7$export$2e2bcd8739ae039), true);
};
function $7e78f1d37a3135f1$var$attachEvents() {
    const swiper = this;
    const document = (0, $bsOiL.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $354123c9cafb5485$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $99259322ff43828e$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $bbede752bca22337$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $b228fe3831925206$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $c4b0db16c657f9a5$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$7e78f1d37a3135f1$var$dummyEventAttached) {
        document.addEventListener("touchstart", $7e78f1d37a3135f1$var$dummyEventListener);
        $7e78f1d37a3135f1$var$dummyEventAttached = true;
    }
    $7e78f1d37a3135f1$var$events(swiper, "on");
}
function $7e78f1d37a3135f1$var$detachEvents() {
    const swiper = this;
    $7e78f1d37a3135f1$var$events(swiper, "off");
}
var $7e78f1d37a3135f1$export$2e2bcd8739ae039 = {
    attachEvents: $7e78f1d37a3135f1$var$attachEvents,
    detachEvents: $7e78f1d37a3135f1$var$detachEvents
};



const $e4e317f56ed14b72$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $e4e317f56ed14b72$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $e4e317f56ed14b72$var$isGridEnabled(swiper, params);
    const isMultiRow = $e4e317f56ed14b72$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $66763f78a062fe47$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}



var $bsOiL = parcelRequire("bsOiL");
function $6c086ee93f033c59$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $bsOiL.getWindow)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}


var $1dbac7449a9a70b4$export$2e2bcd8739ae039 = {
    setBreakpoint: $e4e317f56ed14b72$export$2e2bcd8739ae039,
    getBreakpoint: $6c086ee93f033c59$export$2e2bcd8739ae039
};


function $242fed346075ae93$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $242fed346075ae93$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $242fed346075ae93$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(" "));
    swiper.emitContainerClasses();
}


function $7b231c1bcc1cd8d1$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}


var $e34e3657ee98588a$export$2e2bcd8739ae039 = {
    addClasses: $242fed346075ae93$export$2e2bcd8739ae039,
    removeClasses: $7b231c1bcc1cd8d1$export$2e2bcd8739ae039
};



var $bsOiL = parcelRequire("bsOiL");

function $e8d5422f90e359ec$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $bsOiL.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $353418d5bf56f01e$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}


var $6c5c43237fe6188b$export$2e2bcd8739ae039 = {
    loadImage: $e8d5422f90e359ec$export$2e2bcd8739ae039,
    preloadImages: $353418d5bf56f01e$export$2e2bcd8739ae039
};


function $489d4307d1a2a0a4$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $489d4307d1a2a0a4$export$2e2bcd8739ae039 = {
    checkOverflow: $489d4307d1a2a0a4$var$checkOverflow
};


var $39dec5f93d59aafb$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $a630f0dbc46875f1$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $66763f78a062fe47$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $66763f78a062fe47$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $66763f78a062fe47$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $41c4fba6d5b8bc4d$var$prototypes = {
    eventsEmitter: $6a8281605c772701$export$2e2bcd8739ae039,
    update: $75ff85ec5879b45b$export$2e2bcd8739ae039,
    translate: $962db72774df1284$export$2e2bcd8739ae039,
    transition: $89616bdae253e41c$export$2e2bcd8739ae039,
    slide: $a6edf884942961cd$export$2e2bcd8739ae039,
    loop: $f15e4c9cc0e03817$export$2e2bcd8739ae039,
    grabCursor: $5be8069dbb5c8df7$export$2e2bcd8739ae039,
    events: $7e78f1d37a3135f1$export$2e2bcd8739ae039,
    breakpoints: $1dbac7449a9a70b4$export$2e2bcd8739ae039,
    checkOverflow: $489d4307d1a2a0a4$export$2e2bcd8739ae039,
    classes: $e34e3657ee98588a$export$2e2bcd8739ae039,
    images: $6c5c43237fe6188b$export$2e2bcd8739ae039
};
const $41c4fba6d5b8bc4d$var$extendedDefaults = {};
class $41c4fba6d5b8bc4d$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $41c4fba6d5b8bc4d$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $d37d3ba6ecfe5a72$export$d61c7b85ff180578)();
        swiper.device = (0, $ae582f4d24f7c2fb$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $a30ceb5533f64505$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $a630f0dbc46875f1$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, (0, $39dec5f93d59aafb$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, swiperParams, $41c4fba6d5b8bc4d$var$extendedDefaults, params);
        swiper.originalParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                const desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $66763f78a062fe47$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $bsOiL.getDocument)();
            const wrapper = document.createElement("div");
            $wrapperEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $66763f78a062fe47$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $66763f78a062fe47$export$8b58be045bf06082)($41c4fba6d5b8bc4d$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $41c4fba6d5b8bc4d$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $39dec5f93d59aafb$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$41c4fba6d5b8bc4d$var$Swiper.prototype.__modules__) $41c4fba6d5b8bc4d$var$Swiper.prototype.__modules__ = [];
        const modules = $41c4fba6d5b8bc4d$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$41c4fba6d5b8bc4d$var$Swiper.installModule(m));
            return $41c4fba6d5b8bc4d$var$Swiper;
        }
        $41c4fba6d5b8bc4d$var$Swiper.installModule(module);
        return $41c4fba6d5b8bc4d$var$Swiper;
    }
}
Object.keys($41c4fba6d5b8bc4d$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($41c4fba6d5b8bc4d$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $41c4fba6d5b8bc4d$var$Swiper.prototype[protoMethod] = $41c4fba6d5b8bc4d$var$prototypes[prototypeGroup][protoMethod];
    });
});
$41c4fba6d5b8bc4d$var$Swiper.use([
    (0, $cd460839c9cbbc59$export$2e2bcd8739ae039),
    (0, $ef57bcfb5c097272$export$2e2bcd8739ae039)
]);
var $41c4fba6d5b8bc4d$export$2e2bcd8739ae039 = $41c4fba6d5b8bc4d$var$Swiper;




function $4884439917ba81a8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $bsOiL = parcelRequire("bsOiL");

function $65a8e7a53f8571a2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $bsOiL.getDocument)();
    const window = (0, $bsOiL.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $bsOiL = parcelRequire("bsOiL");


function $000996de4791f079$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $bsOiL.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $66763f78a062fe47$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $66763f78a062fe47$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $66763f78a062fe47$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $66763f78a062fe47$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $bsOiL = parcelRequire("bsOiL");
function $b2b5753ec39ba701$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $bsOiL.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $7b5d41c9939efc77$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $b2b5753ec39ba701$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $15f28c549e2c12fa$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}



function $00cadfbf20e66242$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(" "));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $b2b5753ec39ba701$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $bsOiL = parcelRequire("bsOiL");



function $c5a497678a245696$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $bsOiL.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $b2b5753ec39ba701$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $ff992fdd4fc4c244$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((parallaxEl)=>{
            const $parallaxEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $bsOiL = parcelRequire("bsOiL");


function $f5e3ad991037b6c6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $bsOiL.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $66763f78a062fe47$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $66763f78a062fe47$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $bsOiL = parcelRequire("bsOiL");

function $69a62319825aa708$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr("data-background");
            const src = $imageEl.attr("data-src");
            const srcset = $imageEl.attr("data-srcset");
            const sizes = $imageEl.attr("data-sizes");
            const $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", `url("${background}")`);
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each((sourceEl)=>{
                        const $source = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).attr("data-swiper-slide-index");
            return (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).attr("data-swiper-slide-index") : (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $bsOiL.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on("destroy", ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $9be603625c7cf795$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $c240c595c0d3fbdd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    }
    function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    }
    function addElRole($el, role) {
        $el.attr("role", role);
    }
    function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    }
    function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    }
    function addElLabel($el, label) {
        $el.attr("aria-label", label);
    }
    function addElId($el, id) {
        $el.attr("id", id);
    }
    function addElLive($el, live) {
        $el.attr("aria-live", live);
    }
    function disableEl($el) {
        $el.attr("aria-disabled", true);
    }
    function enableEl($el) {
        $el.attr("aria-disabled", false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on("focus", handleFocus, true);
        swiper.$el.on("pointerdown", handlePointerDown, true);
        swiper.$el.on("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off("focus", handleFocus, true);
        swiper.$el.off("pointerdown", handlePointerDown, true);
        swiper.$el.off("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $bsOiL = parcelRequire("bsOiL");
function $c1978cb544450144$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $bsOiL.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $bsOiL.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $bsOiL.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $bsOiL.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $bsOiL = parcelRequire("bsOiL");

function $30ec01fbe608190c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $bsOiL.getDocument)();
    const window = (0, $bsOiL.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || "");
            emit("hashSet");
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(window).on("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(window).off("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $bsOiL = parcelRequire("bsOiL");

function $d6a8de0ae0918423$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $bsOiL.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit("autoplayPause");
            pause();
        }
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit("autoplayResume");
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    }
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $bsOiL.getDocument)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $bsOiL.getDocument)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $72f9f0012f40ddc2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $66763f78a062fe47$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $b9ef5a7823f4e4ba$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $66763f78a062fe47$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $66763f78a062fe47$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $66763f78a062fe47$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $df520085d71b3a51$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && `${spaceBetween}px` : "");
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $e4c2b7e31c11463d$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $3b130e40a5a9e723$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $504ed09ee395bc9d$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $56782469e370a8b6$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $139e0f202f1b0a63$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $d5271872f2f6357f$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $e4c2b7e31c11463d$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $3b130e40a5a9e723$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $504ed09ee395bc9d$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $56782469e370a8b6$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $139e0f202f1b0a63$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $8aa5bc9213868547$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $892958664a91861e$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}


function $06c97c96b512608b$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $8873c9004bc371bc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $3d213107b8942e00$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
            "transform-origin": `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $4a6c085448bb9aa0$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $77cffb5b66fd0604$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) shadowBefore = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
        if (shadowAfter.length === 0) shadowAfter = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $975c4d79e411ce84$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $acaeb69da8b99d8b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $89703391ee609a8f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */ const $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a = (swiperInstance)=>{
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) swiperInstance.autoplay.start();
            else swiperInstance.autoplay.stop();
        });
    }, observerOptions);
    observer.observe(swiperInstance.el);
};


let $7366146c58df7f36$var$employersSwiperWr = document.querySelectorAll(".employers-swiper-wr");
$7366146c58df7f36$var$employersSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let loop = false;
        let loopedSlides = false;
        if (slidesCount >= 6) {
            loop = true;
            loopedSlides = slidesCount * 2;
        }
        const updateWrapperClass = (slidesPerView)=>{
            if (slidesCount > slidesPerView) wrapper.classList.remove("justify-center");
            else wrapper.classList.add("justify-center");
        };
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 3,
            loop: loop,
            loopedSlides: loopedSlides,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                451: {
                    slidesPerView: 3,
                    on: {
                        beforeInit: function() {
                            updateWrapperClass(3);
                        }
                    }
                },
                640: {
                    slidesPerView: 4,
                    on: {
                        beforeInit: function() {
                            updateWrapperClass(4);
                        }
                    }
                },
                801: {
                    slidesPerView: 5,
                    on: {
                        beforeInit: function() {
                            updateWrapperClass(5);
                        }
                    }
                },
                1024: {
                    slidesPerView: 6,
                    on: {
                        beforeInit: function() {
                            updateWrapperClass(6);
                        }
                    }
                },
                1200: {
                    slidesPerView: 7,
                    on: {
                        beforeInit: function() {
                            updateWrapperClass(7);
                        }
                    }
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            }
        });
        swiper.on("breakpoint", (swiper)=>{
            updateWrapperClass(swiper.params.slidesPerView);
        });
        updateWrapperClass(swiper.params.slidesPerView);
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $0fa6437b980e3816$var$sectorsSwiperWr = document.querySelectorAll(".sectors-swiper-wr");
const $0fa6437b980e3816$var$sectorsTabsArr = document.querySelectorAll(".sectors-section__tab");
$0fa6437b980e3816$var$sectorsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                425: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                640: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 24,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 52,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});
if ($0fa6437b980e3816$var$sectorsTabsArr.length) $0fa6437b980e3816$var$sectorsTabsArr.forEach((tabEl, tadIdx)=>{
    tabEl.addEventListener("click", ()=>{
        if (!tabEl.classList.contains("active")) {
            for(let i = 0; i < $0fa6437b980e3816$var$sectorsTabsArr.length; i++){
                $0fa6437b980e3816$var$sectorsTabsArr[i].classList.remove("active");
                $0fa6437b980e3816$var$sectorsSwiperWr[i].classList.remove("active");
            }
            tabEl.classList.add("active");
            $0fa6437b980e3816$var$sectorsSwiperWr[tadIdx].classList.add("active");
        }
    });
});




let $962a6f5c443fc3b4$var$weOfferSwiperWr = document.querySelectorAll(".pricing-swiper-wr");
$962a6f5c443fc3b4$var$weOfferSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 10,
                    slidesPerView: 1
                },
                768: {
                    spaceBetween: 10,
                    slidesPerView: 2
                },
                1200: {
                    spaceBetween: 0,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});






const $9cb5cf8bde55ff38$export$f16e6af5a274aa5b = (breakpoint, swiperClass, swiperSettings, startOnView)=>{
    let swiper;
    breakpoint = window.matchMedia(breakpoint);
    const enableSwiper = function(className, settings) {
        swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(className, settings);
        if (startOnView) (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    };
    const checker = function() {
        if (breakpoint.matches) return enableSwiper(swiperClass, swiperSettings);
        else {
            if (swiper !== undefined) swiper.destroy(true, true);
            return;
        }
    };
    breakpoint.addEventListener("change", checker);
    checker();
};


let $57875f2163a1f47c$var$popularSwiperWr = document.querySelectorAll(".popular-swiper-wr");
$57875f2163a1f47c$var$popularSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        if (el.classList.contains("grid-type")) (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)("(max-width: 1023px)", swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            spaceBetween: 16,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                440: {
                    slidesPerView: 1.5
                },
                640: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2.5
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 20,
                    slidesPerView: 3
                }
            }
        });
        else {
            let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
                modules: [
                    (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                    (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
                ],
                observer: true,
                observeParents: true,
                spaceBetween: 16,
                slidesPerView: 1,
                threshold: 10,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                breakpoints: {
                    440: {
                        slidesPerView: 1.5
                    },
                    640: {
                        spaceBetween: 16,
                        slidesPerView: 2
                    },
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 2.5
                    },
                    1024: {
                        spaceBetween: 16,
                        slidesPerView: 3
                    },
                    1200: {
                        spaceBetween: 21,
                        slidesPerView: 3
                    }
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false
                }
            });
            let previousThirdItem = null;
            function updateShadows() {
                const slides = swiper.slides;
                const activeIndex = swiper.activeIndex;
                const thirdItemIndex = activeIndex + 3;
                if (window.innerWidth > 1201) {
                    if (previousThirdItem) previousThirdItem.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
                    if (slides[thirdItemIndex]) {
                        slides[thirdItemIndex].style.boxShadow = "none";
                        previousThirdItem = slides[thirdItemIndex];
                    } else previousThirdItem = null;
                }
            }
            swiper.on("slideChange", updateShadows);
            updateShadows();
            (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
        }
    }
});





let $8abf0ee5f01781b1$var$purposeSwiperWr = document.querySelectorAll(".purpose-swiper-wr");
$8abf0ee5f01781b1$var$purposeSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)("(max-width: 1300px)", swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 800,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                500: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 2.5
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            }
        });
    }
});




let $ce1a2d0d63cbd901$var$ourTeamSwiperWr = document.querySelectorAll(".our-team-swiper-wr");
$ce1a2d0d63cbd901$var$ourTeamSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            spaceBetween: 24,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                375: {
                    slidesPerView: 1
                },
                540: {
                    slidesPerView: 1.3
                },
                768: {
                    slidesPerView: 1.5
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 1.5
                },
                1440: {
                    slidesPerView: 2
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $215388dfaeb28d19$var$testimonialsSwiperWr = document.querySelectorAll(".testimonials-swiper-wr");
$215388dfaeb28d19$var$testimonialsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            spaceBetween: 24,
            slidesPerView: 1,
            threshold: 10,
            centeredSlides: true,
            loop: slidesCount > 3 ? true : false,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                1024: {
                    spaceBetween: 128,
                    slidesPerView: 1
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $7c7097d2f81f5446$var$similarSwiperWr = document.querySelectorAll(".similar-swiper-wr");
$7c7097d2f81f5446$var$similarSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            spaceBetween: 16,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                540: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $27bafcfeeafbb549$var$withUsSwiperWr = document.querySelectorAll(".with-us-swiper-wr");
$27bafcfeeafbb549$var$withUsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            spaceBetween: 16,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                540: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});





let $5ad561c6b5f146f7$var$pricingSwiperWr = document.querySelectorAll(".pricing-swiper-wr");
$5ad561c6b5f146f7$var$pricingSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)("(max-width: 1023px)", swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 800,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                540: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 1.5
                },
                1024: {
                    slidesPerView: 2
                },
                1440: {
                    slidesPerView: 3
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            }
        });
    }
});
function $5ad561c6b5f146f7$var$setEqualHeights() {
    const pricingItemTop = document.querySelectorAll(".pricing-section__item-top");
    let maxHeight = 0;
    pricingItemTop.forEach((item)=>{
        item.style.minHeight = ""; // Сбрасываем высоту перед пересчётом
        const itemHeight = item.offsetHeight;
        if (itemHeight > maxHeight) maxHeight = itemHeight;
    });
    pricingItemTop.forEach((item)=>{
        item.style.minHeight = `${maxHeight}px`;
    });
}
if (document.querySelector(".pricing-section__item-top")) {
    $5ad561c6b5f146f7$var$setEqualHeights();
    window.addEventListener("resize", $5ad561c6b5f146f7$var$setEqualHeights);
}




let $0f48811ebc421c0b$var$similarJobsSwiperWr = document.querySelectorAll(".similar-jobs-section__slider");
$0f48811ebc421c0b$var$similarJobsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            spaceBetween: 16,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                1024: {
                    spaceBetween: 20
                },
                1440: {
                    slidesPerView: 2
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});





let $ac9626c11281bd15$var$trustedSwiperWr = document.querySelectorAll(".trusted-swiper-wr");
$ac9626c11281bd15$var$trustedSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)("(max-width: 951px)", swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 12,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                500: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2.5
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            }
        });
    }
});




let $fb0a0a6693573c20$var$blogsSwiperWr = document.querySelectorAll(".blogs-swiper-wr");
$fb0a0a6693573c20$var$blogsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 16,
                    slidesPerView: 1.2
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 1.5
                },
                951: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                1200: {
                    spaceBetween: 38.6,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            on: {
                init: function() {
                    const activeIndex = this.activeIndex;
                    [
                        activeIndex + 3,
                        activeIndex + 4
                    ].forEach((index)=>{
                        if (this.slides[index]) this.slides[index].classList.add("opacity");
                    });
                },
                slideChange: function() {
                    this.slides.forEach((slide)=>slide.classList.remove("opacity"));
                    const activeIndex = this.activeIndex;
                    [
                        activeIndex + 3,
                        activeIndex + 4
                    ].forEach((index)=>{
                        if (this.slides[index]) this.slides[index].classList.add("opacity");
                    });
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $07ffa2f1e0742f25$var$weOfferSwiperWr = document.querySelectorAll(".we-offer-swiper-wr");
$07ffa2f1e0742f25$var$weOfferSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: "auto",
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2.5
                },
                951: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 19,
                    slidesPerView: 3
                },
                1600: {
                    spaceBetween: 90,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $3bbbe3ce1b4d06c9$var$clientSaySwiperWr = document.querySelectorAll(".clients-say-second-swiper-wr");
$3bbbe3ce1b4d06c9$var$clientSaySwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: "auto",
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 20,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2.5
                },
                951: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 40,
                    slidesPerView: 3
                },
                1600: {
                    spaceBetween: 90,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});


/*!
 * OverlayScrollbars
 * Version: 2.8.2
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ const $53673690361d2798$var$createCache = (t, n)=>{
    const { o: o, i: s, u: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const l = t;
        const i = n || (s ? !s(o, l) : o !== l);
        if (i || e) {
            c = l;
            r = o;
        }
        return [
            c,
            i,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $53673690361d2798$var$t = typeof window !== "undefined" && typeof document !== "undefined";
const $53673690361d2798$var$n = $53673690361d2798$var$t ? window : {};
const $53673690361d2798$var$o = Math.max;
const $53673690361d2798$var$s = Math.min;
const $53673690361d2798$var$e = Math.round;
const $53673690361d2798$var$c = Math.abs;
const $53673690361d2798$var$r = Math.sign;
const $53673690361d2798$var$l = $53673690361d2798$var$n.cancelAnimationFrame;
const $53673690361d2798$var$i = $53673690361d2798$var$n.requestAnimationFrame;
const $53673690361d2798$var$a = $53673690361d2798$var$n.setTimeout;
const $53673690361d2798$var$u = $53673690361d2798$var$n.clearTimeout;
const $53673690361d2798$var$getApi = (t)=>typeof $53673690361d2798$var$n[t] !== "undefined" ? $53673690361d2798$var$n[t] : void 0;
const $53673690361d2798$var$d = $53673690361d2798$var$getApi("MutationObserver");
const $53673690361d2798$var$_ = $53673690361d2798$var$getApi("IntersectionObserver");
const $53673690361d2798$var$f = $53673690361d2798$var$getApi("ResizeObserver");
const $53673690361d2798$var$p = $53673690361d2798$var$getApi("ScrollTimeline");
const $53673690361d2798$var$v = $53673690361d2798$var$t && Node.ELEMENT_NODE;
const { toString: $53673690361d2798$var$h, hasOwnProperty: $53673690361d2798$var$g } = Object.prototype;
const $53673690361d2798$var$b = /^\[object (.+)\]$/;
const $53673690361d2798$var$isUndefined = (t)=>t === void 0;
const $53673690361d2798$var$isNull = (t)=>t === null;
const $53673690361d2798$var$type = (t)=>$53673690361d2798$var$isUndefined(t) || $53673690361d2798$var$isNull(t) ? `${t}` : $53673690361d2798$var$h.call(t).replace($53673690361d2798$var$b, "$1").toLowerCase();
const $53673690361d2798$var$isNumber = (t)=>typeof t === "number";
const $53673690361d2798$var$isString = (t)=>typeof t === "string";
const $53673690361d2798$var$isBoolean = (t)=>typeof t === "boolean";
const $53673690361d2798$var$isFunction = (t)=>typeof t === "function";
const $53673690361d2798$var$isArray = (t)=>Array.isArray(t);
const $53673690361d2798$var$isObject = (t)=>typeof t === "object" && !$53673690361d2798$var$isArray(t) && !$53673690361d2798$var$isNull(t);
const $53673690361d2798$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $53673690361d2798$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $53673690361d2798$var$isArray(t) || !$53673690361d2798$var$isFunction(t) && o ? n > 0 && $53673690361d2798$var$isObject(t) ? n - 1 in t : true : false;
};
const $53673690361d2798$var$isPlainObject = (t)=>{
    if (!t || !$53673690361d2798$var$isObject(t) || $53673690361d2798$var$type(t) !== "object") return false;
    let n;
    const o = "constructor";
    const s = t[o];
    const e = s && s.prototype;
    const c = $53673690361d2798$var$g.call(t, o);
    const r = e && $53673690361d2798$var$g.call(e, "isPrototypeOf");
    if (s && !c && !r) return false;
    for(n in t);
    return $53673690361d2798$var$isUndefined(n) || $53673690361d2798$var$g.call(t, n);
};
const $53673690361d2798$var$isHTMLElement = (t)=>{
    const n = HTMLElement;
    return t ? n ? t instanceof n : t.nodeType === $53673690361d2798$var$v : false;
};
const $53673690361d2798$var$isElement = (t)=>{
    const n = Element;
    return t ? n ? t instanceof n : t.nodeType === $53673690361d2798$var$v : false;
};
const $53673690361d2798$var$animationCurrentTime = ()=>performance.now();
const $53673690361d2798$var$animateNumber = (t, n, s, e, c)=>{
    let r = 0;
    const a = $53673690361d2798$var$animationCurrentTime();
    const u = $53673690361d2798$var$o(0, s);
    const frame = (s)=>{
        const l = $53673690361d2798$var$animationCurrentTime();
        const d = l - a;
        const _ = d >= u;
        const f = s ? 1 : 1 - ($53673690361d2798$var$o(0, a + u - l) / u || 0);
        const p = (n - t) * ($53673690361d2798$var$isFunction(c) ? c(f, f * u, 0, 1, u) : f) + t;
        const v = _ || f === 1;
        e && e(p, f, v);
        r = v ? 0 : $53673690361d2798$var$i(()=>frame());
    };
    frame();
    return (t)=>{
        $53673690361d2798$var$l(r);
        t && frame(t);
    };
};
function $53673690361d2798$var$each(t, n) {
    if ($53673690361d2798$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (n(t[o], o, t) === false) break;
    }
    else if (t) $53673690361d2798$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
const $53673690361d2798$var$inArray = (t, n)=>t.indexOf(n) >= 0;
const $53673690361d2798$var$concat = (t, n)=>t.concat(n);
const $53673690361d2798$var$push = (t, n, o)=>{
    !o && !$53673690361d2798$var$isString(n) && $53673690361d2798$var$isArrayLike(n) ? Array.prototype.push.apply(t, n) : t.push(n);
    return t;
};
const $53673690361d2798$var$from = (t)=>Array.from(t || []);
const $53673690361d2798$var$createOrKeepArray = (t)=>$53673690361d2798$var$isArray(t) ? t : [
        t
    ];
const $53673690361d2798$var$isEmptyArray = (t)=>!!t && !t.length;
const $53673690361d2798$var$deduplicateArray = (t)=>$53673690361d2798$var$from(new Set(t));
const $53673690361d2798$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t && t.apply(void 0, n || []);
    $53673690361d2798$var$each(t, runFn);
    !o && (t.length = 0);
};
const $53673690361d2798$var$w = "paddingTop";
const $53673690361d2798$var$y = "paddingRight";
const $53673690361d2798$var$m = "paddingLeft";
const $53673690361d2798$var$S = "paddingBottom";
const $53673690361d2798$var$O = "marginLeft";
const $53673690361d2798$var$$ = "marginRight";
const $53673690361d2798$var$C = "marginBottom";
const $53673690361d2798$var$x = "overflowX";
const $53673690361d2798$var$H = "overflowY";
const $53673690361d2798$var$E = "width";
const $53673690361d2798$var$z = "height";
const $53673690361d2798$var$A = "visible";
const $53673690361d2798$var$I = "hidden";
const $53673690361d2798$var$T = "scroll";
const $53673690361d2798$var$capitalizeFirstLetter = (t)=>{
    const n = String(t || "");
    return n ? n[0].toUpperCase() + n.slice(1) : "";
};
const $53673690361d2798$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let e = true;
        $53673690361d2798$var$each(o, (o)=>{
            const c = s ? s(t[o]) : t[o];
            const r = s ? s(n[o]) : n[o];
            if (c !== r) e = false;
        });
        return e;
    }
    return false;
};
const $53673690361d2798$var$equalWH = (t, n)=>$53673690361d2798$var$equal(t, n, [
        "w",
        "h"
    ]);
const $53673690361d2798$var$equalXY = (t, n)=>$53673690361d2798$var$equal(t, n, [
        "x",
        "y"
    ]);
const $53673690361d2798$var$equalTRBL = (t, n)=>$53673690361d2798$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $53673690361d2798$var$noop = ()=>{};
const $53673690361d2798$var$bind = (t, ...n)=>t.bind(0, ...n);
const $53673690361d2798$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $53673690361d2798$var$a : $53673690361d2798$var$i;
    const s = t ? $53673690361d2798$var$u : $53673690361d2798$var$l;
    return [
        (e)=>{
            s(n);
            n = o(()=>e(), $53673690361d2798$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $53673690361d2798$var$debounce = (t, n)=>{
    let o;
    let s;
    let e;
    let c = $53673690361d2798$var$noop;
    const { _: r, p: d, v: _ } = n || {};
    const f = function invokeFunctionToDebounce(n) {
        c();
        $53673690361d2798$var$u(o);
        o = s = void 0;
        c = $53673690361d2798$var$noop;
        t.apply(this, n);
    };
    const mergeParms = (t)=>_ && s ? _(s, t) : t;
    const flush = ()=>{
        if (c !== $53673690361d2798$var$noop) f(mergeParms(e) || e);
    };
    const p = function debouncedFn() {
        const t = $53673690361d2798$var$from(arguments);
        const n = $53673690361d2798$var$isFunction(r) ? r() : r;
        const _ = $53673690361d2798$var$isNumber(n) && n >= 0;
        if (_) {
            const r = $53673690361d2798$var$isFunction(d) ? d() : d;
            const _ = $53673690361d2798$var$isNumber(r) && r >= 0;
            const p = n > 0 ? $53673690361d2798$var$a : $53673690361d2798$var$i;
            const v = n > 0 ? $53673690361d2798$var$u : $53673690361d2798$var$l;
            const h = mergeParms(t);
            const g = h || t;
            const b = f.bind(0, g);
            c();
            const w = p(b, n);
            c = ()=>v(w);
            if (_ && !o) o = $53673690361d2798$var$a(flush, r);
            s = e = g;
        } else f(t);
    };
    p.m = flush;
    return p;
};
const $53673690361d2798$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $53673690361d2798$var$keys = (t)=>t ? Object.keys(t) : [];
const $53673690361d2798$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const l = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if ((typeof t !== "object" || $53673690361d2798$var$isNull(t)) && !$53673690361d2798$var$isFunction(t)) t = {};
    $53673690361d2798$var$each(l, (n)=>{
        $53673690361d2798$var$each(n, (o, s)=>{
            const e = n[s];
            if (t === e) return true;
            const c = $53673690361d2798$var$isArray(e);
            if (e && $53673690361d2798$var$isPlainObject(e)) {
                const n = t[s];
                let o = n;
                if (c && !$53673690361d2798$var$isArray(n)) o = [];
                else if (!c && !$53673690361d2798$var$isPlainObject(n)) o = {};
                t[s] = $53673690361d2798$var$assignDeep(o, e);
            } else t[s] = c ? e.slice() : e;
        });
    });
    return t;
};
const $53673690361d2798$var$removeUndefinedProperties = (t, n)=>$53673690361d2798$var$each($53673690361d2798$var$assignDeep({}, t), (t, o, s)=>{
        if (t === void 0) delete s[o];
        else if (n && t && $53673690361d2798$var$isPlainObject(t)) s[o] = $53673690361d2798$var$removeUndefinedProperties(t, n);
    });
const $53673690361d2798$var$isEmptyObject = (t)=>{
    for(const n in t)return false;
    return true;
};
const $53673690361d2798$var$capNumber = (t, n, e)=>$53673690361d2798$var$o(t, $53673690361d2798$var$s(n, e));
const $53673690361d2798$var$getDomTokensArray = (t)=>$53673690361d2798$var$from(new Set(($53673690361d2798$var$isArray(t) ? t : (t || "").split(" ")).filter((t)=>t)));
const $53673690361d2798$var$getAttr = (t, n)=>t && t.getAttribute(n);
const $53673690361d2798$var$hasAttr = (t, n)=>t && t.hasAttribute(n);
const $53673690361d2798$var$setAttrs = (t, n, o)=>{
    $53673690361d2798$var$each($53673690361d2798$var$getDomTokensArray(n), (n)=>{
        t && t.setAttribute(n, String(o || ""));
    });
};
const $53673690361d2798$var$removeAttrs = (t, n)=>{
    $53673690361d2798$var$each($53673690361d2798$var$getDomTokensArray(n), (n)=>t && t.removeAttribute(n));
};
const $53673690361d2798$var$domTokenListAttr = (t, n)=>{
    const o = $53673690361d2798$var$getDomTokensArray($53673690361d2798$var$getAttr(t, n));
    const s = $53673690361d2798$var$bind($53673690361d2798$var$setAttrs, t, n);
    const domTokenListOperation = (t, n)=>{
        const s = new Set(o);
        $53673690361d2798$var$each($53673690361d2798$var$getDomTokensArray(t), (t)=>{
            s[n](t);
        });
        return $53673690361d2798$var$from(s).join(" ");
    };
    return {
        S: (t)=>s(domTokenListOperation(t, "delete")),
        O: (t)=>s(domTokenListOperation(t, "add")),
        $: (t)=>{
            const n = $53673690361d2798$var$getDomTokensArray(t);
            return n.reduce((t, n)=>t && o.includes(n), n.length > 0);
        }
    };
};
const $53673690361d2798$var$removeAttrClass = (t, n, o)=>{
    $53673690361d2798$var$domTokenListAttr(t, n).S(o);
    return $53673690361d2798$var$bind($53673690361d2798$var$addAttrClass, t, n, o);
};
const $53673690361d2798$var$addAttrClass = (t, n, o)=>{
    $53673690361d2798$var$domTokenListAttr(t, n).O(o);
    return $53673690361d2798$var$bind($53673690361d2798$var$removeAttrClass, t, n, o);
};
const $53673690361d2798$var$addRemoveAttrClass = (t, n, o, s)=>(s ? $53673690361d2798$var$addAttrClass : $53673690361d2798$var$removeAttrClass)(t, n, o);
const $53673690361d2798$var$hasAttrClass = (t, n, o)=>$53673690361d2798$var$domTokenListAttr(t, n).$(o);
const $53673690361d2798$var$createDomTokenListClass = (t)=>$53673690361d2798$var$domTokenListAttr(t, "class");
const $53673690361d2798$var$removeClass = (t, n)=>{
    $53673690361d2798$var$createDomTokenListClass(t).S(n);
};
const $53673690361d2798$var$addClass = (t, n)=>{
    $53673690361d2798$var$createDomTokenListClass(t).O(n);
    return $53673690361d2798$var$bind($53673690361d2798$var$removeClass, t, n);
};
const $53673690361d2798$var$find = (t, n)=>{
    const o = [];
    const s = n ? $53673690361d2798$var$isElement(n) && n : document;
    return s ? $53673690361d2798$var$push(o, s.querySelectorAll(t)) : o;
};
const $53673690361d2798$var$findFirst = (t, n)=>{
    const o = n ? $53673690361d2798$var$isElement(n) && n : document;
    return o ? o.querySelector(t) : null;
};
const $53673690361d2798$var$is = (t, n)=>{
    if ($53673690361d2798$var$isElement(t)) return t.matches(n);
    return false;
};
const $53673690361d2798$var$isBodyElement = (t)=>$53673690361d2798$var$is(t, "body");
const $53673690361d2798$var$contents = (t)=>t ? $53673690361d2798$var$from(t.childNodes) : [];
const $53673690361d2798$var$parent = (t)=>t && t.parentElement;
const $53673690361d2798$var$closest = (t, n)=>$53673690361d2798$var$isElement(t) && t.closest(n);
const $53673690361d2798$var$getFocusedElement = (t)=>(t || document).activeElement;
const $53673690361d2798$var$liesBetween = (t, n, o)=>{
    const s = $53673690361d2798$var$closest(t, n);
    const e = t && $53673690361d2798$var$findFirst(o, s);
    const c = $53673690361d2798$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $53673690361d2798$var$closest($53673690361d2798$var$closest(t, o), n) !== s : false;
};
const $53673690361d2798$var$removeElements = (t)=>{
    if ($53673690361d2798$var$isArrayLike(t)) $53673690361d2798$var$each($53673690361d2798$var$from(t), (t)=>$53673690361d2798$var$removeElements(t));
    else if (t) {
        const n = $53673690361d2798$var$parent(t);
        n && n.removeChild(t);
    }
};
const $53673690361d2798$var$before = (t, n, o)=>{
    if (o && t) {
        let s = n;
        let e;
        if ($53673690361d2798$var$isArrayLike(o)) {
            e = document.createDocumentFragment();
            $53673690361d2798$var$each(o, (t)=>{
                if (t === s) s = t.previousSibling;
                e.appendChild(t);
            });
        } else e = o;
        if (n) {
            if (!s) s = t.firstChild;
            else if (s !== n) s = s.nextSibling;
        }
        t.insertBefore(e, s || null);
        return ()=>$53673690361d2798$var$removeElements(o);
    }
    return $53673690361d2798$var$noop;
};
const $53673690361d2798$var$appendChildren = (t, n)=>$53673690361d2798$var$before(t, null, n);
const $53673690361d2798$var$insertAfter = (t, n)=>$53673690361d2798$var$before($53673690361d2798$var$parent(t), t && t.nextSibling, n);
const $53673690361d2798$var$createDiv = (t)=>{
    const n = document.createElement("div");
    $53673690361d2798$var$setAttrs(n, "class", t);
    return n;
};
const $53673690361d2798$var$createDOM = (t)=>{
    const n = $53673690361d2798$var$createDiv();
    n.innerHTML = t.trim();
    return $53673690361d2798$var$each($53673690361d2798$var$contents(n), (t)=>$53673690361d2798$var$removeElements(t));
};
const $53673690361d2798$var$D = /^--/;
const $53673690361d2798$var$getCSSVal = (t, n)=>t.getPropertyValue(n) || t[n] || "";
const $53673690361d2798$var$validFiniteNumber = (t)=>{
    const n = t || 0;
    return isFinite(n) ? n : 0;
};
const $53673690361d2798$var$parseToZeroOrNumber = (t)=>$53673690361d2798$var$validFiniteNumber(parseFloat(t || ""));
const $53673690361d2798$var$ratioToCssPercent = (t)=>`${($53673690361d2798$var$validFiniteNumber(t) * 100).toFixed(3)}%`;
const $53673690361d2798$var$numberToCssPx = (t)=>`${$53673690361d2798$var$validFiniteNumber(t)}px`;
function $53673690361d2798$var$setStyles(t, n) {
    t && n && $53673690361d2798$var$each(n, (n, o)=>{
        try {
            const s = t.style;
            const e = $53673690361d2798$var$isNumber(n) ? $53673690361d2798$var$numberToCssPx(n) : (n || "") + "";
            if ($53673690361d2798$var$D.test(o)) s.setProperty(o, e);
            else s[o] = e;
        } catch (s) {}
    });
}
function $53673690361d2798$var$getStyles(t, o, s) {
    const e = $53673690361d2798$var$isString(o);
    let c = e ? "" : {};
    if (t) {
        const r = $53673690361d2798$var$n.getComputedStyle(t, s) || t.style;
        c = e ? $53673690361d2798$var$getCSSVal(r, o) : $53673690361d2798$var$from(o).reduce((t, n)=>{
            t[n] = $53673690361d2798$var$getCSSVal(r, n);
            return t;
        }, c);
    }
    return c;
}
const $53673690361d2798$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const l = `${s}bottom${e}`;
    const i = `${s}left${e}`;
    const a = $53673690361d2798$var$getStyles(t, [
        c,
        r,
        l,
        i
    ]);
    return {
        t: $53673690361d2798$var$parseToZeroOrNumber(a[c]),
        r: $53673690361d2798$var$parseToZeroOrNumber(a[r]),
        b: $53673690361d2798$var$parseToZeroOrNumber(a[l]),
        l: $53673690361d2798$var$parseToZeroOrNumber(a[i])
    };
};
const $53673690361d2798$var$getTrasformTranslateValue = (t, n)=>`translate${$53673690361d2798$var$isObject(t) ? `(${t.x},${t.y})` : `${n ? "X" : "Y"}(${t})`}`;
const $53673690361d2798$var$elementHasDimensions = (t)=>!!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
const $53673690361d2798$var$k = {
    w: 0,
    h: 0
};
const $53673690361d2798$var$getElmWidthHeightProperty = (t, n)=>n ? {
        w: n[`${t}Width`],
        h: n[`${t}Height`]
    } : $53673690361d2798$var$k;
const $53673690361d2798$var$getWindowSize = (t)=>$53673690361d2798$var$getElmWidthHeightProperty("inner", t || $53673690361d2798$var$n);
const $53673690361d2798$var$R = $53673690361d2798$var$bind($53673690361d2798$var$getElmWidthHeightProperty, "offset");
const $53673690361d2798$var$M = $53673690361d2798$var$bind($53673690361d2798$var$getElmWidthHeightProperty, "client");
const $53673690361d2798$var$V = $53673690361d2798$var$bind($53673690361d2798$var$getElmWidthHeightProperty, "scroll");
const $53673690361d2798$var$getFractionalSize = (t)=>{
    const n = parseFloat($53673690361d2798$var$getStyles(t, $53673690361d2798$var$E)) || 0;
    const o = parseFloat($53673690361d2798$var$getStyles(t, $53673690361d2798$var$z)) || 0;
    return {
        w: n - $53673690361d2798$var$e(n),
        h: o - $53673690361d2798$var$e(o)
    };
};
const $53673690361d2798$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
const $53673690361d2798$var$hasDimensions = (t)=>!!t && $53673690361d2798$var$elementHasDimensions(t);
const $53673690361d2798$var$domRectHasDimensions = (t)=>!!(t && (t[$53673690361d2798$var$z] || t[$53673690361d2798$var$E]));
const $53673690361d2798$var$domRectAppeared = (t, n)=>{
    const o = $53673690361d2798$var$domRectHasDimensions(t);
    const s = $53673690361d2798$var$domRectHasDimensions(n);
    return !s && o;
};
const $53673690361d2798$var$removeEventListener = (t, n, o, s)=>{
    $53673690361d2798$var$each($53673690361d2798$var$getDomTokensArray(n), (n)=>{
        t && t.removeEventListener(n, o, s);
    });
};
const $53673690361d2798$var$addEventListener = (t, n, o, s)=>{
    var e;
    const c = (e = s && s.C) != null ? e : true;
    const r = s && s.H || false;
    const l = s && s.A || false;
    const i = {
        passive: c,
        capture: r
    };
    return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, $53673690361d2798$var$getDomTokensArray(n).map((n)=>{
        const s = l ? (e)=>{
            $53673690361d2798$var$removeEventListener(t, n, s, r);
            o && o(e);
        } : o;
        t && t.addEventListener(n, s, i);
        return $53673690361d2798$var$bind($53673690361d2798$var$removeEventListener, t, n, s, r);
    }));
};
const $53673690361d2798$var$stopPropagation = (t)=>t.stopPropagation();
const $53673690361d2798$var$preventDefault = (t)=>t.preventDefault();
const $53673690361d2798$var$stopAndPrevent = (t)=>$53673690361d2798$var$stopPropagation(t) || $53673690361d2798$var$preventDefault(t);
const $53673690361d2798$var$scrollElementTo = (t, n)=>{
    const { x: o, y: s } = $53673690361d2798$var$isNumber(n) ? {
        x: n,
        y: n
    } : n || {};
    $53673690361d2798$var$isNumber(o) && (t.scrollLeft = o);
    $53673690361d2798$var$isNumber(s) && (t.scrollTop = s);
};
const $53673690361d2798$var$getElementScroll = (t)=>({
        x: t.scrollLeft,
        y: t.scrollTop
    });
const $53673690361d2798$var$getZeroScrollCoordinates = ()=>({
        I: {
            x: 0,
            y: 0
        },
        T: {
            x: 0,
            y: 0
        }
    });
const $53673690361d2798$var$sanitizeScrollCoordinates = (t, n)=>{
    const { I: o, T: s } = t;
    const { w: e, h: l } = n;
    const sanitizeAxis = (t, n, o)=>{
        let s = $53673690361d2798$var$r(t) * o;
        let e = $53673690361d2798$var$r(n) * o;
        if (s === e) {
            const o = $53673690361d2798$var$c(t);
            const r = $53673690361d2798$var$c(n);
            e = o > r ? 0 : e;
            s = o < r ? 0 : s;
        }
        s = s === e ? 0 : s;
        return [
            s + 0,
            e + 0
        ];
    };
    const [i, a] = sanitizeAxis(o.x, s.x, e);
    const [u, d] = sanitizeAxis(o.y, s.y, l);
    return {
        I: {
            x: i,
            y: u
        },
        T: {
            x: a,
            y: d
        }
    };
};
const $53673690361d2798$var$isDefaultDirectionScrollCoordinates = ({ I: t, T: n })=>{
    const getAxis = (t, n)=>t === 0 && t <= n;
    return {
        x: getAxis(t.x, n.x),
        y: getAxis(t.y, n.y)
    };
};
const $53673690361d2798$var$getScrollCoordinatesPercent = ({ I: t, T: n }, o)=>{
    const getAxis = (t, n, o)=>$53673690361d2798$var$capNumber(0, 1, (t - o) / (t - n) || 0);
    return {
        x: getAxis(t.x, n.x, o.x),
        y: getAxis(t.y, n.y, o.y)
    };
};
const $53673690361d2798$var$focusElement = (t)=>{
    if (t && t.focus) t.focus({
        preventScroll: true
    });
};
const $53673690361d2798$var$manageListener = (t, n)=>{
    $53673690361d2798$var$each($53673690361d2798$var$createOrKeepArray(n), t);
};
const $53673690361d2798$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $53673690361d2798$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($53673690361d2798$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $53673690361d2798$var$manageListener((t)=>{
                $53673690361d2798$var$isFunction(t) && s.add(t);
            }, o);
            return $53673690361d2798$var$bind(removeEvent, t, o);
        }
        if ($53673690361d2798$var$isBoolean(o) && o) removeEvent();
        const s = $53673690361d2798$var$keys(t);
        const e = [];
        $53673690361d2798$var$each(s, (n)=>{
            const o = t[n];
            o && $53673690361d2798$var$push(e, addEvent(n, o));
        });
        return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, e);
    };
    const triggerEvent = (t, o)=>{
        $53673690361d2798$var$each($53673690361d2798$var$from(n.get(t)), (t)=>{
            if (o && !$53673690361d2798$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $53673690361d2798$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($53673690361d2798$var$isFunction(n)) throw 0;
        return n;
    });
const $53673690361d2798$var$getPropByPath = (t, n)=>t ? `${n}`.split(".").reduce((t, n)=>t && $53673690361d2798$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $53673690361d2798$var$L = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        autoHideSuspend: false,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $53673690361d2798$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $53673690361d2798$var$concat($53673690361d2798$var$keys(n), $53673690361d2798$var$keys(t));
    $53673690361d2798$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($53673690361d2798$var$isObject(e) && $53673690361d2798$var$isObject(c)) {
            $53673690361d2798$var$assignDeep(o[s] = {}, $53673690361d2798$var$getOptionsDiff(e, c));
            if ($53673690361d2798$var$isEmptyObject(o[s])) delete o[s];
        } else if ($53673690361d2798$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($53673690361d2798$var$isArray(e) || $53673690361d2798$var$isArray(c)) try {
                if ($53673690361d2798$var$opsStringify(e) === $53673690361d2798$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $53673690361d2798$var$createOptionCheck = (t, n, o)=>(s)=>[
            $53673690361d2798$var$getPropByPath(t, s),
            o || $53673690361d2798$var$getPropByPath(n, s) !== void 0
        ];
const $53673690361d2798$var$P = `data-overlayscrollbars`;
const $53673690361d2798$var$U = "os-environment";
const $53673690361d2798$var$N = `${$53673690361d2798$var$U}-scrollbar-hidden`;
const $53673690361d2798$var$j = `${$53673690361d2798$var$P}-initialize`;
const $53673690361d2798$var$q = "noClipping";
const $53673690361d2798$var$F = `${$53673690361d2798$var$P}-body`;
const $53673690361d2798$var$B = $53673690361d2798$var$P;
const $53673690361d2798$var$X = "host";
const $53673690361d2798$var$Y = `${$53673690361d2798$var$P}-viewport`;
const $53673690361d2798$var$W = $53673690361d2798$var$x;
const $53673690361d2798$var$J = $53673690361d2798$var$H;
const $53673690361d2798$var$K = "arrange";
const $53673690361d2798$var$G = "measuring";
const $53673690361d2798$var$Q = "scrollbarHidden";
const $53673690361d2798$var$Z = "scrollbarPressed";
const $53673690361d2798$var$tt = "noContent";
const $53673690361d2798$var$nt = `${$53673690361d2798$var$P}-padding`;
const $53673690361d2798$var$ot = `${$53673690361d2798$var$P}-content`;
const $53673690361d2798$var$st = "os-size-observer";
const $53673690361d2798$var$et = `${$53673690361d2798$var$st}-appear`;
const $53673690361d2798$var$ct = `${$53673690361d2798$var$st}-listener`;
const $53673690361d2798$var$rt = `${$53673690361d2798$var$ct}-scroll`;
const $53673690361d2798$var$lt = `${$53673690361d2798$var$ct}-item`;
const $53673690361d2798$var$it = `${$53673690361d2798$var$lt}-final`;
const $53673690361d2798$var$at = "os-trinsic-observer";
const $53673690361d2798$var$ut = "os-theme-none";
const $53673690361d2798$var$dt = "os-scrollbar";
const $53673690361d2798$var$_t = `${$53673690361d2798$var$dt}-rtl`;
const $53673690361d2798$var$ft = `${$53673690361d2798$var$dt}-horizontal`;
const $53673690361d2798$var$pt = `${$53673690361d2798$var$dt}-vertical`;
const $53673690361d2798$var$vt = `${$53673690361d2798$var$dt}-track`;
const $53673690361d2798$var$ht = `${$53673690361d2798$var$dt}-handle`;
const $53673690361d2798$var$gt = `${$53673690361d2798$var$dt}-visible`;
const $53673690361d2798$var$bt = `${$53673690361d2798$var$dt}-cornerless`;
const $53673690361d2798$var$wt = `${$53673690361d2798$var$dt}-interaction`;
const $53673690361d2798$var$yt = `${$53673690361d2798$var$dt}-unusable`;
const $53673690361d2798$var$mt = `${$53673690361d2798$var$dt}-auto-hide`;
const $53673690361d2798$var$St = `${$53673690361d2798$var$mt}-hidden`;
const $53673690361d2798$var$Ot = `${$53673690361d2798$var$dt}-wheel`;
const $53673690361d2798$var$$t = `${$53673690361d2798$var$vt}-interactive`;
const $53673690361d2798$var$Ct = `${$53673690361d2798$var$ht}-interactive`;
let $53673690361d2798$var$xt;
const $53673690361d2798$var$createEnvironment = ()=>{
    const getNativeScrollbarSize = (t, n, o)=>{
        $53673690361d2798$var$appendChildren(document.body, t);
        $53673690361d2798$var$appendChildren(document.body, t);
        const s = $53673690361d2798$var$M(t);
        const e = $53673690361d2798$var$R(t);
        const c = $53673690361d2798$var$getFractionalSize(n);
        o && $53673690361d2798$var$removeElements(t);
        return {
            x: e.h - s.h + c.h,
            y: e.w - s.w + c.w
        };
    };
    const getNativeScrollbarsHiding = (t)=>{
        let n = false;
        const o = $53673690361d2798$var$addClass(t, $53673690361d2798$var$N);
        try {
            n = $53673690361d2798$var$getStyles(t, "scrollbar-width") === "none" || $53673690361d2798$var$getStyles(t, "display", "::-webkit-scrollbar") === "none";
        } catch (s) {}
        o();
        return n;
    };
    const t = `.${$53673690361d2798$var$U}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${$53673690361d2798$var$U} div{width:200%;height:200%;margin:10px 0}.${$53673690361d2798$var$N}{scrollbar-width:none!important}.${$53673690361d2798$var$N}::-webkit-scrollbar,.${$53673690361d2798$var$N}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`;
    const o = $53673690361d2798$var$createDOM(`<div class="${$53673690361d2798$var$U}"><div></div><style>${t}</style></div>`);
    const s = o[0];
    const e = s.firstChild;
    const [c, , r] = $53673690361d2798$var$createEventListenerHub();
    const [l, i] = $53673690361d2798$var$createCache({
        o: getNativeScrollbarSize(s, e),
        i: $53673690361d2798$var$equalXY
    }, $53673690361d2798$var$bind(getNativeScrollbarSize, s, e, true));
    const [a] = i();
    const u = getNativeScrollbarsHiding(s);
    const d = {
        x: a.x === 0,
        y: a.y === 0
    };
    const _ = {
        elements: {
            host: null,
            padding: !u,
            viewport: (t)=>u && $53673690361d2798$var$isBodyElement(t) && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const f = $53673690361d2798$var$assignDeep({}, $53673690361d2798$var$L);
    const v = $53673690361d2798$var$bind($53673690361d2798$var$assignDeep, {}, f);
    const h = $53673690361d2798$var$bind($53673690361d2798$var$assignDeep, {}, _);
    const g = {
        D: a,
        k: d,
        R: u,
        M: !!$53673690361d2798$var$p,
        V: $53673690361d2798$var$bind(c, "r"),
        L: h,
        P: (t)=>$53673690361d2798$var$assignDeep(_, t) && h(),
        U: v,
        N: (t)=>$53673690361d2798$var$assignDeep(f, t) && v(),
        j: $53673690361d2798$var$assignDeep({}, _),
        q: $53673690361d2798$var$assignDeep({}, f)
    };
    $53673690361d2798$var$removeAttrs(s, "style");
    $53673690361d2798$var$removeElements(s);
    $53673690361d2798$var$addEventListener($53673690361d2798$var$n, "resize", ()=>{
        r("r", []);
    });
    if ($53673690361d2798$var$isFunction($53673690361d2798$var$n.matchMedia) && !u && (!d.x || !d.y)) {
        const addZoomListener = (t)=>{
            const o = $53673690361d2798$var$n.matchMedia(`(resolution: ${$53673690361d2798$var$n.devicePixelRatio}dppx)`);
            $53673690361d2798$var$addEventListener(o, "change", ()=>{
                t();
                addZoomListener(t);
            }, {
                A: true
            });
        };
        addZoomListener(()=>{
            const [t, n] = l();
            $53673690361d2798$var$assignDeep(g.D, t);
            r("r", [
                n
            ]);
        });
    }
    return g;
};
const $53673690361d2798$var$getEnvironment = ()=>{
    if (!$53673690361d2798$var$xt) $53673690361d2798$var$xt = $53673690361d2798$var$createEnvironment();
    return $53673690361d2798$var$xt;
};
const $53673690361d2798$var$resolveInitialization = (t, n)=>$53673690361d2798$var$isFunction(n) ? n.apply(0, t) : n;
const $53673690361d2798$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $53673690361d2798$var$isUndefined(s) ? o : s;
    const c = $53673690361d2798$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $53673690361d2798$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $53673690361d2798$var$isUndefined(s) ? o : s;
    const c = $53673690361d2798$var$resolveInitialization(t, e);
    return !!c && ($53673690361d2798$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $53673690361d2798$var$cancelInitialization = (t, n)=>{
    const { nativeScrollbarsOverlaid: o, body: s } = n || {};
    const { k: e, R: c, L: r } = $53673690361d2798$var$getEnvironment();
    const { nativeScrollbarsOverlaid: l, body: i } = r().cancel;
    const a = o != null ? o : l;
    const u = $53673690361d2798$var$isUndefined(s) ? i : s;
    const d = (e.x || e.y) && a;
    const _ = t && ($53673690361d2798$var$isNull(u) ? !c : u);
    return !!d || !!_;
};
const $53673690361d2798$var$Ht = new WeakMap;
const $53673690361d2798$var$addInstance = (t, n)=>{
    $53673690361d2798$var$Ht.set(t, n);
};
const $53673690361d2798$var$removeInstance = (t)=>{
    $53673690361d2798$var$Ht.delete(t);
};
const $53673690361d2798$var$getInstance = (t)=>$53673690361d2798$var$Ht.get(t);
const $53673690361d2798$var$createEventContentChange = (t, n, o)=>{
    let s = false;
    const e = o ? new WeakMap : false;
    const destroy = ()=>{
        s = true;
    };
    const updateElements = (c)=>{
        if (e && o) {
            const r = o.map((n)=>{
                const [o, s] = n || [];
                const e = s && o ? (c || $53673690361d2798$var$find)(o, t) : [];
                return [
                    e,
                    s
                ];
            });
            $53673690361d2798$var$each(r, (o)=>$53673690361d2798$var$each(o[0], (c)=>{
                    const r = o[1];
                    const l = e.get(c) || [];
                    const i = t.contains(c);
                    if (i && r) {
                        const t = $53673690361d2798$var$addEventListener(c, r, (o)=>{
                            if (s) {
                                t();
                                e.delete(c);
                            } else n(o);
                        });
                        e.set(c, $53673690361d2798$var$push(l, t));
                    } else {
                        $53673690361d2798$var$runEachAndClear(l);
                        e.delete(c);
                    }
                }));
        }
    };
    updateElements();
    return [
        destroy,
        updateElements
    ];
};
const $53673690361d2798$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { F: c, B: r, X: l, Y: i, W: a, J: u } = s || {};
    const _ = $53673690361d2798$var$debounce(()=>e && o(true), {
        _: 33,
        p: 99
    });
    const [f, p] = $53673690361d2798$var$createEventContentChange(t, _, l);
    const v = c || [];
    const h = r || [];
    const g = $53673690361d2798$var$concat(v, h);
    const observerCallback = (e, c)=>{
        if (!$53673690361d2798$var$isEmptyArray(c)) {
            const r = a || $53673690361d2798$var$noop;
            const l = u || $53673690361d2798$var$noop;
            const d = [];
            const _ = [];
            let f = false;
            let v = false;
            $53673690361d2798$var$each(c, (o)=>{
                const { attributeName: e, target: c, type: a, oldValue: u, addedNodes: p, removedNodes: g } = o;
                const b = a === "attributes";
                const w = a === "childList";
                const y = t === c;
                const m = b && e;
                const S = m && $53673690361d2798$var$getAttr(c, e || "");
                const O = $53673690361d2798$var$isString(S) ? S : null;
                const $ = m && u !== O;
                const C = $53673690361d2798$var$inArray(h, e) && $;
                if (n && (w || !y)) {
                    const n = b && $;
                    const a = n && i && $53673690361d2798$var$is(c, i);
                    const _ = a ? !r(c, e, u, O) : !b || n;
                    const f = _ && !l(o, !!a, t, s);
                    $53673690361d2798$var$each(p, (t)=>$53673690361d2798$var$push(d, t));
                    $53673690361d2798$var$each(g, (t)=>$53673690361d2798$var$push(d, t));
                    v = v || f;
                }
                if (!n && y && $ && !r(c, e, u, O)) {
                    $53673690361d2798$var$push(_, e);
                    f = f || C;
                }
            });
            p((t)=>$53673690361d2798$var$deduplicateArray(d).reduce((n, o)=>{
                    $53673690361d2798$var$push(n, $53673690361d2798$var$find(t, o));
                    return $53673690361d2798$var$is(o, t) ? $53673690361d2798$var$push(n, o) : n;
                }, []));
            if (n) {
                !e && v && o(false);
                return [
                    false
                ];
            }
            if (!$53673690361d2798$var$isEmptyArray(_) || f) {
                const t = [
                    $53673690361d2798$var$deduplicateArray(_),
                    f
                ];
                !e && o.apply(0, t);
                return t;
            }
        }
    };
    const b = new $53673690361d2798$var$d($53673690361d2798$var$bind(observerCallback, false));
    return [
        ()=>{
            b.observe(t, {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: g,
                subtree: n,
                childList: n,
                characterData: n
            });
            e = true;
            return ()=>{
                if (e) {
                    f();
                    b.disconnect();
                    e = false;
                }
            };
        },
        ()=>{
            if (e) {
                _.m();
                return observerCallback(true, b.takeRecords());
            }
        }
    ];
};
const $53673690361d2798$var$Et = {};
const $53673690361d2798$var$zt = {};
const $53673690361d2798$var$addPlugins = (t)=>{
    $53673690361d2798$var$each(t, (t)=>$53673690361d2798$var$each(t, (n, o)=>{
            $53673690361d2798$var$Et[o] = t[o];
        }));
};
const $53673690361d2798$var$registerPluginModuleInstances = (t, n, o)=>$53673690361d2798$var$keys(t).map((s)=>{
        const { static: e, instance: c } = t[s];
        const [r, l, i] = o || [];
        const a = o ? c : e;
        if (a) {
            const t = o ? a(r, l, n) : a(n);
            return (i || $53673690361d2798$var$zt)[s] = t;
        }
    });
const $53673690361d2798$var$getStaticPluginModuleInstance = (t)=>$53673690361d2798$var$zt[t];
const $53673690361d2798$var$At = "__osOptionsValidationPlugin";
const $53673690361d2798$var$It = "__osSizeObserverPlugin";
const $53673690361d2798$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$53673690361d2798$var$It]: {
            static: ()=>(t, n, o)=>{
                    const s = 3333333;
                    const e = "scroll";
                    const c = $53673690361d2798$var$createDOM(`<div class="${$53673690361d2798$var$lt}" dir="ltr"><div class="${$53673690361d2798$var$lt}"><div class="${$53673690361d2798$var$it}"></div></div><div class="${$53673690361d2798$var$lt}"><div class="${$53673690361d2798$var$it}" style="width: 200%; height: 200%"></div></div></div>`);
                    const r = c[0];
                    const a = r.lastChild;
                    const u = r.firstChild;
                    const d = u == null ? void 0 : u.firstChild;
                    let _ = $53673690361d2798$var$R(r);
                    let f = _;
                    let p = false;
                    let v;
                    const reset = ()=>{
                        $53673690361d2798$var$scrollElementTo(u, s);
                        $53673690361d2798$var$scrollElementTo(a, s);
                    };
                    const onResized = (t)=>{
                        v = 0;
                        if (p) {
                            _ = f;
                            n(t === true);
                        }
                    };
                    const onScroll = (t)=>{
                        f = $53673690361d2798$var$R(r);
                        p = !t || !$53673690361d2798$var$equalWH(f, _);
                        if (t) {
                            $53673690361d2798$var$stopPropagation(t);
                            if (p && !v) {
                                $53673690361d2798$var$l(v);
                                v = $53673690361d2798$var$i(onResized);
                            }
                        } else onResized(t === false);
                        reset();
                    };
                    const h = [
                        $53673690361d2798$var$appendChildren(t, c),
                        $53673690361d2798$var$addEventListener(u, e, onScroll),
                        $53673690361d2798$var$addEventListener(a, e, onScroll)
                    ];
                    $53673690361d2798$var$addClass(t, $53673690361d2798$var$rt);
                    $53673690361d2798$var$setStyles(d, {
                        [$53673690361d2798$var$E]: s,
                        [$53673690361d2798$var$z]: s
                    });
                    $53673690361d2798$var$i(reset);
                    return [
                        o ? $53673690361d2798$var$bind(onScroll, false) : reset,
                        h
                    ];
                }
        }
    }))();
const $53673690361d2798$var$getShowNativeOverlaidScrollbars = (t, n)=>{
    const { k: o } = n;
    const [s, e] = t("showNativeOverlaidScrollbars");
    return [
        s && o.x && o.y,
        e
    ];
};
const $53673690361d2798$var$overflowIsVisible = (t)=>t.indexOf($53673690361d2798$var$A) === 0;
const $53673690361d2798$var$createViewportOverflowState = (t, n)=>{
    const getAxisOverflowStyle = (t, n, o, s)=>{
        const e = t === $53673690361d2798$var$A ? $53673690361d2798$var$I : t.replace(`${$53673690361d2798$var$A}-`, "");
        const c = $53673690361d2798$var$overflowIsVisible(t);
        const r = $53673690361d2798$var$overflowIsVisible(o);
        if (!n && !s) return $53673690361d2798$var$I;
        if (c && r) return $53673690361d2798$var$A;
        if (c) {
            const t = n ? $53673690361d2798$var$A : $53673690361d2798$var$I;
            return n && s ? e : t;
        }
        const l = r && s ? $53673690361d2798$var$A : $53673690361d2798$var$I;
        return n ? e : l;
    };
    const o = {
        x: getAxisOverflowStyle(n.x, t.x, n.y, t.y),
        y: getAxisOverflowStyle(n.y, t.y, n.x, t.x)
    };
    return {
        K: o,
        G: {
            x: o.x === $53673690361d2798$var$T,
            y: o.y === $53673690361d2798$var$T
        }
    };
};
const $53673690361d2798$var$Dt = "__osScrollbarsHidingPlugin";
const $53673690361d2798$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$53673690361d2798$var$Dt]: {
            static: ()=>({
                    Z: (t, n, o, s, e)=>{
                        const { tt: c, nt: r } = t;
                        const { R: l, k: i, D: a } = s;
                        const u = !c && !l && (i.x || i.y);
                        const [d] = $53673690361d2798$var$getShowNativeOverlaidScrollbars(e, s);
                        const readViewportOverflowState = ()=>{
                            const getStatePerAxis = (t)=>{
                                const n = $53673690361d2798$var$getStyles(r, t);
                                const o = n === $53673690361d2798$var$T;
                                return [
                                    n,
                                    o
                                ];
                            };
                            const [t, n] = getStatePerAxis($53673690361d2798$var$x);
                            const [o, s] = getStatePerAxis($53673690361d2798$var$H);
                            return {
                                K: {
                                    x: t,
                                    y: o
                                },
                                G: {
                                    x: n,
                                    y: s
                                }
                            };
                        };
                        const _getViewportOverflowHideOffset = (t)=>{
                            const { G: n } = t;
                            const o = l || d ? 0 : 42;
                            const getHideOffsetPerAxis = (t, n, s)=>{
                                const e = t ? o : s;
                                const c = n && !l ? e : 0;
                                const r = t && !!o;
                                return [
                                    c,
                                    r
                                ];
                            };
                            const [s, e] = getHideOffsetPerAxis(i.x, n.x, a.x);
                            const [c, r] = getHideOffsetPerAxis(i.y, n.y, a.y);
                            return {
                                ot: {
                                    x: s,
                                    y: c
                                },
                                st: {
                                    x: e,
                                    y: r
                                }
                            };
                        };
                        const _hideNativeScrollbars = (t, { et: o }, s)=>{
                            if (!c) {
                                const e = $53673690361d2798$var$assignDeep({}, {
                                    [$53673690361d2798$var$$]: 0,
                                    [$53673690361d2798$var$C]: 0,
                                    [$53673690361d2798$var$O]: 0
                                });
                                const { ot: c, st: r } = _getViewportOverflowHideOffset(t);
                                const { x: l, y: i } = r;
                                const { x: a, y: u } = c;
                                const { ct: d } = n;
                                const _ = o ? $53673690361d2798$var$O : $53673690361d2798$var$$;
                                const f = o ? $53673690361d2798$var$m : $53673690361d2798$var$y;
                                const p = d[_];
                                const v = d[$53673690361d2798$var$C];
                                const h = d[f];
                                const g = d[$53673690361d2798$var$S];
                                e[$53673690361d2798$var$E] = `calc(100% + ${u + p * -1}px)`;
                                e[_] = -u + p;
                                e[$53673690361d2798$var$C] = -a + v;
                                if (s) {
                                    e[f] = h + (i ? u : 0);
                                    e[$53673690361d2798$var$S] = g + (l ? a : 0);
                                }
                                return e;
                            }
                        };
                        const _arrangeViewport = (t, s, e)=>{
                            if (u) {
                                const { ct: c } = n;
                                const { ot: l, st: i } = _getViewportOverflowHideOffset(t);
                                const { x: a, y: u } = i;
                                const { x: d, y: _ } = l;
                                const { et: f } = o;
                                const p = f ? $53673690361d2798$var$y : $53673690361d2798$var$m;
                                const v = c[p];
                                const h = c.paddingTop;
                                const g = s.w + e.w;
                                const b = s.h + e.h;
                                const w = {
                                    w: _ && u ? `${_ + g - v}px` : "",
                                    h: d && a ? `${d + b - h}px` : ""
                                };
                                $53673690361d2798$var$setStyles(r, {
                                    "--os-vaw": w.w,
                                    "--os-vah": w.h
                                });
                            }
                            return u;
                        };
                        const _undoViewportArrange = (t)=>{
                            if (u) {
                                const s = t || readViewportOverflowState();
                                const { ct: e } = n;
                                const { st: c } = _getViewportOverflowHideOffset(s);
                                const { x: l, y: i } = c;
                                const a = {};
                                const assignProps = (t)=>$53673690361d2798$var$each(t, (t)=>{
                                        a[t] = e[t];
                                    });
                                if (l) assignProps([
                                    $53673690361d2798$var$C,
                                    $53673690361d2798$var$w,
                                    $53673690361d2798$var$S
                                ]);
                                if (i) assignProps([
                                    $53673690361d2798$var$O,
                                    $53673690361d2798$var$$,
                                    $53673690361d2798$var$m,
                                    $53673690361d2798$var$y
                                ]);
                                const d = $53673690361d2798$var$getStyles(r, $53673690361d2798$var$keys(a));
                                const _ = $53673690361d2798$var$removeAttrClass(r, $53673690361d2798$var$Y, $53673690361d2798$var$K);
                                $53673690361d2798$var$setStyles(r, a);
                                return [
                                    ()=>{
                                        $53673690361d2798$var$setStyles(r, $53673690361d2798$var$assignDeep({}, d, _hideNativeScrollbars(s, o, u)));
                                        _();
                                    },
                                    s
                                ];
                            }
                            return [
                                $53673690361d2798$var$noop
                            ];
                        };
                        return {
                            rt: _getViewportOverflowHideOffset,
                            lt: _arrangeViewport,
                            it: _undoViewportArrange,
                            ut: _hideNativeScrollbars
                        };
                    }
                })
        }
    }))();
const $53673690361d2798$var$Rt = "__osClickScrollPlugin";
const $53673690361d2798$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$53673690361d2798$var$Rt]: {
            static: ()=>(t, n, o, s, e)=>{
                    let c = 0;
                    let r = $53673690361d2798$var$noop;
                    const animateClickScroll = (l)=>{
                        r = $53673690361d2798$var$animateNumber(l, l + s * Math.sign(o), 133, (o, l, i)=>{
                            t(o);
                            const u = n();
                            const d = u + s;
                            const _ = e >= u && e <= d;
                            if (i && !_) {
                                if (c) animateClickScroll(o);
                                else {
                                    const t = $53673690361d2798$var$a(()=>{
                                        animateClickScroll(o);
                                    }, 222);
                                    r = ()=>{
                                        clearTimeout(t);
                                    };
                                }
                                c++;
                            }
                        });
                    };
                    animateClickScroll(0);
                    return ()=>r();
                }
        }
    }))();
const $53673690361d2798$var$createSizeObserver = (t, n, o)=>{
    const { dt: s } = o || {};
    const e = $53673690361d2798$var$getStaticPluginModuleInstance($53673690361d2798$var$It);
    const [c] = $53673690361d2798$var$createCache({
        o: false,
        u: true
    });
    return ()=>{
        const o = [];
        const r = $53673690361d2798$var$createDOM(`<div class="${$53673690361d2798$var$st}"><div class="${$53673690361d2798$var$ct}"></div></div>`);
        const l = r[0];
        const i = l.firstChild;
        const onSizeChangedCallbackProxy = (t)=>{
            const o = t instanceof ResizeObserverEntry;
            let s = false;
            let e = false;
            if (o) {
                const [n, , o] = c(t.contentRect);
                const r = $53673690361d2798$var$domRectHasDimensions(n);
                e = $53673690361d2798$var$domRectAppeared(n, o);
                s = !e && !r;
            } else e = t === true;
            if (!s) n({
                _t: true,
                dt: e
            });
        };
        if ($53673690361d2798$var$f) {
            const t = new $53673690361d2798$var$f((t)=>onSizeChangedCallbackProxy(t.pop()));
            t.observe(i);
            $53673690361d2798$var$push(o, ()=>{
                t.disconnect();
            });
        } else if (e) {
            const [t, n] = e(i, onSizeChangedCallbackProxy, s);
            $53673690361d2798$var$push(o, $53673690361d2798$var$concat([
                $53673690361d2798$var$addClass(l, $53673690361d2798$var$et),
                $53673690361d2798$var$addEventListener(l, "animationstart", t)
            ], n));
        } else return $53673690361d2798$var$noop;
        return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, $53673690361d2798$var$push(o, $53673690361d2798$var$appendChildren(t, l)));
    };
};
const $53673690361d2798$var$createTrinsicObserver = (t, n)=>{
    let o;
    const isHeightIntrinsic = (t)=>t.h === 0 || t.isIntersecting || t.intersectionRatio > 0;
    const s = $53673690361d2798$var$createDiv($53673690361d2798$var$at);
    const [e] = $53673690361d2798$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = e(isHeightIntrinsic(t));
            const [, c] = s;
            return c && !o && n(s) && [
                s
            ];
        }
    };
    const intersectionObserverCallback = (t, n)=>triggerOnTrinsicChangedCallback(n.pop(), t);
    return [
        ()=>{
            const n = [];
            if ($53673690361d2798$var$_) {
                o = new $53673690361d2798$var$_($53673690361d2798$var$bind(intersectionObserverCallback, false), {
                    root: t
                });
                o.observe(s);
                $53673690361d2798$var$push(n, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $53673690361d2798$var$R(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                $53673690361d2798$var$push(n, $53673690361d2798$var$createSizeObserver(s, onSizeChanged)());
                onSizeChanged();
            }
            return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, $53673690361d2798$var$push(n, $53673690361d2798$var$appendChildren(t, s)));
        },
        ()=>o && intersectionObserverCallback(true, o.takeRecords())
    ];
};
const $53673690361d2798$var$createObserversSetup = (t, n, o, s)=>{
    let e;
    let c;
    let r;
    let l;
    let i;
    let a;
    const { R: u } = $53673690361d2798$var$getEnvironment();
    const d = `[${$53673690361d2798$var$B}]`;
    const _ = `[${$53673690361d2798$var$Y}]`;
    const p = [];
    const v = [
        "wrap",
        "cols",
        "rows"
    ];
    const h = [
        "id",
        "class",
        "style",
        "open"
    ];
    const { ft: g, vt: b, nt: w, ht: y, gt: m, bt: S, tt: O, wt: $, yt: C } = t;
    const getDirectionIsRTL = (t)=>$53673690361d2798$var$getStyles(t, "direction") === "rtl";
    const x = {
        St: false,
        et: getDirectionIsRTL(g)
    };
    const H = $53673690361d2798$var$getEnvironment();
    const E = $53673690361d2798$var$getStaticPluginModuleInstance($53673690361d2798$var$Dt);
    const [z] = $53673690361d2798$var$createCache({
        i: $53673690361d2798$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const s = E && E.Z(t, n, x, H, o).it;
        const e = !O && $($53673690361d2798$var$K);
        const c = e && $53673690361d2798$var$getElementScroll(y);
        const r = C($53673690361d2798$var$G, true);
        const l = e && s && s()[0];
        const i = $53673690361d2798$var$V(m);
        const a = $53673690361d2798$var$V(w);
        const u = $53673690361d2798$var$getFractionalSize(w);
        l && l();
        $53673690361d2798$var$scrollElementTo(y, c);
        r();
        return {
            w: a.w + i.w + u.w,
            h: a.h + i.h + u.h
        };
    });
    const A = S ? v : $53673690361d2798$var$concat(h, v);
    const I = $53673690361d2798$var$debounce(s, {
        _: ()=>e,
        p: ()=>c,
        v (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $53673690361d2798$var$concat($53673690361d2798$var$keys(o), $53673690361d2798$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const setDirection = (t)=>{
        const n = getDirectionIsRTL(g);
        $53673690361d2798$var$assignDeep(t, {
            Ot: a !== n
        });
        $53673690361d2798$var$assignDeep(x, {
            et: n
        });
        a = n;
    };
    const onTrinsicChanged = (t, n)=>{
        const [o, e] = t;
        const c = {
            $t: e
        };
        $53673690361d2798$var$assignDeep(x, {
            St: o
        });
        !n && s(c);
        return c;
    };
    const onSizeChanged = ({ _t: t, dt: n })=>{
        const o = t && !n;
        const e = !o && u ? I : s;
        const c = {
            _t: t || n,
            dt: n
        };
        setDirection(c);
        e(c);
    };
    const onContentMutation = (t, n)=>{
        const [, o] = z();
        const e = {
            Ct: o
        };
        setDirection(e);
        const c = t ? s : I;
        o && !n && c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            xt: n
        };
        setDirection(s);
        if (n && !o) I(s);
        return s;
    };
    const { V: T } = H;
    const [D, k] = m ? $53673690361d2798$var$createTrinsicObserver(b, onTrinsicChanged) : [];
    const R = !O && $53673690361d2798$var$createSizeObserver(b, onSizeChanged, {
        dt: true
    });
    const [M, L] = $53673690361d2798$var$createDOMObserver(b, false, onHostMutation, {
        B: h,
        F: $53673690361d2798$var$concat(h, p)
    });
    const P = O && $53673690361d2798$var$f && new $53673690361d2798$var$f((t)=>{
        const n = t[t.length - 1].contentRect;
        onSizeChanged({
            _t: true,
            dt: $53673690361d2798$var$domRectAppeared(n, i)
        });
        i = n;
    });
    return [
        ()=>{
            P && P.observe(b);
            const t = R && R();
            const n = D && D();
            const o = M();
            const s = T((t)=>{
                const [, n] = z();
                I({
                    Ht: t,
                    Ct: n
                });
            });
            return ()=>{
                P && P.disconnect();
                t && t();
                n && n();
                l && l();
                o();
                s();
            };
        },
        ({ Et: t, zt: n, At: o })=>{
            const s = {};
            const [i] = t("update.ignoreMutation");
            const [a, u] = t("update.attributes");
            const [f, p] = t("update.elementEvents");
            const [v, h] = t("update.debounce");
            const g = p || u;
            const b = n || o;
            const ignoreMutationFromOptions = (t)=>$53673690361d2798$var$isFunction(i) && i(t);
            if (g) {
                r && r();
                l && l();
                const [t, n] = $53673690361d2798$var$createDOMObserver(m || w, true, onContentMutation, {
                    F: $53673690361d2798$var$concat(A, a || []),
                    X: f,
                    Y: d,
                    J: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !O ? $53673690361d2798$var$liesBetween(o, d, _) : false;
                        return e || !!$53673690361d2798$var$closest(o, `.${$53673690361d2798$var$dt}`) || !!ignoreMutationFromOptions(t);
                    }
                });
                l = t();
                r = n;
            }
            if (h) {
                I.m();
                if ($53673690361d2798$var$isArray(v)) {
                    const t = v[0];
                    const n = v[1];
                    e = $53673690361d2798$var$isNumber(t) && t;
                    c = $53673690361d2798$var$isNumber(n) && n;
                } else if ($53673690361d2798$var$isNumber(v)) {
                    e = v;
                    c = false;
                } else {
                    e = false;
                    c = false;
                }
            }
            if (b) {
                const t = L();
                const n = k && k();
                const o = r && r();
                t && $53673690361d2798$var$assignDeep(s, onHostMutation(t[0], t[1], b));
                n && $53673690361d2798$var$assignDeep(s, onTrinsicChanged(n[0], b));
                o && $53673690361d2798$var$assignDeep(s, onContentMutation(o[0], b));
            }
            setDirection(s);
            return s;
        },
        x
    ];
};
const $53673690361d2798$var$createScrollbarsSetupElements = (t, n, o, s)=>{
    const { L: e } = $53673690361d2798$var$getEnvironment();
    const { scrollbars: c } = e();
    const { slot: r } = c;
    const { ft: l, vt: i, nt: a, It: u, ht: d, Tt: _, tt: f } = n;
    const { scrollbars: v } = u ? {} : t;
    const { slot: h } = v || {};
    const g = new Map;
    const initScrollTimeline = (t)=>$53673690361d2798$var$p && new $53673690361d2798$var$p({
            source: d,
            axis: t
        });
    const b = {
        x: initScrollTimeline("x"),
        y: initScrollTimeline("y")
    };
    const w = $53673690361d2798$var$dynamicInitializationElement([
        l,
        i,
        a
    ], ()=>f && _ ? l : i, r, h);
    const getScrollbarHandleLengthRatio = (t, n)=>{
        if (n) {
            const o = t ? $53673690361d2798$var$E : $53673690361d2798$var$z;
            const { Dt: s, kt: e } = n;
            const c = $53673690361d2798$var$getBoundingClientRect(e)[o];
            const r = $53673690361d2798$var$getBoundingClientRect(s)[o];
            return $53673690361d2798$var$capNumber(0, 1, c / r || 0);
        }
        const s = t ? "x" : "y";
        const { Rt: e, Mt: c } = o;
        const r = c[s];
        const l = e[s];
        return $53673690361d2798$var$capNumber(0, 1, r / (r + l) || 0);
    };
    const getScrollbarHandleOffsetRatio = (t, n, o)=>{
        const s = getScrollbarHandleLengthRatio(o, t);
        return 1 / s * (1 - s) * n;
    };
    const addDirectionRTLKeyframes = (t)=>$53673690361d2798$var$assignDeep(t, {
            clear: [
                "left"
            ]
        });
    const cancelElementAnimations = (t)=>{
        g.forEach((n, o)=>{
            const s = t ? $53673690361d2798$var$inArray($53673690361d2798$var$createOrKeepArray(t), o) : true;
            if (s) {
                $53673690361d2798$var$each(n || [], (t)=>{
                    t && t.cancel();
                });
                g.delete(o);
            }
        });
    };
    const setElementAnimation = (t, n, o, s)=>{
        const e = g.get(t) || [];
        const c = e.find((t)=>t && t.timeline === n);
        if (c) c.effect = new KeyframeEffect(t, o, {
            composite: s
        });
        else g.set(t, $53673690361d2798$var$concat(e, [
            t.animate(o, {
                timeline: n,
                composite: s
            })
        ]));
    };
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $53673690361d2798$var$addClass : $53673690361d2798$var$removeClass;
        $53673690361d2798$var$each(t, (t)=>{
            s(t.Vt, n);
        });
    };
    const scrollbarStyle = (t, n)=>{
        $53673690361d2798$var$each(t, (t)=>{
            const [o, s] = n(t);
            $53673690361d2798$var$setStyles(o, s);
        });
    };
    const scrollbarStructureRefreshHandleLength = (t, n)=>{
        scrollbarStyle(t, (t)=>{
            const { kt: o } = t;
            return [
                o,
                {
                    [n ? $53673690361d2798$var$E : $53673690361d2798$var$z]: $53673690361d2798$var$ratioToCssPercent(getScrollbarHandleLengthRatio(n))
                }
            ];
        });
    };
    const scrollbarStructureRefreshHandleOffset = (t, n)=>{
        const { Lt: s } = o;
        const e = n ? "x" : "y";
        const c = b[e];
        const r = $53673690361d2798$var$isDefaultDirectionScrollCoordinates(s)[e];
        const getAxisTransformValue = (t, o)=>$53673690361d2798$var$getTrasformTranslateValue($53673690361d2798$var$ratioToCssPercent(getScrollbarHandleOffsetRatio(t, r ? o : 1 - o, n)), n);
        if (c) $53673690361d2798$var$each(t, (t)=>{
            const { kt: n } = t;
            setElementAnimation(n, c, addDirectionRTLKeyframes({
                transform: [
                    0,
                    1
                ].map((n)=>getAxisTransformValue(t, n))
            }));
        });
        else scrollbarStyle(t, (t)=>[
                t.kt,
                {
                    transform: getAxisTransformValue(t, $53673690361d2798$var$getScrollCoordinatesPercent(s, $53673690361d2798$var$getElementScroll(d))[e])
                }
            ]);
    };
    const doRefreshScrollbarOffset = (t)=>f && !_ && $53673690361d2798$var$parent(t) === a;
    const y = [];
    const m = [];
    const S = [];
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $53673690361d2798$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        e && scrollbarStructureAddRemoveClass(m, t, n);
        c && scrollbarStructureAddRemoveClass(S, t, n);
    };
    const refreshScrollbarsHandleLength = ()=>{
        scrollbarStructureRefreshHandleLength(m, true);
        scrollbarStructureRefreshHandleLength(S);
    };
    const refreshScrollbarsHandleOffset = ()=>{
        scrollbarStructureRefreshHandleOffset(m, true);
        scrollbarStructureRefreshHandleOffset(S);
    };
    const refreshScrollbarsScrollbarOffset = ()=>{
        if (f) {
            const { Rt: t, Lt: n } = o;
            const s = $53673690361d2798$var$isDefaultDirectionScrollCoordinates(n);
            const e = .5;
            if (b.x && b.y) $53673690361d2798$var$each($53673690361d2798$var$concat(S, m), ({ Vt: n })=>{
                if (doRefreshScrollbarOffset(n)) {
                    const setScrollbarElementAnimation = (o)=>setElementAnimation(n, b[o], addDirectionRTLKeyframes({
                            transform: [
                                0,
                                s[o] ? 1 : -1
                            ].map((n)=>$53673690361d2798$var$getTrasformTranslateValue($53673690361d2798$var$numberToCssPx(n * (t[o] - e)), o === "x"))
                        }), "add");
                    setScrollbarElementAnimation("x");
                    setScrollbarElementAnimation("y");
                } else cancelElementAnimations(n);
            });
            else {
                const o = $53673690361d2798$var$getScrollCoordinatesPercent(n, $53673690361d2798$var$getElementScroll(d));
                const styleScrollbarPosition = (n)=>{
                    const { Vt: e } = n;
                    const c = doRefreshScrollbarOffset(e) && e;
                    const getTranslateValue = (t, n, o)=>{
                        const s = n * t;
                        return $53673690361d2798$var$numberToCssPx(o ? s : -s);
                    };
                    return [
                        c,
                        c && {
                            transform: $53673690361d2798$var$getTrasformTranslateValue({
                                x: getTranslateValue(o.x, t.x, s.x),
                                y: getTranslateValue(o.y, t.y, s.y)
                            })
                        }
                    ];
                };
                scrollbarStyle(m, styleScrollbarPosition);
                scrollbarStyle(S, styleScrollbarPosition);
            }
        }
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? $53673690361d2798$var$ft : $53673690361d2798$var$pt;
        const o = $53673690361d2798$var$createDiv(`${$53673690361d2798$var$dt} ${n}`);
        const e = $53673690361d2798$var$createDiv($53673690361d2798$var$vt);
        const c = $53673690361d2798$var$createDiv($53673690361d2798$var$ht);
        const r = {
            Vt: o,
            Dt: e,
            kt: c
        };
        $53673690361d2798$var$push(t ? m : S, r);
        $53673690361d2798$var$push(y, [
            $53673690361d2798$var$appendChildren(o, e),
            $53673690361d2798$var$appendChildren(e, c),
            $53673690361d2798$var$bind($53673690361d2798$var$removeElements, o),
            cancelElementAnimations,
            s(r, scrollbarsAddRemoveClass, scrollbarStructureRefreshHandleOffset, t)
        ]);
        return r;
    };
    const O = $53673690361d2798$var$bind(generateScrollbarDOM, true);
    const $ = $53673690361d2798$var$bind(generateScrollbarDOM, false);
    const appendElements = ()=>{
        $53673690361d2798$var$appendChildren(w, m[0].Vt);
        $53673690361d2798$var$appendChildren(w, S[0].Vt);
        return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, y);
    };
    O();
    $();
    return [
        {
            Pt: refreshScrollbarsHandleLength,
            Ut: refreshScrollbarsHandleOffset,
            Nt: refreshScrollbarsScrollbarOffset,
            jt: scrollbarsAddRemoveClass,
            qt: {
                M: b.x,
                Ft: m,
                Bt: O,
                Xt: $53673690361d2798$var$bind(scrollbarStyle, m)
            },
            Yt: {
                M: b.y,
                Ft: S,
                Bt: $,
                Xt: $53673690361d2798$var$bind(scrollbarStyle, S)
            }
        },
        appendElements
    ];
};
const $53673690361d2798$var$createScrollbarsSetupEvents = (t, n, o, s)=>(r, l, i, u)=>{
        const { vt: d, nt: _, tt: f, ht: p, Wt: v, yt: h } = n;
        const { Vt: g, Dt: b, kt: w } = r;
        const [y, m] = $53673690361d2798$var$selfClearTimeout(333);
        const [S, O] = $53673690361d2798$var$selfClearTimeout(444);
        const [$, C] = $53673690361d2798$var$selfClearTimeout();
        const x = $53673690361d2798$var$bind(i, [
            r
        ], u);
        const scrollOffsetElementScrollBy = (t)=>{
            $53673690361d2798$var$isFunction(p.scrollBy) && p.scrollBy({
                behavior: "smooth",
                left: t.x,
                top: t.y
            });
        };
        const H = u ? $53673690361d2798$var$E : $53673690361d2798$var$z;
        const createInteractiveScrollEvents = ()=>{
            const n = "pointerup pointercancel lostpointercapture";
            const s = `client${u ? "X" : "Y"}`;
            const r = u ? "left" : "top";
            const l = u ? "w" : "h";
            const i = u ? "x" : "y";
            const createRelativeHandleMove = (t, n)=>(s)=>{
                    const { Rt: e } = o;
                    const c = $53673690361d2798$var$R(b)[l] - $53673690361d2798$var$R(w)[l];
                    const r = n * s / c;
                    const a = r * e[i];
                    $53673690361d2798$var$scrollElementTo(p, {
                        [i]: t + a
                    });
                };
            return $53673690361d2798$var$addEventListener(b, "pointerdown", (o)=>{
                const a = $53673690361d2798$var$closest(o.target, `.${$53673690361d2798$var$ht}`) === w;
                const u = a ? w : b;
                const d = t.scrollbars;
                const { button: _, isPrimary: f, pointerType: g } = o;
                const { pointers: y } = d;
                const m = _ === 0 && f && d[a ? "dragScroll" : "clickScroll"] && (y || []).includes(g);
                if (m) {
                    O();
                    const t = !a && o.shiftKey;
                    const d = $53673690361d2798$var$bind($53673690361d2798$var$getBoundingClientRect, w);
                    const _ = $53673690361d2798$var$bind($53673690361d2798$var$getBoundingClientRect, b);
                    const getHandleOffset = (t, n)=>(t || d())[r] - (n || _())[r];
                    const f = $53673690361d2798$var$e($53673690361d2798$var$getBoundingClientRect(p)[H]) / $53673690361d2798$var$R(p)[l] || 1;
                    const g = createRelativeHandleMove($53673690361d2798$var$getElementScroll(p)[i], 1 / f);
                    const y = o[s];
                    const m = d();
                    const $ = _();
                    const C = m[H];
                    const x = getHandleOffset(m, $) + C / 2;
                    const E = y - $[r];
                    const z = a ? 0 : E - x;
                    const releasePointerCapture = (t)=>{
                        $53673690361d2798$var$runEachAndClear(I);
                        u.releasePointerCapture(t.pointerId);
                    };
                    const addScrollbarPressedClass = ()=>h($53673690361d2798$var$Z, true);
                    const A = addScrollbarPressedClass();
                    const I = [
                        ()=>{
                            const t = $53673690361d2798$var$getElementScroll(p);
                            A();
                            const n = $53673690361d2798$var$getElementScroll(p);
                            const o = {
                                x: n.x - t.x,
                                y: n.y - t.y
                            };
                            if ($53673690361d2798$var$c(o.x) > 3 || $53673690361d2798$var$c(o.y) > 3) {
                                addScrollbarPressedClass();
                                $53673690361d2798$var$scrollElementTo(p, t);
                                scrollOffsetElementScrollBy(o);
                                S(A);
                            }
                        },
                        $53673690361d2798$var$addEventListener(v, n, releasePointerCapture),
                        $53673690361d2798$var$addEventListener(v, "selectstart", (t)=>$53673690361d2798$var$preventDefault(t), {
                            C: false
                        }),
                        $53673690361d2798$var$addEventListener(b, n, releasePointerCapture),
                        $53673690361d2798$var$addEventListener(b, "pointermove", (n)=>{
                            const o = n[s] - y;
                            if (a || t) g(z + o);
                        })
                    ];
                    u.setPointerCapture(o.pointerId);
                    if (t) g(z);
                    else if (!a) {
                        const t = $53673690361d2798$var$getStaticPluginModuleInstance($53673690361d2798$var$Rt);
                        t && $53673690361d2798$var$push(I, t(g, getHandleOffset, z, C, E));
                    }
                }
            });
        };
        let A = true;
        const isAffectingTransition = (t)=>t.propertyName.indexOf(H) > -1;
        return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, [
            $53673690361d2798$var$addEventListener(w, "pointermove pointerleave", s),
            $53673690361d2798$var$addEventListener(g, "pointerenter", ()=>{
                l($53673690361d2798$var$wt, true);
            }),
            $53673690361d2798$var$addEventListener(g, "pointerleave pointercancel", ()=>{
                l($53673690361d2798$var$wt, false);
            }),
            !f && $53673690361d2798$var$addEventListener(g, "mousedown", ()=>{
                const t = $53673690361d2798$var$getFocusedElement();
                if ($53673690361d2798$var$hasAttr(t, $53673690361d2798$var$Y) || $53673690361d2798$var$hasAttr(t, $53673690361d2798$var$B) || t === document.body) $53673690361d2798$var$a($53673690361d2798$var$bind($53673690361d2798$var$focusElement, _), 25);
            }),
            $53673690361d2798$var$addEventListener(g, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: s } = t;
                if (A && s === 0 && $53673690361d2798$var$parent(g) === d) scrollOffsetElementScrollBy({
                    x: n,
                    y: o
                });
                A = false;
                l($53673690361d2798$var$Ot, true);
                y(()=>{
                    A = true;
                    l($53673690361d2798$var$Ot);
                });
                $53673690361d2798$var$preventDefault(t);
            }, {
                C: false,
                H: true
            }),
            $53673690361d2798$var$addEventListener(w, "transitionstart", (t)=>{
                if (isAffectingTransition(t)) {
                    const animateHandleOffset = ()=>{
                        x();
                        $(animateHandleOffset);
                    };
                    animateHandleOffset();
                }
            }),
            $53673690361d2798$var$addEventListener(w, "transitionend transitioncancel", (t)=>{
                if (isAffectingTransition(t)) {
                    C();
                    x();
                }
            }),
            $53673690361d2798$var$addEventListener(g, "pointerdown", $53673690361d2798$var$bind($53673690361d2798$var$addEventListener, v, "click", $53673690361d2798$var$stopAndPrevent, {
                A: true,
                H: true,
                C: false
            }), {
                H: true
            }),
            createInteractiveScrollEvents(),
            m,
            O,
            C
        ]);
    };
const $53673690361d2798$var$createScrollbarsSetup = (t, n, o, s, e, c)=>{
    let r;
    let l;
    let i;
    let a;
    let u;
    let d = $53673690361d2798$var$noop;
    let _ = 0;
    const isHoverablePointerType = (t)=>t.pointerType === "mouse";
    const [f, p] = $53673690361d2798$var$selfClearTimeout();
    const [v, h] = $53673690361d2798$var$selfClearTimeout(100);
    const [g, b] = $53673690361d2798$var$selfClearTimeout(100);
    const [w, y] = $53673690361d2798$var$selfClearTimeout(()=>_);
    const [m, S] = $53673690361d2798$var$createScrollbarsSetupElements(t, e, s, $53673690361d2798$var$createScrollbarsSetupEvents(n, e, s, (t)=>isHoverablePointerType(t) && manageScrollbarsAutoHideInstantInteraction()));
    const { vt: O, Jt: $, Tt: C } = e;
    const { jt: x, Pt: H, Ut: E, Nt: z } = m;
    const manageScrollbarsAutoHide = (t, n)=>{
        y();
        if (t) x($53673690361d2798$var$St);
        else {
            const t = $53673690361d2798$var$bind(x, $53673690361d2798$var$St, true);
            if (_ > 0 && !n) w(t);
            else t();
        }
    };
    const manageScrollbarsAutoHideInstantInteraction = ()=>{
        if (i ? !r : !a) {
            manageScrollbarsAutoHide(true);
            v(()=>{
                manageScrollbarsAutoHide(false);
            });
        }
    };
    const manageAutoHideSuspension = (t)=>{
        x($53673690361d2798$var$mt, t, true);
        x($53673690361d2798$var$mt, t, false);
    };
    const onHostMouseEnter = (t)=>{
        if (isHoverablePointerType(t)) {
            r = i;
            i && manageScrollbarsAutoHide(true);
        }
    };
    const I = [
        y,
        h,
        b,
        p,
        ()=>d(),
        $53673690361d2798$var$addEventListener(O, "pointerover", onHostMouseEnter, {
            A: true
        }),
        $53673690361d2798$var$addEventListener(O, "pointerenter", onHostMouseEnter),
        $53673690361d2798$var$addEventListener(O, "pointerleave", (t)=>{
            if (isHoverablePointerType(t)) {
                r = false;
                i && manageScrollbarsAutoHide(false);
            }
        }),
        $53673690361d2798$var$addEventListener(O, "pointermove", (t)=>{
            isHoverablePointerType(t) && l && manageScrollbarsAutoHideInstantInteraction();
        }),
        $53673690361d2798$var$addEventListener($, "scroll", (t)=>{
            f(()=>{
                E();
                manageScrollbarsAutoHideInstantInteraction();
            });
            c(t);
            z();
        })
    ];
    return [
        ()=>$53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, $53673690361d2798$var$push(I, S())),
        ({ Et: t, At: n, Kt: e, Gt: c })=>{
            const { Qt: r, Zt: f, tn: p, nn: v } = c || {};
            const { Ot: h, dt: b } = e || {};
            const { et: w } = o;
            const { k: y } = $53673690361d2798$var$getEnvironment();
            const { K: m, sn: S } = s;
            const [O, I] = t("showNativeOverlaidScrollbars");
            const [D, k] = t("scrollbars.theme");
            const [R, M] = t("scrollbars.visibility");
            const [V, L] = t("scrollbars.autoHide");
            const [P, U] = t("scrollbars.autoHideSuspend");
            const [N] = t("scrollbars.autoHideDelay");
            const [j, q] = t("scrollbars.dragScroll");
            const [F, B] = t("scrollbars.clickScroll");
            const [X, Y] = t("overflow");
            const W = b && !n;
            const J = S.x || S.y;
            const K = r || f || v || h || n;
            const G = p || M || Y;
            const Q = O && y.x && y.y;
            const setScrollbarVisibility = (t, n, o)=>{
                const s = t.includes($53673690361d2798$var$T) && (R === $53673690361d2798$var$A || R === "auto" && n === $53673690361d2798$var$T);
                x($53673690361d2798$var$gt, s, o);
                return s;
            };
            _ = N;
            if (W) {
                if (P && J) {
                    manageAutoHideSuspension(false);
                    d();
                    g(()=>{
                        d = $53673690361d2798$var$addEventListener($, "scroll", $53673690361d2798$var$bind(manageAutoHideSuspension, true), {
                            A: true
                        });
                    });
                } else manageAutoHideSuspension(true);
            }
            if (I) x($53673690361d2798$var$ut, Q);
            if (k) {
                x(u);
                x(D, true);
                u = D;
            }
            if (U && !P) manageAutoHideSuspension(true);
            if (L) {
                l = V === "move";
                i = V === "leave";
                a = V === "never";
                manageScrollbarsAutoHide(a, true);
            }
            if (q) x($53673690361d2798$var$Ct, j);
            if (B) x($53673690361d2798$var$$t, F);
            if (G) {
                const t = setScrollbarVisibility(X.x, m.x, true);
                const n = setScrollbarVisibility(X.y, m.y, false);
                const o = t && n;
                x($53673690361d2798$var$bt, !o);
            }
            if (K) {
                H();
                E();
                z();
                x($53673690361d2798$var$yt, !S.x, true);
                x($53673690361d2798$var$yt, !S.y, false);
                x($53673690361d2798$var$_t, w && !C);
            }
        },
        {},
        m
    ];
};
const $53673690361d2798$var$createStructureSetupElements = (t)=>{
    const o = $53673690361d2798$var$getEnvironment();
    const { L: s, R: e } = o;
    const { elements: c } = s();
    const { host: r, padding: l, viewport: i, content: a } = c;
    const u = $53673690361d2798$var$isHTMLElement(t);
    const d = u ? {} : t;
    const { elements: _ } = d;
    const { host: f, padding: p, viewport: v, content: h } = _ || {};
    const g = u ? t : d.target;
    const b = $53673690361d2798$var$isBodyElement(g);
    const w = $53673690361d2798$var$is(g, "textarea");
    const y = g.ownerDocument;
    const m = y.documentElement;
    const getDocumentWindow = ()=>y.defaultView || $53673690361d2798$var$n;
    const S = $53673690361d2798$var$bind($53673690361d2798$var$staticInitializationElement, [
        g
    ]);
    const O = $53673690361d2798$var$bind($53673690361d2798$var$dynamicInitializationElement, [
        g
    ]);
    const $ = $53673690361d2798$var$bind($53673690361d2798$var$createDiv, "");
    const C = $53673690361d2798$var$bind(S, $, i);
    const x = $53673690361d2798$var$bind(O, $, a);
    const H = C(v);
    const E = H === g;
    const z = E && b;
    const A = !E && x(h);
    const I = !E && H === A;
    const T = z ? m : H;
    const D = w ? S($, r, f) : g;
    const k = z ? T : D;
    const R = !E && O($, l, p);
    const M = !I && A;
    const V = [
        M,
        T,
        R,
        k
    ].map((t)=>$53673690361d2798$var$isHTMLElement(t) && !$53673690361d2798$var$parent(t) && t);
    const elementIsGenerated = (t)=>t && $53673690361d2798$var$inArray(V, t);
    const L = elementIsGenerated(T) ? g : T;
    const P = {
        ft: g,
        vt: k,
        nt: T,
        en: R,
        gt: M,
        ht: z ? m : T,
        Jt: z ? y : T,
        cn: b ? m : L,
        Wt: y,
        bt: w,
        Tt: b,
        It: u,
        tt: E,
        rn: getDocumentWindow,
        wt: (t)=>$53673690361d2798$var$hasAttrClass(T, $53673690361d2798$var$Y, t),
        yt: (t, n)=>$53673690361d2798$var$addRemoveAttrClass(T, $53673690361d2798$var$Y, t, n)
    };
    const { ft: U, vt: N, en: q, nt: W, gt: J } = P;
    const K = [
        ()=>{
            $53673690361d2798$var$removeAttrs(N, [
                $53673690361d2798$var$B,
                $53673690361d2798$var$j
            ]);
            $53673690361d2798$var$removeAttrs(U, $53673690361d2798$var$j);
            if (b) $53673690361d2798$var$removeAttrs(m, [
                $53673690361d2798$var$j,
                $53673690361d2798$var$B
            ]);
        }
    ];
    const G = w && elementIsGenerated(N);
    let Z = w ? U : $53673690361d2798$var$contents([
        J,
        W,
        q,
        N,
        U
    ].find((t)=>t && !elementIsGenerated(t)));
    const tt = z ? U : J || W;
    const st = $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, K);
    const appendElements = ()=>{
        const t = getDocumentWindow();
        const n = $53673690361d2798$var$getFocusedElement();
        const unwrap = (t)=>{
            $53673690361d2798$var$appendChildren($53673690361d2798$var$parent(t), $53673690361d2798$var$contents(t));
            $53673690361d2798$var$removeElements(t);
        };
        const prepareWrapUnwrapFocus = (t)=>$53673690361d2798$var$addEventListener(t, "focusin focusout focus blur", $53673690361d2798$var$stopAndPrevent, {
                H: true,
                C: false
            });
        const o = "tabindex";
        const s = $53673690361d2798$var$getAttr(W, o);
        const c = prepareWrapUnwrapFocus(n);
        $53673690361d2798$var$setAttrs(N, $53673690361d2798$var$B, E ? "" : $53673690361d2798$var$X);
        $53673690361d2798$var$setAttrs(q, $53673690361d2798$var$nt, "");
        $53673690361d2798$var$setAttrs(W, $53673690361d2798$var$Y, "");
        $53673690361d2798$var$setAttrs(J, $53673690361d2798$var$ot, "");
        if (!E) {
            $53673690361d2798$var$setAttrs(W, o, s || "-1");
            b && $53673690361d2798$var$setAttrs(m, $53673690361d2798$var$F, "");
        }
        if (G) {
            $53673690361d2798$var$insertAfter(U, N);
            $53673690361d2798$var$push(K, ()=>{
                $53673690361d2798$var$insertAfter(N, U);
                $53673690361d2798$var$removeElements(N);
            });
        }
        $53673690361d2798$var$appendChildren(tt, Z);
        $53673690361d2798$var$appendChildren(N, q);
        $53673690361d2798$var$appendChildren(q || N, !E && W);
        $53673690361d2798$var$appendChildren(W, J);
        $53673690361d2798$var$push(K, [
            c,
            ()=>{
                const t = $53673690361d2798$var$getFocusedElement();
                const n = elementIsGenerated(W);
                const e = n && t === W ? U : t;
                const c = prepareWrapUnwrapFocus(e);
                $53673690361d2798$var$removeAttrs(q, $53673690361d2798$var$nt);
                $53673690361d2798$var$removeAttrs(J, $53673690361d2798$var$ot);
                $53673690361d2798$var$removeAttrs(W, $53673690361d2798$var$Y);
                b && $53673690361d2798$var$removeAttrs(m, $53673690361d2798$var$F);
                s ? $53673690361d2798$var$setAttrs(W, o, s) : $53673690361d2798$var$removeAttrs(W, o);
                elementIsGenerated(J) && unwrap(J);
                n && unwrap(W);
                elementIsGenerated(q) && unwrap(q);
                $53673690361d2798$var$focusElement(e);
                c();
            }
        ]);
        if (e && !E) {
            $53673690361d2798$var$addAttrClass(W, $53673690361d2798$var$Y, $53673690361d2798$var$Q);
            $53673690361d2798$var$push(K, $53673690361d2798$var$bind($53673690361d2798$var$removeAttrs, W, $53673690361d2798$var$Y));
        }
        $53673690361d2798$var$focusElement(!E && b && n === U && t.top === t ? W : n);
        c();
        Z = 0;
        return st;
    };
    return [
        P,
        appendElements,
        st
    ];
};
const $53673690361d2798$var$createTrinsicUpdateSegment = ({ gt: t })=>({ Kt: n, ln: o, At: s })=>{
        const { $t: e } = n || {};
        const { St: c } = o;
        const r = t && (e || s);
        if (r) $53673690361d2798$var$setStyles(t, {
            [$53673690361d2798$var$z]: c && "100%"
        });
    };
const $53673690361d2798$var$createPaddingUpdateSegment = ({ vt: t, en: n, nt: o, tt: s }, e)=>{
    const [c, r] = $53673690361d2798$var$createCache({
        i: $53673690361d2798$var$equalTRBL,
        o: $53673690361d2798$var$topRightBottomLeft()
    }, $53673690361d2798$var$bind($53673690361d2798$var$topRightBottomLeft, t, "padding", ""));
    return ({ Et: t, Kt: l, ln: i, At: a })=>{
        let [u, d] = r(a);
        const { R: _ } = $53673690361d2798$var$getEnvironment();
        const { _t: f, Ct: p, Ot: v } = l || {};
        const { et: h } = i;
        const [g, b] = t("paddingAbsolute");
        const x = a || p;
        if (f || d || x) [u, d] = c(a);
        const H = !s && (b || v || d);
        if (H) {
            const t = !g || !n && !_;
            const s = u.r + u.l;
            const c = u.t + u.b;
            const r = {
                [$53673690361d2798$var$$]: t && !h ? -s : 0,
                [$53673690361d2798$var$C]: t ? -c : 0,
                [$53673690361d2798$var$O]: t && h ? -s : 0,
                top: t ? -u.t : 0,
                right: t ? h ? -u.r : "auto" : 0,
                left: t ? h ? "auto" : -u.l : 0,
                [$53673690361d2798$var$E]: t && `calc(100% + ${s}px)`
            };
            const l = {
                [$53673690361d2798$var$w]: t ? u.t : 0,
                [$53673690361d2798$var$y]: t ? u.r : 0,
                [$53673690361d2798$var$S]: t ? u.b : 0,
                [$53673690361d2798$var$m]: t ? u.l : 0
            };
            $53673690361d2798$var$setStyles(n || o, r);
            $53673690361d2798$var$setStyles(o, l);
            $53673690361d2798$var$assignDeep(e, {
                en: u,
                an: !t,
                ct: n ? l : $53673690361d2798$var$assignDeep({}, r, l)
            });
        }
        return {
            un: H
        };
    };
};
const $53673690361d2798$var$createOverflowUpdateSegment = (t, s)=>{
    const e = $53673690361d2798$var$getEnvironment();
    const { vt: c, en: r, nt: l, tt: a, Jt: u, ht: d, Tt: _, yt: f, rn: p } = t;
    const { R: v } = e;
    const h = _ && a;
    const g = $53673690361d2798$var$bind($53673690361d2798$var$o, 0);
    const b = [
        "display",
        "direction",
        "flexDirection",
        "writingMode"
    ];
    const w = {
        i: $53673690361d2798$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    };
    const y = {
        i: $53673690361d2798$var$equalXY,
        o: {}
    };
    const getOverflowAmount = (t, o)=>{
        const s = $53673690361d2798$var$n.devicePixelRatio % 1 !== 0 ? 1 : 0;
        const e = {
            w: g(t.w - o.w),
            h: g(t.h - o.h)
        };
        return {
            w: e.w > s ? e.w : 0,
            h: e.h > s ? e.h : 0
        };
    };
    const measureScrollCoordinates = ()=>{
        const t = $53673690361d2798$var$getElementScroll(d);
        const n = f($53673690361d2798$var$tt, true);
        const o = $53673690361d2798$var$addEventListener(u, $53673690361d2798$var$T, (n)=>{
            const o = $53673690361d2798$var$getElementScroll(d);
            if (n.isTrusted && o.x === t.x && o.y === t.y) $53673690361d2798$var$stopPropagation(n);
        }, {
            H: true,
            A: true
        });
        $53673690361d2798$var$scrollElementTo(d, {
            x: 0,
            y: 0
        });
        n();
        const s = $53673690361d2798$var$getElementScroll(d);
        const e = $53673690361d2798$var$V(d);
        $53673690361d2798$var$scrollElementTo(d, {
            x: e.w,
            y: e.h
        });
        const c = $53673690361d2798$var$getElementScroll(d);
        $53673690361d2798$var$scrollElementTo(d, {
            x: c.x - s.x < 1 && -e.w,
            y: c.y - s.y < 1 && -e.h
        });
        const r = $53673690361d2798$var$getElementScroll(d);
        $53673690361d2798$var$scrollElementTo(d, t);
        $53673690361d2798$var$i(()=>o());
        return {
            I: s,
            T: r
        };
    };
    const getFlowDirectionStyles = ()=>$53673690361d2798$var$assignDeep({}, $53673690361d2798$var$hasDimensions(l) ? $53673690361d2798$var$getStyles(l, b) : {});
    const [m, S] = $53673690361d2798$var$createCache(w, $53673690361d2798$var$bind($53673690361d2798$var$getFractionalSize, l));
    const [O, $] = $53673690361d2798$var$createCache(w, $53673690361d2798$var$bind($53673690361d2798$var$V, l));
    const [C, x] = $53673690361d2798$var$createCache(w);
    const [H] = $53673690361d2798$var$createCache(y);
    const [E, z] = $53673690361d2798$var$createCache(w);
    const [D] = $53673690361d2798$var$createCache(y);
    const [k] = $53673690361d2798$var$createCache({
        i: (t, n)=>$53673690361d2798$var$equal(t, n, b),
        o: {}
    });
    const [R, L] = $53673690361d2798$var$createCache({
        i: (t, n)=>$53673690361d2798$var$equalXY(t.I, n.I) && $53673690361d2798$var$equalXY(t.T, n.T),
        o: $53673690361d2798$var$getZeroScrollCoordinates()
    });
    const P = $53673690361d2798$var$getStaticPluginModuleInstance($53673690361d2798$var$Dt);
    const createViewportOverflowStyleClassName = (t, n)=>{
        const o = n ? $53673690361d2798$var$W : $53673690361d2798$var$J;
        return `${o}${$53673690361d2798$var$capitalizeFirstLetter(t)}`;
    };
    const setViewportOverflow = (t)=>{
        const { K: n } = t;
        $53673690361d2798$var$each($53673690361d2798$var$keys(n), (t)=>{
            const o = t === "x";
            const s = [
                $53673690361d2798$var$A,
                $53673690361d2798$var$I,
                $53673690361d2798$var$T
            ].map((t)=>createViewportOverflowStyleClassName(t, o));
            f(s.join(" "));
            f(createViewportOverflowStyleClassName(n[t], o), true);
        });
    };
    return ({ Et: n, Kt: i, ln: a, At: u }, { un: d })=>{
        const { _t: _, Ct: b, Ot: w, dt: y, Ht: A } = i || {};
        const I = P && P.Z(t, s, a, e, n);
        const { lt: T, it: V, ut: U } = I || {};
        const [N, j] = $53673690361d2798$var$getShowNativeOverlaidScrollbars(n, e);
        const [F, X] = n("overflow");
        const Y = $53673690361d2798$var$overflowIsVisible(F.x);
        const W = $53673690361d2798$var$overflowIsVisible(F.y);
        const J = _ || d || b || w || A || j;
        let K = S(u);
        let G = $(u);
        let Z = x(u);
        let tt = z(u);
        if (j && v) f($53673690361d2798$var$Q, !N);
        if (J) {
            const [t] = V ? V() : [];
            const [n] = K = m(u);
            const [s] = G = O(u);
            const e = $53673690361d2798$var$M(l);
            const c = s;
            const r = e;
            t && t();
            const i = $53673690361d2798$var$getWindowSize(p());
            const a = {
                w: g($53673690361d2798$var$o(s.w, c.w) + n.w),
                h: g($53673690361d2798$var$o(s.h, c.h) + n.h)
            };
            const d = {
                w: g((h ? i.w : r.w + g(e.w - s.w)) + n.w),
                h: g((h ? i.h : r.h + g(e.h - s.h)) + n.h)
            };
            tt = E(d);
            Z = C(getOverflowAmount(a, d), u);
        }
        const [ot, st] = tt;
        const [et, ct] = Z;
        const [rt, lt] = G;
        const [it, at] = K;
        const [ut, dt] = H({
            x: et.w > 0,
            y: et.h > 0
        });
        const _t = Y && W && (ut.x || ut.y) || Y && ut.x && !ut.y || W && ut.y && !ut.x;
        const ft = d || w || A || at || lt || st || ct || X || j || J;
        const pt = $53673690361d2798$var$createViewportOverflowState(ut, F);
        const [vt, ht] = D(pt.K);
        const [, gt] = k(getFlowDirectionStyles(), u);
        const bt = w || y || gt || dt || u;
        const [wt, yt] = bt ? R(measureScrollCoordinates(), u) : L();
        if (ft) {
            setViewportOverflow(pt);
            if (U && T) $53673690361d2798$var$setStyles(l, U(pt, a, T(pt, rt, it)));
        }
        $53673690361d2798$var$addRemoveAttrClass(c, $53673690361d2798$var$B, $53673690361d2798$var$q, _t);
        $53673690361d2798$var$addRemoveAttrClass(r, $53673690361d2798$var$nt, $53673690361d2798$var$q, _t);
        $53673690361d2798$var$assignDeep(s, {
            K: vt,
            Mt: {
                x: ot.w,
                y: ot.h
            },
            Rt: {
                x: et.w,
                y: et.h
            },
            sn: ut,
            Lt: $53673690361d2798$var$sanitizeScrollCoordinates(wt, et)
        });
        return {
            tn: ht,
            Qt: st,
            Zt: ct,
            nn: yt || ct,
            dn: bt
        };
    };
};
const $53673690361d2798$var$createStructureSetup = (t)=>{
    const [n, o, s] = $53673690361d2798$var$createStructureSetupElements(t);
    const e = {
        en: {
            t: 0,
            r: 0,
            b: 0,
            l: 0
        },
        an: false,
        ct: {
            [$53673690361d2798$var$$]: 0,
            [$53673690361d2798$var$C]: 0,
            [$53673690361d2798$var$O]: 0,
            [$53673690361d2798$var$w]: 0,
            [$53673690361d2798$var$y]: 0,
            [$53673690361d2798$var$S]: 0,
            [$53673690361d2798$var$m]: 0
        },
        Mt: {
            x: 0,
            y: 0
        },
        Rt: {
            x: 0,
            y: 0
        },
        K: {
            x: $53673690361d2798$var$I,
            y: $53673690361d2798$var$I
        },
        sn: {
            x: false,
            y: false
        },
        Lt: $53673690361d2798$var$getZeroScrollCoordinates()
    };
    const { ft: c, ht: r, tt: l, yt: i } = n;
    const { R: a, k: u } = $53673690361d2798$var$getEnvironment();
    const d = !a && (u.x || u.y);
    const _ = [
        $53673690361d2798$var$createTrinsicUpdateSegment(n),
        $53673690361d2798$var$createPaddingUpdateSegment(n, e),
        $53673690361d2798$var$createOverflowUpdateSegment(n, e)
    ];
    return [
        o,
        (t)=>{
            const n = {};
            const o = d;
            const s = i($53673690361d2798$var$G, true);
            const e = o && $53673690361d2798$var$getElementScroll(r);
            $53673690361d2798$var$each(_, (o)=>{
                $53673690361d2798$var$assignDeep(n, o(t, n) || {});
            });
            $53673690361d2798$var$scrollElementTo(r, e);
            !l && $53673690361d2798$var$scrollElementTo(c, 0);
            s();
            return n;
        },
        e,
        n,
        s
    ];
};
const $53673690361d2798$var$createSetups = (t, n, o, s)=>{
    const e = $53673690361d2798$var$createOptionCheck(n, {});
    const [c, r, l, i, a] = $53673690361d2798$var$createStructureSetup(t);
    const [u, d, _] = $53673690361d2798$var$createObserversSetup(i, l, e, (t)=>{
        update({}, t);
    });
    const [f, p, , v] = $53673690361d2798$var$createScrollbarsSetup(t, n, _, l, i, s);
    const updateHintsAreTruthy = (t)=>$53673690361d2798$var$keys(t).some((n)=>!!t[n]);
    const update = (t, s)=>{
        const { _n: e, At: c, zt: l, fn: i } = t;
        const a = e || {};
        const u = !!c;
        const f = {
            Et: $53673690361d2798$var$createOptionCheck(n, a, u),
            _n: a,
            At: u
        };
        if (i) {
            p(f);
            return false;
        }
        const v = s || d($53673690361d2798$var$assignDeep({}, f, {
            zt: l
        }));
        const h = r($53673690361d2798$var$assignDeep({}, f, {
            ln: _,
            Kt: v
        }));
        p($53673690361d2798$var$assignDeep({}, f, {
            Kt: v,
            Gt: h
        }));
        const g = updateHintsAreTruthy(v);
        const b = updateHintsAreTruthy(h);
        const w = g || b || !$53673690361d2798$var$isEmptyObject(a) || u;
        w && o(t, {
            Kt: v,
            Gt: h
        });
        return w;
    };
    return [
        ()=>{
            const { cn: t, ht: n, yt: o } = i;
            const s = o($53673690361d2798$var$G, true);
            const e = $53673690361d2798$var$getElementScroll(t);
            const r = [
                u(),
                c(),
                f()
            ];
            $53673690361d2798$var$scrollElementTo(n, e);
            s();
            return $53673690361d2798$var$bind($53673690361d2798$var$runEachAndClear, r);
        },
        update,
        ()=>({
                pn: _,
                vn: l
            }),
        {
            hn: i,
            gn: v
        },
        a
    ];
};
const $53673690361d2798$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { U: s } = $53673690361d2798$var$getEnvironment();
    const e = $53673690361d2798$var$isHTMLElement(t);
    const c = e ? t : t.target;
    const r = $53673690361d2798$var$getInstance(c);
    if (n && !r) {
        let r = false;
        const l = [];
        const i = {};
        const validateOptions = (t)=>{
            const n = $53673690361d2798$var$removeUndefinedProperties(t, true);
            const o = $53673690361d2798$var$getStaticPluginModuleInstance($53673690361d2798$var$At);
            return o ? o(n, true) : n;
        };
        const a = $53673690361d2798$var$assignDeep({}, s(), validateOptions(n));
        const [u, d, _] = $53673690361d2798$var$createEventListenerHub();
        const [f, p, v] = $53673690361d2798$var$createEventListenerHub(o);
        const triggerEvent = (t, n)=>{
            v(t, n);
            _(t, n);
        };
        const [h, g, b, w, y] = $53673690361d2798$var$createSetups(t, a, ({ _n: t, At: n }, { Kt: o, Gt: s })=>{
            const { _t: e, Ot: c, $t: r, Ct: l, xt: i, dt: a } = o;
            const { Qt: u, Zt: d, tn: _, nn: f } = s;
            triggerEvent("updated", [
                m,
                {
                    updateHints: {
                        sizeChanged: !!e,
                        directionChanged: !!c,
                        heightIntrinsicChanged: !!r,
                        overflowEdgeChanged: !!u,
                        overflowAmountChanged: !!d,
                        overflowStyleChanged: !!_,
                        scrollCoordinatesChanged: !!f,
                        contentMutation: !!l,
                        hostMutation: !!i,
                        appear: !!a
                    },
                    changedOptions: t || {},
                    force: !!n
                }
            ]);
        }, (t)=>triggerEvent("scroll", [
                m,
                t
            ]));
        const destroy = (t)=>{
            $53673690361d2798$var$removeInstance(c);
            $53673690361d2798$var$runEachAndClear(l);
            r = true;
            triggerEvent("destroyed", [
                m,
                t
            ]);
            d();
            p();
        };
        const m = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $53673690361d2798$var$getOptionsDiff(a, $53673690361d2798$var$assignDeep(o, validateOptions(t)));
                    if (!$53673690361d2798$var$isEmptyObject(e)) {
                        $53673690361d2798$var$assignDeep(a, e);
                        g({
                            _n: e
                        });
                    }
                }
                return $53673690361d2798$var$assignDeep({}, a);
            },
            on: f,
            off: (t, n)=>{
                t && n && p(t, n);
            },
            state () {
                const { pn: t, vn: n } = b();
                const { et: o } = t;
                const { Mt: s, Rt: e, K: c, sn: l, en: i, an: a, Lt: u } = n;
                return $53673690361d2798$var$assignDeep({}, {
                    overflowEdge: s,
                    overflowAmount: e,
                    overflowStyle: c,
                    hasOverflow: l,
                    scrollCoordinates: {
                        start: u.I,
                        end: u.T
                    },
                    padding: i,
                    paddingAbsolute: a,
                    directionRTL: o,
                    destroyed: r
                });
            },
            elements () {
                const { ft: t, vt: n, en: o, nt: s, gt: e, ht: c, Jt: r } = w.hn;
                const { qt: l, Yt: i } = w.gn;
                const translateScrollbarStructure = (t)=>{
                    const { kt: n, Dt: o, Vt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Ft: n, Bt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $53673690361d2798$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            g({
                                fn: true
                            });
                            return t;
                        }
                    });
                };
                return $53673690361d2798$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(l),
                    scrollbarVertical: translateScrollbarsSetupElement(i)
                });
            },
            update: (t)=>g({
                    At: t,
                    zt: true
                }),
            destroy: $53673690361d2798$var$bind(destroy, false),
            plugin: (t)=>i[$53673690361d2798$var$keys(t)[0]]
        };
        $53673690361d2798$var$push(l, [
            y
        ]);
        $53673690361d2798$var$addInstance(c, m);
        $53673690361d2798$var$registerPluginModuleInstances($53673690361d2798$var$Et, $53673690361d2798$export$d08ab3fe303a3356, [
            m,
            u,
            i
        ]);
        if ($53673690361d2798$var$cancelInitialization(w.hn.Tt, !e && t.cancel)) {
            destroy(true);
            return m;
        }
        $53673690361d2798$var$push(l, h());
        triggerEvent("initialized", [
            m
        ]);
        m.update(true);
        return m;
    }
    return r;
};
$53673690361d2798$export$d08ab3fe303a3356.plugin = (t)=>{
    const n = $53673690361d2798$var$isArray(t);
    const o = n ? t : [
        t
    ];
    const s = o.map((t)=>$53673690361d2798$var$registerPluginModuleInstances(t, $53673690361d2798$export$d08ab3fe303a3356)[0]);
    $53673690361d2798$var$addPlugins(o);
    return n ? s : s[0];
};
$53673690361d2798$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $53673690361d2798$var$isFunction(n) && n();
    return $53673690361d2798$var$isPlainObject(o) && !!$53673690361d2798$var$getInstance(o.target);
};
$53673690361d2798$export$d08ab3fe303a3356.env = ()=>{
    const { D: t, k: n, R: o, M: s, j: e, q: c, L: r, P: l, U: i, N: a } = $53673690361d2798$var$getEnvironment();
    return $53673690361d2798$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        scrollTimeline: s,
        staticDefaultInitialization: e,
        staticDefaultOptions: c,
        getDefaultInitialization: r,
        setDefaultInitialization: l,
        getDefaultOptions: i,
        setDefaultOptions: a
    });
};


if (document.querySelector("[data-scroll]")) {
    const scrollElArr = document.querySelectorAll("[data-scroll]");
    scrollElArr.forEach((scrollEl)=>{
        const osInstance = (0, $53673690361d2798$export$d08ab3fe303a3356)(scrollEl, {});
    });
}


var $96e5aefdb3c7e519$var$t = function() {
    return $96e5aefdb3c7e519$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $96e5aefdb3c7e519$var$t.apply(this, arguments);
}, $96e5aefdb3c7e519$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $96e5aefdb3c7e519$var$t($96e5aefdb3c7e519$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


/**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ /**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ const $e981795122c4c4b4$var$counts = Array.from(document.getElementsByClassName("count-up"));
if ($e981795122c4c4b4$var$counts) {
    const defaultOptions = {
        separator: "",
        enableScrollSpy: true,
        scrollSpyRunOnce: true
    };
    let idNumber = 1;
    $e981795122c4c4b4$var$counts.forEach((count)=>{
        const id = `count-up-${idNumber}`, value = parseFloat(count.innerHTML);
        let optionsFromDataAttr = {
            ...count.dataset
        };
        for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === "") optionsFromDataAttr[key] = true;
        count.id = id;
        new (0, $96e5aefdb3c7e519$export$1567cc001e3d0c1d)(id, value, Object.assign(Object.assign({}, defaultOptions), optionsFromDataAttr));
        idNumber++;
    });
}


window.jsScrollToEl = function jsScrollToEl(targetID) {
    let config = targetID.split("|");
    let duration = +config[1] && (config[1], true) ? +config[1] : 800;
    let paddingTop = +config[2] && (config[2], true) ? +config[2] : 0;
    let target = config[0];
    let targetElement = document.querySelector(target);
    if (targetElement) {
        let targetOffsetTop = targetElement.offsetTop - paddingTop;
        window.scrollTo({
            top: targetOffsetTop,
            behavior: "smooth"
        });
        return false;
    }
};
/* Filter Search Accordions */ const $42a766e449d15d73$var$searchAccs = document.querySelectorAll(".filter-accordion");
const $42a766e449d15d73$var$searchAccsTitles = document.querySelectorAll(".filter-accordion__title");
function $42a766e449d15d73$var$setInitialState() {
    const windowWidth = window.innerWidth;
    $42a766e449d15d73$var$searchAccs.forEach((acc, index)=>{
        if (windowWidth <= 768) acc.classList.toggle("active", index === 0);
        else acc.classList.add("active");
    });
}
$42a766e449d15d73$var$setInitialState();
window.addEventListener("resize", $42a766e449d15d73$var$setInitialState);
$42a766e449d15d73$var$searchAccsTitles.forEach((accTitle)=>{
    accTitle.addEventListener("click", function(e) {
        e.preventDefault();
        this.closest(".filter-accordion").classList.toggle("active");
    });
});
/* HOVERS LINKS */ document.addEventListener("DOMContentLoaded", function() {
    const shareElements = document.querySelectorAll(".first-section__left-share");
    if (shareElements.length) shareElements.forEach((item)=>{
        item.addEventListener("click", function(event) {
            event.stopPropagation();
            item.classList.toggle("active");
        });
    // document.addEventListener('click', function(event) {
    //   if (!item.contains(event.target)) {
    //     item.classList.remove('active');
    //   }
    // });
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const shareElements = document.querySelectorAll(".similar-section__item-share");
    if (shareElements.length) {
        shareElements.forEach((item)=>{
            item.addEventListener("click", function(event) {
                event.stopPropagation();
                item.classList.toggle("active");
            });
        });
        document.addEventListener("click", function(event) {
            shareElements.forEach((item)=>{
                if (!item.contains(event.target)) item.classList.remove("active");
            });
        });
    }
});
document.addEventListener("DOMContentLoaded", ()=>{
    const shareWrappers = document.querySelectorAll(".share-wrapper");
    const shareButtons = document.querySelectorAll(".share");
    console.log(shareButtons);
    shareButtons.forEach((button, i)=>{
        console.log(button);
        button.addEventListener("click", (event)=>{
            event.stopPropagation();
            shareWrappers[i].classList.toggle("active");
        });
        document.addEventListener("click", (event)=>{
            if (!shareWrappers[i].contains(event.target)) shareWrappers[i].classList.remove("active");
        });
    });
});
initChoices("[data-choices]");
document.querySelectorAll("[data-anchor]").forEach((anchor)=>{
    console.log(anchor);
    anchor.addEventListener("click", function(e) {
        e.preventDefault();
        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
});
window.globalLoaderStart = function globalLoaderStart() {
    const loader = document.getElementById("global-loader");
    loader.style.opacity = "1";
    loader.style.pointerEvents = "auto";
    scrollLock.disablePageScroll();
};
window.globalLoaderEnd = function globalLoaderEnd() {
    const loader = document.getElementById("global-loader");
    loader.style.opacity = "0";
    loader.style.pointerEvents = "none";
    scrollLock.enablePageScroll();
};
window.workExperienceInit = function workExperienceInit1() {
    const workExperienceElements = document.querySelectorAll('[id^="section-work-experience-"]');
    workExperienceElements.forEach((el)=>{
        if (!el.classList.contains("is-init")) {
            el.classList.add("is-init");
            const checkbox = el.querySelector('[id^="is_present_"]');
            const endDate = el.querySelector('[name="end_date[]"]');
            if (checkbox && endDate) {
                const updateEndDateVisibility = ()=>{
                    endDate.style.display = checkbox.checked ? "none" : "";
                };
                updateEndDateVisibility();
                checkbox.addEventListener("change", updateEndDateVisibility);
            }
        }
    });
};
workExperienceInit();

})();
//# sourceMappingURL=scripts.86d8fbaa.js.map
